// GENERATED FILE — DO NOT EDIT BY HAND
// Generator: tools/generate-a4.mjs; metadata schema 1.0.0
// Source: biome-data.js.liquid; SHA-256: 7bbc0d38f2750b96a2015e74429dda0d58dc811476d2201267a68a2a44590112
// Source: data/a4-edition-rules.json; SHA-256: 41b8540fc667955897d3683ef155c13453d06101df07bc885b5fcb101a908011
// A4 Production: original source order minus the four owner-authoritative habitat removals.
// All retained selectable entries and source fields are preserved; no animal/context classifications are inferred.

window.INITIAL_DATA = [
  {
    "id": "alpine",
    "name": "Alpine Meadow",
    "location": "Swiss Alps, Switzerland",
    "description": "Found high up in the mountains just below the snowy peaks. It's so cold and the air is so thin that trees cannot grow here. Animals must navigate steep, dangerous cliffs and survive long periods with very little food.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/alpine-hero.webp?v=7537509518427798995",
    "color": "bg-emerald-500",
    "facts": [
      {
        "title": "Above the Tree Line",
        "content": "It's so high up that it's too cold and the soil is too thin for trees to grow! It's an open, grassy world touching the sky.",
        "icon": "tree-pine"
      },
      {
        "title": "Thin Air",
        "content": "The air way up here has less oxygen, which means animals have to grow bigger lungs or special blood to run and jump without getting tired out.",
        "icon": "wind"
      },
      {
        "title": "Blanket of Flowers",
        "content": "During the super-short summer, the meadows burst into dazzling colors with special wildflowers that hug the ground to hide from frosty winds.",
        "icon": "flower2"
      },
      {
        "title": "Sunscreen Needed",
        "content": "Because the air is thin, the sun's UV rays are extra strong. Animals and even plants have built-in 'sunscreen' or thick fuzzy coats to protect them.",
        "icon": "sun"
      }
    ],
    "animals": [
      {
        "id": "alpine-blue-butterfly",
        "name": "Alpine Blue Butterfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-blue-butterfly.webp?v=2377348071528177247",
        "evolutionaryTrait": "Tiny hairs on their bodies trap heat like a fuzzy sweater!",
        "funFact": "They love to drink mineral water from damp mountain mud!",
        "ecosystemRole": "High altitude pollinator.",
        "diet": "Nectar from alpine flowers.",
        "size": "Small wingspan of 1 inch.",
        "sound": "Silent."
      },
      {
        "id": "alpine-chamois",
        "name": "Alpine Chamois",
        "image": "//cleverfoxplay.com/cdn/shop/files/jumping-alpine-chamois-2.webp?v=13793632306084605359",
        "evolutionaryTrait": "Special hooves that act like hiking boots for vertical cliffs.",
        "funFact": "They can jump 6 feet high in a single bound!",
        "ecosystemRole": "Prey for large carnivores.",
        "diet": "Alpine grasses and herbs.",
        "size": "Medium goat size.",
        "sound": "A sneeze-like alarm call."
      },
      {
        "id": "alpine-chough",
        "name": "Alpine Chough",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-chough.webp?v=1009730631414970831",
        "evolutionaryTrait": "Nests higher than any other bird on the planet!",
        "funFact": "They are expert acrobats when flying in mountain winds.",
        "ecosystemRole": "Scavenger and insect controller.",
        "diet": "Insects and human scraps.",
        "size": "Size of a crow.",
        "sound": "A ringing 'chee-ow'."
      },
      {
        "id": "alpine-ibex",
        "name": "Alpine Ibex",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-ibex.webp?v=18001950471416834796",
        "evolutionaryTrait": "Rubbery hooves that work like suction cups on rocks.",
        "funFact": "They love licking salt off the sides of mountain dams!",
        "ecosystemRole": "Herbivore grazer.",
        "diet": "Grasses, moss, and leaves.",
        "size": "Large wild goat.",
        "sound": "Short whistles and snorts."
      },
      {
        "id": "alpine-marmot",
        "name": "Alpine Marmot",
        "image": "//cleverfoxplay.com/cdn/shop/files/yellow-bellied-marmot-2.webp?v=7979142450219821013",
        "evolutionaryTrait": "Fat bellies help them sleep through the whole winter.",
        "funFact": "They whistle like birds to warn their friends of danger!",
        "ecosystemRole": "Prey for eagles and foxes.",
        "diet": "Grasses and herbs.",
        "size": "Size of a large housecat.",
        "sound": "A loud alarm whistle."
      },
      {
        "id": "alpine-salamander",
        "name": "Alpine Salamander",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-salamander.webp?v=9348514039846390806",
        "evolutionaryTrait": "Only salamander that doesn't need to lay eggs in water.",
        "funFact": "They are jet black to soak up every drop of sun heat!",
        "ecosystemRole": "Insect predator.",
        "diet": "Spiders and insects.",
        "size": "About 6 inches long.",
        "sound": "Silent."
      },
      {
        "id": "alpine-shrew",
        "name": "Alpine Shrew",
        "image": "//cleverfoxplay.com/cdn/shop/files/european-mole-1.webp?v=12516225040464007651",
        "evolutionaryTrait": "A tiny battery that never stops—it has to eat all day!",
        "funFact": "They are world-class tunnel diggers in the mountain soil.",
        "ecosystemRole": "Insect population controller.",
        "diet": "Insects and earthworms.",
        "size": "Tiny, 2-3 inches.",
        "sound": "High-pitched squeaks."
      },
      {
        "id": "alpine-swift",
        "name": "Alpine Swift",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-swift.webp?v=3597467486084066517",
        "evolutionaryTrait": "Can stay flying for six months without ever landing!",
        "funFact": "They eat, sleep, and even dream while gliding in the air.",
        "ecosystemRole": "Aerial insect predator.",
        "diet": "Airborne insects.",
        "size": "Large swift, 8-inch wingspan.",
        "sound": "Loud, trilling chatter."
      },
      {
        "id": "apollo-butterfly",
        "name": "Apollo Butterfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-apollo-butterfly.webp?v=899915360327308343",
        "evolutionaryTrait": "Red eye spots on their wings trick birds into being scared.",
        "funFact": "They are very slow flyers but very hard to catch!",
        "ecosystemRole": "Alpine flower pollinator.",
        "diet": "Nectar.",
        "size": "Large, 3-inch wingspan.",
        "sound": "Silent."
      },
      {
        "id": "bearded-vulture",
        "name": "Bearded Vulture",
        "image": "//cleverfoxplay.com/cdn/shop/files/bearded-vulture-3.webp?v=3683534058867598575",
        "evolutionaryTrait": "The only bird that eats mostly bones—what a tummy!",
        "funFact": "They dye their feathers orange by bathing in rusty mud.",
        "ecosystemRole": "Bone scavenger, cleaning the ecosystem.",
        "diet": "Bones from dead animals.",
        "size": "Massive 9-foot wingspan.",
        "sound": "Quiet whistles."
      },
      {
        "id": "black-grouse",
        "name": "Black Grouse",
        "image": "//cleverfoxplay.com/cdn/shop/files/black-grouse-1.webp?v=1903233750917060656",
        "evolutionaryTrait": "Lyre-shaped tails that look like fancy musical instruments.",
        "funFact": "They gathered in groups called 'leks' to dance together.",
        "ecosystemRole": "Seed and insect consumer.",
        "diet": "Seeds, berries, and insects.",
        "size": "Size of a small chicken.",
        "sound": "A bubbling coo."
      },
      {
        "id": "brown-bear",
        "name": "Brown Bear",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-brown-bear-2.webp?v=1851135758782873786",
        "evolutionaryTrait": "A massive hump of muscle for digging and heavy lifting.",
        "funFact": "Their sense of smell is 7 times stronger than a bloodhound's!",
        "ecosystemRole": "Apex predator and seed disperser.",
        "diet": "Omnivore: berries, roots, and meat.",
        "size": "Massive, up to 1000 lbs.",
        "sound": "Deep growls and roars."
      },
      {
        "id": "brown-trout",
        "name": "Brown Trout",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-trout.webp?v=8625816511504828777",
        "evolutionaryTrait": "Powerful tails for swimming up fast mountain streams.",
        "funFact": "They have teeth on the roof of their mouths!",
        "ecosystemRole": "Aquatic predator.",
        "diet": "Insects and smaller fish.",
        "size": "Medium freshwater fish.",
        "sound": "Splashes."
      },
      {
        "id": "bumblebee",
        "name": "Bumblebee",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-bumblebee-2.webp?v=3930689554676423265",
        "evolutionaryTrait": "They can shiver their muscles to stay warm in the cold.",
        "funFact": "Bees see colors that humans didn't even know existed!",
        "ecosystemRole": "Crucial alpine pollinator.",
        "diet": "Nectar and pollen.",
        "size": "Small flying insect.",
        "sound": "A deep buzz."
      },
      {
        "id": "ermine",
        "name": "Ermine",
        "image": "//cleverfoxplay.com/cdn/shop/files/ermine-summer-coat-1.webp?v=13974875610945952337",
        "evolutionaryTrait": "Change their fur from brown to white for winter stealth.",
        "funFact": "They are fearless hunters, taking on prey larger than them!",
        "ecosystemRole": "Small rodent controller.",
        "diet": "Voles, mice, and rabbits.",
        "size": "Small as a squirrel.",
        "sound": "Trills and squeaks."
      },
      {
        "id": "eurasian-lynx",
        "name": "Eurasian Lynx",
        "image": "//cleverfoxplay.com/cdn/shop/files/eurasian-lynx-5.webp?v=11181231758826328134",
        "evolutionaryTrait": "Huge, furry paws that act like natural snowshoes.",
        "funFact": "The black tufts on their ears help them hear even better!",
        "ecosystemRole": "Apex predator controlling deer.",
        "diet": "Chamois and roe deer.",
        "size": "Medium-sized cat.",
        "sound": "Low growls and meows."
      },
      {
        "id": "field-mouse",
        "name": "Field Mouse",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-field-mouse-4.webp?v=11988815113952838034",
        "evolutionaryTrait": "Super sensitive whiskers for navigating in the dark.",
        "funFact": "They can jump high in the air to avoid predators!",
        "ecosystemRole": "Prey for numerous predators.",
        "diet": "Seeds and roots.",
        "size": "Tiny.",
        "sound": "High squeaks."
      },
      {
        "id": "fire-salamander",
        "name": "Fire Salamander",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-fire-salamander.webp?v=8033240397501074470",
        "evolutionaryTrait": "Bright yellow patterns that warn predators: 'Stay away!'",
        "funFact": "They can live to be over 50 years old!",
        "ecosystemRole": "Invertebrate predator.",
        "diet": "Slugs, worms, and insects.",
        "size": "Up to 8 inches.",
        "sound": "Silent."
      },
      {
        "id": "golden-eagle",
        "name": "Golden Eagle",
        "image": "//cleverfoxplay.com/cdn/shop/files/golden-eagle-2.webp?v=17986508475262688894",
        "evolutionaryTrait": "Telescope eyes that see a rabbit from miles away.",
        "funFact": "They are the fastest raptors in the mountains.",
        "ecosystemRole": "Apex avian predator.",
        "diet": "Marmots, hares, and foxes.",
        "size": "Huge wingspan over 7 feet.",
        "sound": "A sharp 'kya-kya'."
      },
      {
        "id": "grasshopper",
        "name": "Grasshopper",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-grasshopper-2.webp?v=9874117469608715459",
        "evolutionaryTrait": "Powerful hind legs that work like catapults.",
        "funFact": "They have ears on their bellies!",
        "ecosystemRole": "Primary consumer.",
        "diet": "Grasses.",
        "size": "Small insect.",
        "sound": "A chirping buzz."
      },
      {
        "id": "hazel-grouse",
        "name": "Hazel Grouse",
        "image": "//cleverfoxplay.com/cdn/shop/files/hazel-grouse.webp?v=12155726991318945133",
        "evolutionaryTrait": "Expert camoflague that blends perfectly with forest floor.",
        "funFact": "They love to take dust baths to keep their feathers clean.",
        "ecosystemRole": "Forest floor grazer.",
        "diet": "Berries and shoots.",
        "size": "Size of a pigeon.",
        "sound": "A high-pitched whistle."
      },
      {
        "id": "ladybug",
        "name": "Ladybug",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-ladybug-1.webp?v=9434589399275337710",
        "evolutionaryTrait": "A hard shell that protects their delicate wings.",
        "funFact": "In winter, thousands of ladybugs snuggle together to stay warm!",
        "ecosystemRole": "Aphid predator.",
        "diet": "Aphids and tiny insects.",
        "size": "Tiny insect.",
        "sound": "Silent."
      },
      {
        "id": "leaf-beetle",
        "name": "Leaf Beetle",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-leaf-beetle.webp?v=9889742341155384925",
        "evolutionaryTrait": "Shiny colors that make them look like bits of jewelry.",
        "funFact": "Some can walk on water using special air bubbles on their feet.",
        "ecosystemRole": "Plant consumer.",
        "diet": "Alpine leaves.",
        "size": "Tiny insect.",
        "sound": "Silent."
      },
      {
        "id": "longhorn-beetle",
        "name": "Longhorn Beetle",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-longhorn-beetle.webp?v=995375715496230469",
        "evolutionaryTrait": "Ultra-long antennas for feeling their way through wood.",
        "funFact": "Their antennas can be twice as long as their bodies!",
        "ecosystemRole": "Wood decomposer.",
        "diet": "Wood and pollen.",
        "size": "Medium insect.",
        "sound": "Soft clicking."
      },
      {
        "id": "mason-bee",
        "name": "Mason Bee",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-mason-bee-2.webp?v=10670166946154344691",
        "evolutionaryTrait": "Solitary builders that use mud to build tiny safe homes.",
        "funFact": "They are more effective at pollination than honeybees!",
        "ecosystemRole": "Efficient pollinator.",
        "diet": "Nectar and pollen.",
        "size": "Small flying insect.",
        "sound": "Soft buzz."
      },
      {
        "id": "mountain-hare",
        "name": "Mountain Hare",
        "image": "//cleverfoxplay.com/cdn/shop/files/mountain-hare-1.webp?v=9518237000865487464",
        "evolutionaryTrait": "Changes coat color to match the seasons just like erasable ink!",
        "funFact": "Their ears are shorter than a regular rabbit's to keep heat in.",
        "ecosystemRole": "Prey for major carnivores.",
        "diet": "Twigs and alpine plants.",
        "size": "Large rabbit.",
        "sound": "Thumping feet."
      },
      {
        "id": "newt",
        "name": "Newt",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-newt-2.webp?v=6563906800793119131",
        "evolutionaryTrait": "Can regrow their own legs and tails if they get hurt!",
        "funFact": "They start as babies with gills and grow lungs when they get older.",
        "ecosystemRole": "Aquatic and terrestrial predator.",
        "diet": "Insects and amphibian eggs.",
        "size": "Small amphibian.",
        "sound": "Silent."
      },
      {
        "id": "pine-marten",
        "name": "Pine Marten",
        "image": "//cleverfoxplay.com/cdn/shop/files/pine-marten-2.webp?v=10060240443304379009",
        "evolutionaryTrait": "Super sharp claws for sprinting up tree trunks at high speed.",
        "funFact": "They are related to weasels and love to eat berries and nuts.",
        "ecosystemRole": "Arboreal predator.",
        "diet": "Squirrels and birds.",
        "size": "Size of a small cat.",
        "sound": "Hisses and chatters."
      },
      {
        "id": "pygmy-shrew",
        "name": "Pygmy Shrew",
        "image": "//cleverfoxplay.com/cdn/shop/files/pygmy-shrew.webp?v=3260687072149033631",
        "evolutionaryTrait": "Smallest mammal in Europe—can fit on a thumb!",
        "funFact": "They eat up to 125% of their body weight every single day.",
        "ecosystemRole": "Continuous insect controller.",
        "diet": "Spiders and insects.",
        "size": "Tiny, 2 inches long.",
        "sound": "Faint squeaks."
      },
      {
        "id": "red-crossbill",
        "name": "Red Crossbill",
        "image": "//cleverfoxplay.com/cdn/shop/files/red-crossbill.webp?v=17975963977872790831",
        "evolutionaryTrait": "A beak like a pair of scissors for opening pine cones.",
        "funFact": "They can be right-beaked or left-beaked, just like us!",
        "ecosystemRole": "Seed consumer.",
        "diet": "Conifer seeds.",
        "size": "Finch-sized.",
        "sound": "A sharp 'jip-jip'."
      },
      {
        "id": "red-fox",
        "name": "Red Fox",
        "image": "//cleverfoxplay.com/cdn/shop/files/red-fox-1.webp?v=12985158314388215601",
        "evolutionaryTrait": "A bushy tail that works as a cozy blanket when it's cold.",
        "funFact": "They use the Earth's magnetic field to help them hunt!",
        "ecosystemRole": "Versatile mesopredator.",
        "diet": "Mice, birds, and berries.",
        "size": "Medium dog.",
        "sound": "Yips, barks, and screams."
      },
      {
        "id": "rock-ptarmigan",
        "name": "Rock Ptarmigan",
        "image": "//cleverfoxplay.com/cdn/shop/files/rock-ptarmigan.webp?v=13893110173556858302",
        "evolutionaryTrait": "Feathered feet that work like warm winter boots in the snow.",
        "funFact": "They turn completely white to match the mountain peaks.",
        "ecosystemRole": "Prey for falcons and foxes.",
        "diet": "Buds and berries.",
        "size": "Medium ground bird.",
        "sound": "A guttural, croaking sound."
      },
      {
        "id": "rock-snail",
        "name": "Rock Snail",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-rock-snail.webp?v=6784400412985430952",
        "evolutionaryTrait": "Extra strong shell to protect from sliding mountain pebbles.",
        "funFact": "They can hibernate for years if the weather gets too cold!",
        "ecosystemRole": "Detritivore.",
        "diet": "Algae and decaying plants.",
        "size": "Tiny shell-bearer.",
        "sound": "Silent."
      },
      {
        "id": "roe-deer-fawn",
        "name": "Roe Deer Fawn",
        "image": "//cleverfoxplay.com/cdn/shop/files/roe-deer-fawn-2.webp?v=10878296412517122437",
        "evolutionaryTrait": "White spots on their back look like dappled sunlight in the grass.",
        "funFact": "They can smell danger from a long, long way away.",
        "ecosystemRole": "Undergrowth grazer.",
        "diet": "Tender leaves and shoots.",
        "size": "Small deer.",
        "sound": "High-pitched bleating."
      },
      {
        "id": "snow-vole",
        "name": "Snow Vole",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-snow-vole-2.webp?v=7002691909036613439",
        "evolutionaryTrait": "High-altitude experts that live in rock cracks near summits.",
        "funFact": "They have extra long whiskers to feel around in dark rock tunnels.",
        "ecosystemRole": "Important prey for foxes and owls.",
        "diet": "Roots and grass.",
        "size": "Small rodent.",
        "sound": "Squeaks."
      },
      {
        "id": "st-bernard-dog",
        "name": "St. Bernard Dog",
        "image": "//cleverfoxplay.com/cdn/shop/files/rescue-hero-st-bernard-1.webp?v=6660501196865161638",
        "evolutionaryTrait": "Immense size and strength for navigating deep mountain snow.",
        "funFact": "They were originally bred by monks to help find lost travelers!",
        "ecosystemRole": "Human companion and rescue.",
        "diet": "Omnivore dog food.",
        "size": "Massive dog.",
        "sound": "Deep, thunderous bark."
      },
      {
        "id": "tawny-owl",
        "name": "Tawny Owl",
        "image": "//cleverfoxplay.com/cdn/shop/files/tawny-owl.webp?v=5509497511109254451",
        "evolutionaryTrait": "Feathers that are super quiet so they fly like silent ghosts.",
        "funFact": "They can turn their heads almost all the way around!",
        "ecosystemRole": "Nocturnal rodent controller.",
        "diet": "Voles and mice.",
        "size": "Medium-sized owl.",
        "sound": "A classic 'hoo-hoo'."
      },
      {
        "id": "valais-blacknose-sheep",
        "name": "Valais Blacknose Sheep",
        "image": "//cleverfoxplay.com/cdn/shop/files/valais-blacknose-sheep-2.webp?v=2153671536580904886",
        "evolutionaryTrait": "Thick, woolly coats for surviving the freezing mountain air.",
        "funFact": "People often say they are the 'world's cutest sheep'!",
        "ecosystemRole": "Alpine meadow grazer.",
        "diet": "Grass and herbs.",
        "size": "Medium sheep.",
        "sound": "A gentle baa."
      },
      {
        "id": "wallcreeper",
        "name": "Wallcreeper",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-tichodroma.webp?v=17324083092375416123",
        "evolutionaryTrait": "Huge crimson wings that look like butterflies when they fly.",
        "funFact": "They spend their lives hopping up and down steep cliff faces.",
        "ecosystemRole": "Cliff-dwelling insectivore.",
        "diet": "Spiders and insects.",
        "size": "Small bird.",
        "sound": "A short, rising whistle."
      },
      {
        "id": "wood-mouse",
        "name": "Wood Mouse",
        "image": "//cleverfoxplay.com/cdn/shop/files/alpine-wood-mouse.webp?v=15625255709678256886",
        "evolutionaryTrait": "Enormous ears and eyes for spotting owls in the dark.",
        "funFact": "They collect acorns and hide them in secret burrows!",
        "ecosystemRole": "Prey base.",
        "diet": "Seeds and berries.",
        "size": "Tiny rodent.",
        "sound": "Soft squeaks."
      },
      {
        "id": "yellow-spotted-ringlet",
        "name": "Yellow-spotted Ringlet",
        "image": "//cleverfoxplay.com/cdn/shop/files/mountain-ringlet-butterfly.webp?v=11056459027306313951",
        "evolutionaryTrait": "Dark wings help them absorb heat from the weak mountain sun.",
        "funFact": "They only live in the very highest parts of the mountains!",
        "ecosystemRole": "Pollinator.",
        "diet": "Nectar.",
        "size": "Small butterfly.",
        "sound": "Silent."
      }
    ]
  },
  {
    "id": "arctic",
    "name": "Arctic",
    "location": "Svalbard, Norway",
    "description": "A frozen wonderland at the top of the world. It spends half the year in total daylight and half the year in total darkness. Animals here need serious insulation (like blubber) and often turn completely white to camouflage in the snow.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/arctic-svalbard-hero.webp?v=8028473422017131582",
    "color": "bg-blue-400",
    "facts": [
      {
        "title": "Ice as Land",
        "content": "Instead of dirt or rocks, the ground here is actually a frozen ocean! Animals like polar bears use the sea ice as a giant platform to walk, hunt, and rest on.",
        "icon": "snowflake"
      },
      {
        "title": "Midnight Sun",
        "content": "During the summer, the sun never sets—it just goes in circles in the sky! It stays bright outside even in the middle of the night.",
        "icon": "sun"
      },
      {
        "title": "Built-in Winter Coats",
        "content": "To stay warm in freezing winds, animals have super thick fur or a thick layer of fat called 'blubber' right underneath their skin.",
        "icon": "shield"
      },
      {
        "title": "Snow Camouflage",
        "content": "Many Arctic residents turn completely white in the winter. This magical trick helps them become invisible in the snow to hide or hunt!",
        "icon": "eye"
      }
    ],
    "animals": [
      {
        "id": "arctic-char",
        "name": "Arctic Char",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-arctic-char.webp?v=13905440843479035119",
        "evolutionaryTrait": "Special blood that doesn't freeze even in icy water.",
        "funFact": "They can survive under frozen lakes for months!",
        "ecosystemRole": "Key freshwater prey.",
        "diet": "Insects and smaller fish.",
        "size": "Medium fish.",
        "sound": "Splashing in water."
      },
      {
        "id": "arctic-fox",
        "name": "Arctic Fox",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-arctic-fox-pouncing-in-snow.webp?v=15669553940178525582",
        "evolutionaryTrait": "A thick, bushy tail they wrap around themselves like a cozy sleeping bag.",
        "funFact": "Their fur changes from brown in summer to pure white in winter!",
        "ecosystemRole": "Scavenger and mesopredator.",
        "diet": "Lemmings and seal scraps.",
        "size": "Small dog size.",
        "sound": "High-pitched barks and yips."
      },
      {
        "id": "arctic-hare",
        "name": "Arctic Hare",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-arctic-hare-2.webp?v=9815001061845853819",
        "evolutionaryTrait": "Extra large furry feet acting like snowshoes to run on top of deep snow.",
        "funFact": "They can run up to 40 miles per hour to outrun predators!",
        "ecosystemRole": "Primary prey for wolves and foxes.",
        "diet": "Woody plants and mosses.",
        "size": "Large rabbit.",
        "sound": "Usually silent, thumping feet."
      },
      {
        "id": "arctic-reindeer",
        "name": "Arctic Reindeer",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-svalbard-reindeer-1.webp?v=3566645923510836231",
        "evolutionaryTrait": "Their snouts warm up freezing air before it even reaches their lungs.",
        "funFact": "Their eyes change color from gold in summer to deep blue in winter!",
        "ecosystemRole": "Tundra grazer.",
        "diet": "Lichen and sedges.",
        "size": "Large deer species.",
        "sound": "Grunts and snorts."
      },
      {
        "id": "arctic-stoat",
        "name": "Arctic Stoat",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-arctic-stoat-ermine.webp?v=5648787622283719811",
        "evolutionaryTrait": "A long, slinky shape that lets them chase mice right into narrow burrows.",
        "funFact": "They are perfectly white in winter except for a black tip on their tail!",
        "ecosystemRole": "Hyperactive small predator.",
        "diet": "Lemmings and voles.",
        "size": "Small, slender weasel.",
        "sound": "Chatters and hisses."
      },
      {
        "id": "arctic-tern",
        "name": "Arctic Tern",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-arctic-tern-flying.webp?v=2084477281596160559",
        "evolutionaryTrait": "Wings perfectly designed for gliding massive distances over oceans without getting tired.",
        "funFact": "They fly all the way to Antarctica and back every single year!",
        "ecosystemRole": "Marine predator.",
        "diet": "Small fish and crustaceans.",
        "size": "Small seabird.",
        "sound": "A sharp, harsh 'kee-kee'."
      },
      {
        "id": "arctic-wolf",
        "name": "Arctic Wolf",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-arctic-wolf-pup.webp?v=17943203087570026937",
        "evolutionaryTrait": "Shorter ears and smaller noses than other wolves so they don't get frostbite.",
        "funFact": "They can travel up to 30 miles in a single day looking for food!",
        "ecosystemRole": "Apex terrestrial predator.",
        "diet": "Muskoxen and arctic hares.",
        "size": "Large dog.",
        "sound": "Long, echoing howls."
      },
      {
        "id": "atlantic-puffin",
        "name": "Atlantic Puffin",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-atlantic-puffin-3.webp?v=10070146702628152933",
        "evolutionaryTrait": "A special spiky tongue that helps them hold lots of slippery fish in their mouth.",
        "funFact": "Their colorful beak fades to dull gray during the winter!",
        "ecosystemRole": "Marine fish predator.",
        "diet": "Sand eels and herring.",
        "size": "Small seabird.",
        "sound": "A low purring or grunting."
      },
      {
        "id": "bearded-seal",
        "name": "Bearded Seal",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-bearded-seal-1.webp?v=4891556601530276501",
        "evolutionaryTrait": "Super sensitive whiskers to feel for clams hidden deep in dark, muddy sea floors.",
        "funFact": "Males sing loud underwater songs that sort of sound like aliens space ships!",
        "ecosystemRole": "Benthic forager.",
        "diet": "Clams, crabs, and fish.",
        "size": "Large seal, up to 800 lbs.",
        "sound": "Complex trills underwater."
      },
      {
        "id": "beluga-whale",
        "name": "Beluga Whale",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-beluga.webp?v=12257329434556719802",
        "evolutionaryTrait": "No back fin so they can swim easily right underneath thick sea ice without getting stuck.",
        "funFact": "They are nicknamed the 'canaries of the sea' because they chirp and squeak constantly!",
        "ecosystemRole": "Mid-level marine predator.",
        "diet": "Fish and squid.",
        "size": "Medium whale, 15 feet.",
        "sound": "Chirps, clicks, and whistles."
      },
      {
        "id": "black-legged-kittiwake",
        "name": "Black-legged Kittiwake",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-black-legged-kittiwake.webp?v=4827881954554711087",
        "evolutionaryTrait": "They build super tough nests out of seaweed right on sheer, dizzying vertical cliffs.",
        "funFact": "They get their name from the funny 'kitti-waak' sound they make when they call out!",
        "ecosystemRole": "Surface-feeding seabird.",
        "diet": "Small fish.",
        "size": "Medium gull.",
        "sound": "A nasal 'kitti-wake'."
      },
      {
        "id": "bowhead-whale",
        "name": "Bowhead Whale",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-graceful-bowhead-whale-calf.webp?v=11173761549743368182",
        "evolutionaryTrait": "A giant, rock-hard skull they use as a battering ram to smash through heavy ice to breathe.",
        "funFact": "Some of them can live to be over 200 years old!",
        "ecosystemRole": "Filter feeder.",
        "diet": "Zooplankton and krill.",
        "size": "Massive whale, up to 60 feet.",
        "sound": "Low-frequency calls and songs."
      },
      {
        "id": "brynnichs-guillemot",
        "name": "Brünnich’s Guillemot",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-the-thick-billed-murre-or-bru-nnich-s-guillemot.webp?v=12639609887432404452",
        "evolutionaryTrait": "They 'fly' underwater like penguins by fiercely flapping their short, strong wings.",
        "funFact": "Baby chicks leap off giant cliffs into the ocean before they know how to fly!",
        "ecosystemRole": "Diving seabird.",
        "diet": "Fish and crustaceans.",
        "size": "Medium seabird.",
        "sound": "A growling 'arrr'."
      },
      {
        "id": "collared-lemming",
        "name": "Collared Lemming",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-collared-lemming.webp?v=12392374924503187192",
        "evolutionaryTrait": "Grow special double claws in winter to shovel through hard ice and compacted snow.",
        "funFact": "They safely raise their babies in cozy grass nests hidden deep under the winter snow blanket!",
        "ecosystemRole": "Keystone prey species.",
        "diet": "Grasses and roots.",
        "size": "Small, plump rodent.",
        "sound": "High squeaks and chatters."
      },
      {
        "id": "glaucous-gull",
        "name": "Glaucous Gull",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-glaucous-gull.webp?v=9785130082796050758",
        "evolutionaryTrait": "A massive size that makes them the tough 'bosses' of all the other Arctic skies.",
        "funFact": "They are clever enough to follow polar bears way out on the ice hoping for leftover scraps!",
        "ecosystemRole": "Fearsome avian scavenger.",
        "diet": "Eggs, chicks, and carrion.",
        "size": "Large, aggressive gull.",
        "sound": "A loud, raucous 'kyow'."
      },
      {
        "id": "greenland-shark",
        "name": "Greenland Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-greenland-shark.webp?v=1938433821924022378",
        "evolutionaryTrait": "Moves in extreme, sluggish slow motion to save precious energy in freezing ocean depths.",
        "funFact": "They are the longest-living animals with backbones on Earth, reaching over 400 years old!",
        "ecosystemRole": "Deep-sea scavenger.",
        "diet": "Fish, seals, and carrion.",
        "size": "Huge shark, up to 20 feet.",
        "sound": "Silent."
      },
      {
        "id": "harp-seal",
        "name": "Harp Seal",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-harp-seal-pup.webp?v=1818265908128852129",
        "evolutionaryTrait": "Babies are born with yellow fur that quickly turns magically white to safely blend in on the ice.",
        "funFact": "Adults chew fresh air holes in sea ice so they can always pop up and take a quick breath!",
        "ecosystemRole": "Ice-dependent marine predator.",
        "diet": "Fish and crustaceans.",
        "size": "Medium seal.",
        "sound": "Barks and underwater trills."
      },
      {
        "id": "ivory-gull",
        "name": "Ivory Gull",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-ivory-gull.webp?v=8801943095246719067",
        "evolutionaryTrait": "Unlike other gulls, its legs are black to absorb every bit of heat while standing on freezing ice.",
        "funFact": "They are so incredibly white they practically vanish when flying against snowy clouds!",
        "ecosystemRole": "High-arctic scavenger.",
        "diet": "Fish and seal afterbirth.",
        "size": "Medium, pure white gull.",
        "sound": "A harsh, screeching call."
      },
      {
        "id": "king-eider-duck",
        "name": "King Eider Duck",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-king-eider-duck.webp?v=18059678191786601603",
        "evolutionaryTrait": "Males have a giant, crown-like bright orange shield right on their forehead.",
        "funFact": "They can dive straight down to the freezing ocean floor to grab starfish for lunch!",
        "ecosystemRole": "Diving seaduck.",
        "diet": "Mollusks and crustaceans.",
        "size": "Large duck.",
        "sound": "A soft, cooing 'hoo-hoo'."
      },
      {
        "id": "little-auk",
        "name": "Little Auk",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-little-auk-dovekie.webp?v=1279790426680331890",
        "evolutionaryTrait": "Tiny round bodies with wings that buzz super fast so they don't freeze in the chilly air.",
        "funFact": "They have a special pocket in their throat to store yummy little shrimp for later!",
        "ecosystemRole": "Plankton consumer.",
        "diet": "Copepods.",
        "size": "Tiny, starling-sized seabird.",
        "sound": "Chattering trills."
      },
      {
        "id": "narwhal",
        "name": "Narwhal",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-baby-narwhal-2.webp?v=16526862090397372049",
        "evolutionaryTrait": "A twisted, magical tooth that sticks out of their head exactly like a unicorn horn.",
        "funFact": "Their long horn is packed with millions of nerves that can actually 'taste' the ocean water!",
        "ecosystemRole": "Deep-sea predator.",
        "diet": "Greenland halibut and squid.",
        "size": "Medium whale.",
        "sound": "Clicks, squeaks, and whistles."
      },
      {
        "id": "orca",
        "name": "Orca",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-baby-orca.webp?v=1406447843555446332",
        "evolutionaryTrait": "Astonishing teamwork and giant brains that let them conquer any challenging ocean environment.",
        "funFact": "Orca families have their own unique languages and accents when they chatter underwater!",
        "ecosystemRole": "Apex marine predator.",
        "diet": "Seals, fish, and other whales.",
        "size": "Huge dolphin, up to 30 feet.",
        "sound": "Complex whistles and clicks."
      },
      {
        "id": "pink-footed-goose",
        "name": "Pink-footed Goose",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-pink-footed-goose-gosling-2.webp?v=8034811582548136411",
        "evolutionaryTrait": "Bright pink webbed feet that act as completely perfect paddles in icy, half-frozen waters.",
        "funFact": "They fly in big 'V' shapes straight across the sky to save energy during long migration trips!",
        "ecosystemRole": "Migratory herbivore.",
        "diet": "Roots, shoots, and grain.",
        "size": "Large goose.",
        "sound": "A high pitched 'wink-wink'."
      },
      {
        "id": "polar-bear",
        "name": "Polar Bear",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-mother-polar-bear.webp?v=933315585456901259",
        "evolutionaryTrait": "Hollow, clear fur that works like millions of tiny greenhouses capturing the warmth of the sun.",
        "funFact": "Their skin underneath all that bright white looking fur is actually totally pitch black!",
        "ecosystemRole": "Apex ice predator.",
        "diet": "Seals.",
        "size": "Massive bear.",
        "sound": "Chuffs, growls, and roars."
      },
      {
        "id": "ringed-seal",
        "name": "Ringed Seal",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-ringed-seal-pup.webp?v=15299316388314718430",
        "evolutionaryTrait": "Extra strong claws on front flippers powerful enough to break right through thick ice floors.",
        "funFact": "They sneak up onto chunks of sea ice to take cozy, sunny naps when they are tired!",
        "ecosystemRole": "Primary prey for polar bears.",
        "diet": "Arctic cod and crustaceans.",
        "size": "Smallest arctic seal.",
        "sound": "Barks and yelps."
      },
      {
        "id": "rock-ptarmigan",
        "name": "Rock Ptarmigan",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-svalbard-rock-ptarmigan.webp?v=3821400479343134067",
        "evolutionaryTrait": "Heavily feathered feet that work exactly like fluffy, warm winter boots walking in powder snow.",
        "funFact": "They turn completely snow-white in winter but switch to muddy-brown in the summer to hide!",
        "ecosystemRole": "Prey for falcons and foxes.",
        "diet": "Buds and berries.",
        "size": "Medium ground bird.",
        "sound": "A guttural, croaking sound."
      },
      {
        "id": "snow-bunting",
        "name": "Snow Bunting",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-snow-bunting-flying.webp?v=17617032199252481482",
        "evolutionaryTrait": "Special dense feathers that trap heat closely and let them easily survive roaring snow blizzards.",
        "funFact": "Because they show up in white flurries they are known as the 'snowflakes of the bird world'!",
        "ecosystemRole": "Seed disperser.",
        "diet": "Seeds and insects.",
        "size": "Small songbird.",
        "sound": "A musical, rippling twitter."
      },
      {
        "id": "snowy-owl",
        "name": "Snowy Owl",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-snowy-owl.webp?v=11248640301876680887",
        "evolutionaryTrait": "Ghostly white feathers that let them hunt completely invisibly against a white snowy background.",
        "funFact": "Unlike most other owls who hunt at night, snowy owls absolutely love to hunt in bright sunshine!",
        "ecosystemRole": "Tundra apex avian predator.",
        "diet": "Lemmings and hares.",
        "size": "Large, heavy owl.",
        "sound": "A harsh 'krek-krek'."
      },
      {
        "id": "walrus",
        "name": "Walrus",
        "image": "//cleverfoxplay.com/cdn/shop/files/arctic-walrus-2.webp?v=18273696584882000790",
        "evolutionaryTrait": "Giant, tough ivory tusks they creatively use like handy ice-picks to climb out of freezing water.",
        "funFact": "They can easily inflate special hidden air sacs inside their necks so they can drift and safely sleep while floating!",
        "ecosystemRole": "Benthic ecosystem engineer.",
        "diet": "Clams and sea cucumbers.",
        "size": "Massive marine mammal.",
        "sound": "Bellows, snorts, and underwater bells."
      }
    ]
  },
  {
    "id": "outback",
    "name": "Australia",
    "location": "Northern Territory, Australia",
    "description": "A vast, dry, and dusty interior landscape that covers most of Australia. Water is incredibly scarce and temperatures soar. Animals have evolved strange and amazing ways to stay cool and travel huge distances.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/straya-outback-hero.webp?v=552355736272637524",
    "color": "bg-orange-500",
    "facts": [
      {
        "title": "Red Dirt World",
        "content": "The dirt and rocks here are famously bright red because they contain rusted iron! It's like walking on a giant rusty pan.",
        "icon": "sun"
      },
      {
        "title": "Water Catchers",
        "content": "Because it almost never rains, plants and animals are experts at saving water. Some animals never even need to drink; they get all their liquid from eating seeds!",
        "icon": "flower2"
      },
      {
        "title": "Underground Cities",
        "content": "To escape the blistering mid-day sun, lots of creatures dig deep into the earth to build cool, quiet burrows to sleep in.",
        "icon": "trees"
      },
      {
        "title": "Nighttime Magic",
        "content": "The Outback gets freezing cold at night! Many animals actually wait for the sun to go down before they wake up to play and hunt.",
        "icon": "wind"
      }
    ],
    "animals": [
      {
        "id": "australian-bustard",
        "name": "Australian Bustard",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-australian-bustard-3.webp?v=10278431566439824112",
        "evolutionaryTrait": "Long strong legs for marching powerfully through tall grass over vast distances.",
        "funFact": "Males puff out a special neck balloon to make a loud roaring boom sound!",
        "ecosystemRole": "Large terrestrial omnivore.",
        "diet": "Insects, seeds, and small lizards.",
        "size": "Very large ground bird.",
        "sound": "A deep, roaring boom."
      },
      {
        "id": "australian-magpie",
        "name": "Australian Magpie",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-australian-magpie-2.webp?v=9227976117974153752",
        "evolutionaryTrait": "Incredible memory allows them to remember the faces of up to 100 different people.",
        "funFact": "They are considered to have one of the most complex and beautiful bird songs in the world!",
        "ecosystemRole": "Insect controller and scavenger.",
        "diet": "Insects, lizards, and scraps.",
        "size": "Large songbird.",
        "sound": "A complex, melodic caroling."
      },
      {
        "id": "bilby",
        "name": "Bilby",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-bilby.webp?v=119226853921152073",
        "evolutionaryTrait": "Massive rabbit-like ears acting like giant radiators to release body heat.",
        "funFact": "In Australia, they celebrate with chocolate Bilbies instead of Easter Bunnies!",
        "ecosystemRole": "Soil aerator via digging.",
        "diet": "Insects, seeds, and fungi.",
        "size": "Small rabbit-sized marsupial.",
        "sound": "Soft grunts and hisses."
      },
      {
        "id": "black-flanked-rock-wallaby",
        "name": "Black-flanked Rock-wallaby",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-black-footed-rock-wallaby-2.webp?v=8846609436502609450",
        "evolutionaryTrait": "Thick textured foot pads that act like ultimate grippy rock-climbing shoes.",
        "funFact": "They can jump up giant vertical rock walls just like parkour experts!",
        "ecosystemRole": "Rocky outcrop grazer.",
        "diet": "Grasses and leaves.",
        "size": "Small kangaroo-relative.",
        "sound": "Thumping feet and coughs."
      },
      {
        "id": "blue-tongued-skink",
        "name": "Blue-tongued Skink",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-blue-tongued-skink-2.webp?v=14087671964577121164",
        "evolutionaryTrait": "A startlingly bright blue tongue used strictly to scare off predators.",
        "funFact": "If they are scared, they stick out their tongue and hiss to look as dangerous as a snake!",
        "ecosystemRole": "Ground-dwelling omnivore.",
        "diet": "Snails, insects, and berries.",
        "size": "Large lizard.",
        "sound": "A loud, warning hiss."
      },
      {
        "id": "budgerigar",
        "name": "Budgerigar",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-budgerigar-budgie-2.webp?v=5087431305116381666",
        "evolutionaryTrait": "Feathers that glow strictly under ultraviolet light so they can secretly signal each other.",
        "funFact": "They fly in massive, swirling green clouds that look like giant dragonflies!",
        "ecosystemRole": "Nomadic seed eater.",
        "diet": "Grass seeds.",
        "size": "Small parrot.",
        "sound": "Continuous chattering and completely happy chirruping."
      },
      {
        "id": "dingo",
        "name": "Dingo",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-dingo-2.webp?v=17798701692905205276",
        "evolutionaryTrait": "Their wrists can rotate fully, allowing them to turn doorknobs and open gates!",
        "funFact": "Unlike regular dogs, dingos don't bark—they howl like wolves to communicate.",
        "ecosystemRole": "Apex terrestrial predator.",
        "diet": "Kangaroos, rabbits, and rodents.",
        "size": "Medium wild dog.",
        "sound": "Haunting, long howls."
      },
      {
        "id": "emu",
        "name": "Emu",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-emu-2.webp?v=2060366737408677475",
        "evolutionaryTrait": "Three specialized toes let them sprint incredibly fast across flat sandy deserts.",
        "funFact": "The dads are the ones who sit on the huge green eggs and raise the chicks all by themselves!",
        "ecosystemRole": "Long-distance seed disperser.",
        "diet": "Fruits, seeds, and insects.",
        "size": "Second largest bird in the world.",
        "sound": "Deep, drumming grunts."
      },
      {
        "id": "frilled-neck-lizard",
        "name": "Frilled-neck Lizard",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-frilled-neck-lizard-1.webp?v=3921190474983106924",
        "evolutionaryTrait": "A giant umbrella of skin around their neck that forcefully snaps open when threatened.",
        "funFact": "When they need to run away fast, they stand up and sprint on exactly two legs!",
        "ecosystemRole": "Tree-dwelling insectivore.",
        "diet": "Insects and small vertebrates.",
        "size": "Medium lizard.",
        "sound": "An angry hiss when threatened."
      },
      {
        "id": "kookaburra",
        "name": "Kookaburra",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-kookaburra-1.webp?v=2172407066509256952",
        "evolutionaryTrait": "Super strong, heavy beaks explicitly designed for catching venomous outback snakes.",
        "funFact": "Their famous morning call sounds exactly like absolutely uncontrollable human laughing!",
        "ecosystemRole": "Avian predator.",
        "diet": "Snakes, lizards, and large insects.",
        "size": "Large kingfisher.",
        "sound": "A loud, echoing, monkey-like laugh."
      },
      {
        "id": "monitor-lizard",
        "name": "Monitor Lizard",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-australian-monitor-lizard-1.webp?v=5187480020579241462",
        "evolutionaryTrait": "A deeply forked tongue that perfectly tastes the air to find hiding snacks.",
        "funFact": "Some of them can run so fast they look like tiny scampering dinosaurs.",
        "ecosystemRole": "Apex reptile scavenger and predator.",
        "diet": "Carrion, eggs, and smaller animals.",
        "size": "Large varanid lizard.",
        "sound": "Loud, deep hissing."
      },
      {
        "id": "numbat",
        "name": "Numbat",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-numbat.webp?v=3009175926140029473",
        "evolutionaryTrait": "A ridiculously long, sticky tongue perfectly specialized for slurping up hidden termites.",
        "funFact": "They eat absolutely nothing else but termites—over 20,000 of them every single day!",
        "ecosystemRole": "Termite population controller.",
        "diet": "Exclusively termites.",
        "size": "Small, squirrel-like marsupial.",
        "sound": "Soft clicks and tuts."
      },
      {
        "id": "pink-cockatoo",
        "name": "Pink Cockatoo",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-pink-cockatoo-2.webp?v=2367915452119116553",
        "evolutionaryTrait": "A massive, powerful beak that can playfully crack open the hardest outback nuts.",
        "funFact": "They have a glamorous bright pink crest that fully pops up when they are incredibly excited!",
        "ecosystemRole": "Seed and nut consumer.",
        "diet": "Seeds, roots, and nuts.",
        "size": "Medium parrot.",
        "sound": "Piercing, loud screeches."
      },
      {
        "id": "platypus",
        "name": "Platypus",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-platypus-2.webp?v=8519474998713520016",
        "evolutionaryTrait": "A bill packed with tiny electricity sensors to hunt perfectly in muddy water with their eyes closed.",
        "funFact": "They have a duck's bill, a beaver's tail, and they are mammals that lay real eggs!",
        "ecosystemRole": "Freshwater benthic predator.",
        "diet": "Shrimp, worms, and aquatic insects.",
        "size": "Like a small, weird otter.",
        "sound": "Soft growls."
      },
      {
        "id": "quokka",
        "name": "Quokka",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-quokka-1.webp?v=15806736167381543187",
        "evolutionaryTrait": "Can survive totally without drinking fresh water for months by sucking juice out of plants.",
        "funFact": "They are universally known as the 'world's happiest animal' because they are always naturally smiling!",
        "ecosystemRole": "Small browsing herbivore.",
        "diet": "Leaves, stems, and grasses.",
        "size": "Like a small, round wallaby.",
        "sound": "Squeaks and soft grunts."
      },
      {
        "id": "rainbow-lorikeet",
        "name": "Rainbow Lorikeet",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-rainbow-lorikeet-2.webp?v=11577343185344274550",
        "evolutionaryTrait": "A tongue with a special tiny brush at the tip specifically to lovingly sweep up flower pollen.",
        "funFact": "They sleep cuddled tightly together in giant noisy flocks that look absolutely beautiful!",
        "ecosystemRole": "Canopy pollinator.",
        "diet": "Nectar and pollen.",
        "size": "Small, colorful parrot.",
        "sound": "High-pitched screeches and chatters."
      },
      {
        "id": "red-kangaroo",
        "name": "Red Kangaroo",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-red-kangaroo.webp?v=17700164028010390921",
        "evolutionaryTrait": "Hopping actually acts like a bouncy spring, which dramatically uses far less energy than running.",
        "funFact": "They can bound up to 25 feet powerfully forward in exactly one single massive hop!",
        "ecosystemRole": "Large grazing herbivore.",
        "diet": "Grass and shrubs.",
        "size": "Massive marsupial, up to 6 feet tall.",
        "sound": "Soft clucks and coughs."
      },
      {
        "id": "red-back-spider",
        "name": "Red-back Spider",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-red-back-spider-1.webp?v=1050285168844701581",
        "evolutionaryTrait": "Construct intensely messy, tangled webs completely designed to catch walking bugs instead of flying ones.",
        "funFact": "The striking bright red stripe is a huge permanent warning sign that says 'Do Not Eat Me!'",
        "ecosystemRole": "Insect ambush predator.",
        "diet": "Insects and small lizards.",
        "size": "Small, highly venomous spider.",
        "sound": "Silent."
      },
      {
        "id": "short-beaked-echidna",
        "name": "Short-beaked Echidna",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-short-beaked-echidna-1.webp?v=12841211270542934917",
        "evolutionaryTrait": "Covered completely in sharp spines directly made from the exact same thick stuff as your fingernails.",
        "funFact": "If they feel deeply threatened, they quickly roll up into an impossible spiky little ball!",
        "ecosystemRole": "Ecosystem engineer via earth moving.",
        "diet": "Ants and termites.",
        "size": "Small, spiky monotreme.",
        "sound": "Snuffling noises."
      },
      {
        "id": "spinifex-hopping-mouse",
        "name": "Spinifex Hopping Mouse",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-spinifex-hopping-mouse-2.webp?v=8280574144245575303",
        "evolutionaryTrait": "Special incredibly efficient kidneys ensure they never honestly have to ever take a single drink of water.",
        "funFact": "They hop powerfully around exactly like miniature kangaroos instead of running on all fours!",
        "ecosystemRole": "Desert seed consumer.",
        "diet": "Seeds and roots.",
        "size": "Tiny rodent.",
        "sound": "High-pitched squeaks."
      },
      {
        "id": "thorny-devil-lizard",
        "name": "Thorny Devil Lizard",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-thorny-devil-lizard-4.webp?v=17432811941609783528",
        "evolutionaryTrait": "Their spikes impressively collect morning dew drops and quietly funnel it directly to their waiting mouths.",
        "funFact": "They have a completely fake head on the very back of their neck to totally confuse hungry predators!",
        "ecosystemRole": "Ant population controller.",
        "diet": "Exclusively ants.",
        "size": "Small, extremely spiky lizard.",
        "sound": "Silent."
      },
      {
        "id": "wombat",
        "name": "Wombat",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-wombat-1.webp?v=3725649091499405902",
        "evolutionaryTrait": "Their baby pouch practically faces totally backwards so it doesn't stupidly fill up with dirt while they dig.",
        "funFact": "They are the absolutely only animal universally known to leave cube-shaped poop behind!",
        "ecosystemRole": "Extensive burrow digger.",
        "diet": "Grasses and roots.",
        "size": "Chunky, like a small, heavy bear.",
        "sound": "Gruff coughs and grunts."
      },
      {
        "id": "zebra-finch",
        "name": "Zebra Finch",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-zebra-finch-2.webp?v=16819544270042594093",
        "evolutionaryTrait": "Able to aggressively drink salty outback water securely when pure fresh water is completely impossible to find.",
        "funFact": "Finch dads faithfully sing totally unique little songs to cleverly teach their tiny babies how to perfectly sing!",
        "ecosystemRole": "Flocking seed eater.",
        "diet": "Grass seeds.",
        "size": "Tiny songbird.",
        "sound": "A surprisingly loud 'beep-beep'."
      },
      {
        "id": "bulldog-ant",
        "name": "Bulldog Ant",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-bulldog-ant-baby-warrior.webp?v=2180708669738564849",
        "evolutionaryTrait": "Powerful jaws and a potent sting make it a formidable predator.",
        "funFact": "They can jump repeatedly when agitated!",
        "ecosystemRole": "Predator and scavenger.",
        "diet": "Insects, nectar, honeydew.",
        "size": "Large ant.",
        "sound": "Silent."
      },
      {
        "id": "honey-pot-ant",
        "name": "Honeypot Ant",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-honey-pot-ant.webp?v=12719534166707630761",
        "evolutionaryTrait": "Specialized workers swell with nectar to become living food storage for the colony.",
        "funFact": "Their abdomens look like little golden grapes!",
        "ecosystemRole": "Resource storage for ant colonies.",
        "diet": "Nectar and insect honeydew.",
        "size": "Small ant.",
        "sound": "Silent."
      },
      {
        "id": "peacock-spider",
        "name": "Peacock Spider",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-peacock-spider.webp?v=9570737649937575376",
        "evolutionaryTrait": "Males have brightly colored, iridescent abdomen flaps used in complex mating dances.",
        "funFact": "Their dances look like a choreographed routine with tiny legs waving!",
        "ecosystemRole": "Micro-predator.",
        "diet": "Insects and other spiders.",
        "size": "Extremely tiny.",
        "sound": "Silent."
      },
      {
        "id": "australian-jewel-beetle",
        "name": "Jewel Beetle",
        "image": "//cleverfoxplay.com/cdn/shop/files/straya-australian-jewel-beetle.webp?v=3403185426349348444",
        "evolutionaryTrait": "Hard, iridescent exoskeleton that reflects sunlight in brilliant metallic colors.",
        "funFact": "Their shiny bodies act like camouflage in sun-dappled foliage.",
        "ecosystemRole": "Wood borer and pollinator.",
        "diet": "Nectar, foliage, and wood.",
        "size": "Small to medium insect.",
        "sound": "Buzzing in flight."
      }
    ]
  },
  {
    "id": "cloud-forest",
    "name": "Cloud Forest",
    "location": "Monteverde, Costa Rica",
    "description": "A jungle located so high in the mountains that it physically sits right inside the clouds. Everything is constantly dripping with mist. Many plants and animals live entirely in the canopy.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/cloudfor-monteverde-hero.webp?v=8284080207729268860",
    "color": "bg-teal-600",
    "facts": [
      {
        "title": "Inside the Clouds",
        "content": "These forests are so high up that they actually trap passing clouds! It means you're walking through mist all the time.",
        "icon": "cloud"
      },
      {
        "title": "Drink from the Air",
        "content": "Plants here don't even need roots in the soil to drink. They can suck water directly out of the foggy, humid air!",
        "icon": "droplets"
      },
      {
        "title": "Sky Gardens",
        "content": "Every single tree branch is absolutely packed with moss, ferns, and gorgeous little orchids growing right on the bark.",
        "icon": "flower2"
      },
      {
        "title": "The Green Canopy",
        "content": "Most animals here never actually touch the ground! They live their whole amazing lives swinging and crawling way up in the treetops.",
        "icon": "tree-pine"
      }
    ],
    "animals": [
      {
        "id": "agouti",
        "name": "Agouti",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-agouti.webp?v=18083622882079660919",
        "evolutionaryTrait": "Amazing sense of smell to sniff out fallen fruit buried deep in the rotting leaves.",
        "funFact": "They forget where they bury seeds, accidentally planting new fruit trees everywhere!",
        "ecosystemRole": "Forest gardener planting seeds.",
        "diet": "Seeds, fallen fruit, and nuts.",
        "size": "Size of a plump rabbit.",
        "sound": "A sharp grunt!"
      },
      {
        "id": "bare-necked-umbrellabird",
        "name": "Bare-necked Umbrellabird",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-bare-necked-umbrellabird.webp?v=11115962822702921466",
        "evolutionaryTrait": "Males inflate a bright red throat pouch to make their voice echo miles away.",
        "funFact": "Their feathers make them look like they are politely wearing an umbrella as a hat!",
        "ecosystemRole": "Seed disperser.",
        "diet": "Large fruits and big bugs.",
        "size": "Chunky like a large crow.",
        "sound": "A deep, mooing BOOM!"
      },
      {
        "id": "blue-morpho",
        "name": "Blue Morpho",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-blue-morpho-butterfly.webp?v=17452851512052834378",
        "evolutionaryTrait": "Microscopic scales bend light to create intense blue magic without any actual blue dye.",
        "funFact": "If they close their wings, they look exactly like a boring, dead brown leaf.",
        "ecosystemRole": "Cleans the forest by eating rotting fruit.",
        "diet": "Rotting fruit juice and tree sap.",
        "size": "Wingspan size of a dinner plate.",
        "sound": "Silent flutters."
      },
      {
        "id": "blue-crowned-motmot",
        "name": "Blue-crowned Motmot",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-blue-crowned-motmot.webp?v=6973979444576843574",
        "evolutionaryTrait": "They bite off pieces of their tail feathers on purpose to create a cool tennis racket shape.",
        "funFact": "They swing their tail back and forth just like an old ticking clock!",
        "ecosystemRole": "Controls bug populations.",
        "diet": "Insects and small lizards.",
        "size": "Long as a classroom ruler.",
        "sound": "A repeating WHOOT-WHOOT."
      },
      {
        "id": "coati",
        "name": "Coati",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-baby-coati.webp?v=945096384062934609",
        "evolutionaryTrait": "Double-jointed ankles allow them to boldly climb straight down trees head-first.",
        "funFact": "They boldly keep their long tails straight up like a flagpole to find friends in tall grass!",
        "ecosystemRole": "Soil aerator and pest controller.",
        "diet": "Bugs, fruit, and eggs.",
        "size": "Like a raccoon with a long nose.",
        "sound": "Pig-like snorts and chirps."
      },
      {
        "id": "collared-peccary",
        "name": "Collared Peccary",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-collared-peccary.webp?v=1290538160841146912",
        "evolutionaryTrait": "A brutally tough snout perfectly designed like a shovel for digging up buried roots.",
        "funFact": "They heavily rely on a very stinky back gland to identify their family members!",
        "ecosystemRole": "Turns over the soil to keep it healthy.",
        "diet": "Roots, tough seeds, and grass.",
        "size": "Like a medium-sized dog.",
        "sound": "Fierce teeth-chattering clatters."
      },
      {
        "id": "coral-snake",
        "name": "Coral Snake",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-coral-snake.webp?v=16261612517071496178",
        "evolutionaryTrait": "Insanely bright colored stripes powerfully warning everyone around them to stay away.",
        "funFact": "Remember the rhyme to stay safe: 'Red touch yellow, kills a fellow.'",
        "ecosystemRole": "Keeps other snake numbers balanced.",
        "diet": "Other smaller snakes.",
        "size": "Thin like a pencil, long as an arm.",
        "sound": "A quiet, sneaky hiss."
      },
      {
        "id": "costa-rican-zebra-tarantula",
        "name": "Costa Rican Zebra Tarantula",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-costa-rican-zebra-tarantula.webp?v=14954488404669710109",
        "evolutionaryTrait": "Can accurately flick microscopic spiky hairs into the eyes of attackers.",
        "funFact": "Their striking bright white stripes make them look incredibly fierce and totally stylish!",
        "ecosystemRole": "Ambush predator controlling large bugs.",
        "diet": "Huge crickets and roaches.",
        "size": "Large enough to cover a human hand.",
        "sound": "Faint leafy scuttles."
      },
      {
        "id": "emerald-basilisk-lizard",
        "name": "Emerald Basilisk Lizard",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-emerald-basilisk-lizard.webp?v=18234425266748783679",
        "evolutionaryTrait": "Special fringed toes that trap air bubbles securely under their running feet.",
        "funFact": "They are called the 'Jesus Christ Lizard' because they run right across water!",
        "ecosystemRole": "Controls mosquito populations.",
        "diet": "Insects and sweet forest fruits.",
        "size": "Electric-green body with a foot-long tail.",
        "sound": "Startling, fast water splashes."
      },
      {
        "id": "emerald-toucanet",
        "name": "Emerald Toucanet",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-emerald-toucanet.webp?v=3490340454943823587",
        "evolutionaryTrait": "A giant yet ultra-lightweight beak brilliantly meant for grabbing far-away fruit.",
        "funFact": "They use their beak like a giant radiator to let off heat on hot days!",
        "ecosystemRole": "Rains seeds out from the canopy.",
        "diet": "Mostly colorful fruits.",
        "size": "An adorable, tiny toucan.",
        "sound": "A loud, dog-like bark!"
      },
      {
        "id": "eyelash-viper",
        "name": "Eyelash Viper",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-eyelash-viper.webp?v=6629522940147602997",
        "evolutionaryTrait": "Spiky scales right above their eyes break up their outline among leaves.",
        "funFact": "They come in brilliant neon colors like yellow, pink, and glowing green!",
        "ecosystemRole": "Controls small rodent and frog populations.",
        "diet": "Tiny frogs and little birds.",
        "size": "A short but chunky venomous snake.",
        "sound": "A scary, sudden hiss."
      },
      {
        "id": "great-curassow",
        "name": "Great Curassow",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-great-curassow-bird.webp?v=10769933744085805989",
        "evolutionaryTrait": "A ridiculous curly crest of feathers sitting directly on top of their head.",
        "funFact": "Male birds lovingly offer yummy bugs to court the female birds!",
        "ecosystemRole": "Ground cleaner and large seed disperser.",
        "diet": "Fallen fruits, nuts, and giant beetles.",
        "size": "As big as a majestic turkey.",
        "sound": "A deep, booming humming note."
      },
      {
        "id": "green-and-black-poison-dart-frog",
        "name": "Green and Black Poison Dart Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-green-and-black-poison-dart-frog.webp?v=17651307350229856463",
        "evolutionaryTrait": "They steal deadly poison from the ants they eat and secrete it through their skin.",
        "funFact": "Their bright swirling neon colors warn predators to back off!",
        "ecosystemRole": "Ant population controller.",
        "diet": "Spicy ants, tricky tiny beetles.",
        "size": "Barely bigger than a quarter.",
        "sound": "A buzzing trill like a tiny motor."
      },
      {
        "id": "green-crowned-brilliant-hummingbird",
        "name": "Green-crowned Brilliant Hummingbird",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-green-crowned-brilliant-hummingbird.webp?v=16755181755975060956",
        "evolutionaryTrait": "Wings flap wildly fast so they can hover magically still in the air.",
        "funFact": "They can fly backwards and even upside down whenever they need to escape!",
        "ecosystemRole": "Vital pollinator of deep flowers.",
        "diet": "Sweet flower nectar and tiny hidden spiders.",
        "size": "Smaller than a playing card.",
        "sound": "A loud, high-pitched buzzy hum."
      },
      {
        "id": "hercules-beetle",
        "name": "Hercules Beetle",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-hercules-bug.webp?v=1719952419405096196",
        "evolutionaryTrait": "Males have massively strong horns used for fierce wrestling.",
        "funFact": "They actually change their shell color based on the humidity level!",
        "ecosystemRole": "Recycles decaying wood back into dirt.",
        "diet": "Rotten fruits and decaying wood.",
        "size": "Can grow up to six inches long.",
        "sound": "A loud buzzing when flying."
      },
      {
        "id": "howler-monkey",
        "name": "Howler Monkey",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-howler-monkey.webp?v=6967310293803668612",
        "evolutionaryTrait": "A massively enlarged throat bone lets them amplify their voice up to three miles.",
        "funFact": "They are the loudest land animals in the entire world.",
        "ecosystemRole": "Canopy seed disperser.",
        "diet": "Leaves, flowers, and sweet fruit.",
        "size": "As big as a medium-sized dog.",
        "sound": "A terrifyingly loud roar."
      },
      {
        "id": "jaguar",
        "name": "Jaguar",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-jaguar-cat.webp?v=14349776331827518368",
        "evolutionaryTrait": "Their delightfully strong jaws can crush a whole turtle shell in one bite.",
        "funFact": "Unlike other giant cats, they absolutely love swimming.",
        "ecosystemRole": "Apex predator keeping the ecosystem balanced.",
        "diet": "Peccaries, deer, and monkeys.",
        "size": "A massive, heavy muscle-packed cat.",
        "sound": "A deep, rasping, saw-like grunt."
      },
      {
        "id": "keel-billed-toucan",
        "name": "Keel-billed Toucan",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-keel-billed-toucan.webp?v=15321674113258490738",
        "evolutionaryTrait": "A giant rainbow bill gracefully used to snag tricky out-of-reach fruit.",
        "funFact": "They toss yummy fruit completely backwards down their throats.",
        "ecosystemRole": "The ultimate tree planter and seed dropper.",
        "diet": "Fruit.",
        "size": "A large brightly colored bird.",
        "sound": "A frog-like, raspy croak."
      },
      {
        "id": "kinkajou",
        "name": "Kinkajou",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-kinkajou.webp?v=16244279745660974784",
        "evolutionaryTrait": "A prehensile tail capable of perfectly gripping thick branches.",
        "funFact": "Their long skinny tongue can slurp sweet flower nectar out of deep blooms.",
        "ecosystemRole": "Important night-time pollinator and seed disperser.",
        "diet": "Sweet fruit, nectar, and honey.",
        "size": "Small, furry, and golden.",
        "sound": "High squeaks and barks."
      },
      {
        "id": "lanternfly",
        "name": "Lanternfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-peanuthead-lanternfly.webp?v=13269910725437294499",
        "evolutionaryTrait": "Has a massive, hollow snout shaped exactly like a peanut.",
        "funFact": "Despite their name, they don't actually light up or glow!",
        "ecosystemRole": "Tree sap drinker.",
        "diet": "Tree sap and plant juices.",
        "size": "A large, weirdly shaped insect.",
        "sound": "A weird, ticking buzz."
      },
      {
        "id": "long-tailed-manakin",
        "name": "Long-tailed Manakin",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-long-tailed-manakin-bird.webp?v=15851683000309590616",
        "evolutionaryTrait": "Males team up to perform synchronized, acrobatic dance routines.",
        "funFact": "The apprentice bird dances carefully to help the master bird get a mate!",
        "ecosystemRole": "Berry seed disperser.",
        "diet": "Berries and tiny insects.",
        "size": "A small, colorful bird.",
        "sound": "A loud, synchronized 'TOLEDO!'"
      },
      {
        "id": "nine-banded-armadillo",
        "name": "Nine-banded Armadillo",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-nine-banded-armadillo.webp?v=11519347602013879255",
        "evolutionaryTrait": "Covered in a tough, flexible suit of armor made of bone.",
        "funFact": "They always give birth to exactly four identical babies at a time!",
        "ecosystemRole": "Turns up dirt while digging for bugs.",
        "diet": "Bugs, grubs, and worms.",
        "size": "Like an armored housecat.",
        "sound": "Snuffling and rooting noises."
      },
      {
        "id": "olingo",
        "name": "Olingo",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-olingo.webp?v=5982662743542584118",
        "evolutionaryTrait": "Incredibly agile for jumping silently through the high canopy at night.",
        "funFact": "They look like a mix between a housecat, a bear, and a ferret!",
        "ecosystemRole": "Canopy fruit eater and seed spreader.",
        "diet": "Fruit, nectar, and insects.",
        "size": "Small and slender.",
        "sound": "Soft sneezes and chirps."
      },
      {
        "id": "orchid-bee",
        "name": "Orchid Bee",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-orchid-bee-1.webp?v=11343449211500094623",
        "evolutionaryTrait": "A brilliantly metallic green body with an incredibly long tongue.",
        "funFact": "Male bees scrape perfume off orchids to make themselves smell good!",
        "ecosystemRole": "The only bee that can pollinate deep cloud forest orchids.",
        "diet": "Nectar.",
        "size": "A large, shiny bee.",
        "sound": "A loud, low hum."
      },
      {
        "id": "palm-pit-viper",
        "name": "Palm Pit Viper",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-palm-pit-viper.webp?v=10068165091641582347",
        "evolutionaryTrait": "Heat-sensing pits on their face let them see warm-blooded prey in total darkness.",
        "funFact": "They hang directly from branches, looking exactly like a hanging green leaf.",
        "ecosystemRole": "Ambush predator high in the trees.",
        "diet": "Birds, frogs, and mice.",
        "size": "Long, coiled, and green.",
        "sound": "A threatening hiss."
      },
      {
        "id": "porcupine",
        "name": "Porcupine",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-prehensile-tailed-porcupine.webp?v=9562463324719454216",
        "evolutionaryTrait": "Covered in absolutely terrifying sharp quills to scare off jaguars.",
        "funFact": "They can't actually shoot their quills, but the quills pop off super easily!",
        "ecosystemRole": "Chews off tree bark, opening up the canopy.",
        "diet": "Leaves, twigs, and bark.",
        "size": "Like a spiky, waddling badger.",
        "sound": "Whines, grunts, and teeth clattering."
      },
      {
        "id": "puma",
        "name": "Puma",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-puma.webp?v=15863684338385654995",
        "evolutionaryTrait": "Massive, powerful back legs allow them to jump twenty feet straight up.",
        "funFact": "They can actually purr just like a housecat, but they cannot roar!",
        "ecosystemRole": "Apex predator.",
        "diet": "Deer, raccoons, and other mammals.",
        "size": "A large, sleek tan cat.",
        "sound": "A screaming yowl or a gentle purr."
      },
      {
        "id": "red-brocket-deer",
        "name": "Red Brocket Deer",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-red-brocket-deer-fawn.webp?v=1636194888462784679",
        "evolutionaryTrait": "Tiny spike antlers that don't get tangled in the thick brush.",
        "funFact": "They are incredibly shy and will dive into rivers to escape predators.",
        "ecosystemRole": "Eats undergrowth and disperses seeds.",
        "diet": "Leaves, fruit, and fungi.",
        "size": "Small, like a large goat.",
        "sound": "Usually silent, sometimes a sharp bark."
      },
      {
        "id": "red-eyed-tree-frog",
        "name": "Red-eyed Tree Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-red-eyed-tree-frog.webp?v=11066351631489995745",
        "evolutionaryTrait": "Sticky toe pads designed to cling perfectly to wet, slippery leaves.",
        "funFact": "They flash their bright red eyes to completely startle sleepy predators!",
        "ecosystemRole": "Insect control.",
        "diet": "Moths, crickets, and flies.",
        "size": "Small enough to sit on your hand.",
        "sound": "A soft, rhythmic 'chuck'."
      },
      {
        "id": "resplendent-quetzal",
        "name": "Resplendent Quetzal",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-resplendent-quetzal.webp?v=14258400484102032326",
        "evolutionaryTrait": "Males grow a dazzling metallic green tail over a yard long.",
        "funFact": "They were considered sacred by the ancient Maya and Aztec civilizations.",
        "ecosystemRole": "The ultimate wild avocado farmer and seed spreader.",
        "diet": "Wild avocados, insects, and frogs.",
        "size": "A chunky pigeon with a giant tail.",
        "sound": "A soulful, whistling song."
      },
      {
        "id": "silky-anteater",
        "name": "Silky Anteater",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-silky-anteater.webp?v=11801339535848394955",
        "evolutionaryTrait": "Incredibly soft, golden fur that perfectly matches the shiny silk-cotton tree.",
        "funFact": "They never come down from the trees and move slower than a sloth!",
        "ecosystemRole": "Controls arboreal ant colonies.",
        "diet": "Thousands of tiny tree ants.",
        "size": "Very small, about the size of a squirrel.",
        "sound": "Usually completely silent."
      },
      {
        "id": "spectacled-owl",
        "name": "Spectacled Owl",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-spectacled-owl.webp?v=13028530204284248900",
        "evolutionaryTrait": "White rings around their eyes make them look like they're wearing glasses.",
        "funFact": "Baby owls are pure white and look like giant fluffy marshmallows!",
        "ecosystemRole": "Night-time predator controlling rodents.",
        "diet": "Mice, frogs, and large bugs.",
        "size": "A very large, powerful owl.",
        "sound": "A deep, popping hoot."
      },
      {
        "id": "spotted-paca",
        "name": "Spotted Paca",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-spotted-paca.webp?v=8597682535494998012",
        "evolutionaryTrait": "White spots break up their outline, giving them perfect camouflage in the shadows.",
        "funFact": "When scared, they will plunge into water and hold their breath for minutes!",
        "ecosystemRole": "Seed disperser.",
        "diet": "Fallen fruit and leaves.",
        "size": "Like a very fat, tailless cat.",
        "sound": "Loud, snorting grunts."
      },
      {
        "id": "strawberry-poison-dart-frog",
        "name": "Strawberry Poison Dart Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-strawberry-poison-dart-frog.webp?v=5018598128305873814",
        "evolutionaryTrait": "Neon red 'strawberry' skin with blue 'blue jean' legs.",
        "funFact": "Mothers carry their tadpoles on their backs up into the canopy pools!",
        "ecosystemRole": "Ant controlling predator.",
        "diet": "Poisonous ants and tiny mites.",
        "size": "Tiny as a fingernail.",
        "sound": "A sharp, chirping buzz."
      },
      {
        "id": "tayra",
        "name": "Tayra",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-tayra.webp?v=86219361558560173",
        "evolutionaryTrait": "A long, sleek body built like an oversized weasel for climbing high trees.",
        "funFact": "They love honey so much they will steal sweet fruit, hide it, and wait for it to ripen!",
        "ecosystemRole": "Generalist predator and seed disperser.",
        "diet": "Fruit, honey, bugs, and mice.",
        "size": "Like a fuzzy, tall black dog.",
        "sound": "Snarls, growls, and spits."
      },
      {
        "id": "three-wattled-bellbird",
        "name": "Three-wattled Bellbird",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-three-wattle-bellbird.webp?v=12416946283527689373",
        "evolutionaryTrait": "Three bizarre, fleshy worm-like wattles hanging right off its beak.",
        "funFact": "It has one of the loudest bird calls on the planet, heard half a mile away!",
        "ecosystemRole": "Spreads seeds of the wild avocado tree.",
        "diet": "Wild avocados and big fruits.",
        "size": "A bulky, rusty-brown bird.",
        "sound": "A deafening, metallic 'BONK!'"
      },
      {
        "id": "two-toed-sloth",
        "name": "Two-toed Sloth",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-two-toed-sloth.webp?v=7364300455512509781",
        "evolutionaryTrait": "A specialized stomach that slowly digests toxic leaves over an entire month.",
        "funFact": "They move so incredibly slowly that green algae actually grows in their fur!",
        "ecosystemRole": "Leaf eater and slow canopy dweller.",
        "diet": "Leaves, twigs, and some fruit.",
        "size": "Like a medium dog with long arms.",
        "sound": "A high-pitched, hissing sigh."
      },
      {
        "id": "walking-stick",
        "name": "Walking Stick",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-walking-stick-insect.webp?v=5624280221890327229",
        "evolutionaryTrait": "Perfectly mimics a brown stick or green branch to avoid being eaten.",
        "funFact": "They gently sway back and forth in the wind to look exactly like a moving branch!",
        "ecosystemRole": "Leaf trimmer.",
        "diet": "Green canopy leaves.",
        "size": "As long as a ruler.",
        "sound": "Completely silent."
      },
      {
        "id": "white-faced-capuchin",
        "name": "White-faced Capuchin",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-white-faced-capuchin.webp?v=12845171601873931373",
        "evolutionaryTrait": "A strong prehensile tail used as an extra hand to swing through branches.",
        "funFact": "They are brilliant tool users, occasionally using rocks to smash open hard nuts!",
        "ecosystemRole": "Fruit eater and insect predator.",
        "diet": "Fruit, bugs, eggs, and leaves.",
        "size": "A small, muscular monkey.",
        "sound": "High barks, chatters, and squeaks."
      },
      {
        "id": "golden-toad",
        "name": "Golden Toad",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-golden-toad.webp?v=13860301325719074145",
        "evolutionaryTrait": "Brilliant, glowing orange skin that made males stand out vibrantly against the dark forest floor.",
        "funFact": "They are believed to be extinct, as none have been seen since 1989, making them a symbol of conservation.",
        "ecosystemRole": "Amphibian insectivore (historically).",
        "diet": "Small insects and invertebrates.",
        "size": "Small toad.",
        "sound": "A soft, quiet trill."
      },
      {
        "id": "green-iguana",
        "name": "Green Iguana",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-green-iguana.webp?v=9137303959198942303",
        "evolutionaryTrait": "A long, whip-like tail they can use to defend against predators or swim powerfully through rivers.",
        "funFact": "They have a 'third eye' on top of their head called a parietal eye to sense shadows of predatory birds!",
        "ecosystemRole": "Canopy herbivore.",
        "diet": "Leaves, flowers, and fruit.",
        "size": "Large lizard.",
        "sound": "Soft hisses."
      },
      {
        "id": "squirrel-monkey",
        "name": "Squirrel Monkey",
        "image": "//cleverfoxplay.com/cdn/shop/files/cloudfor-squirrel-monkey.webp?v=17718262493394489949",
        "evolutionaryTrait": "Incredibly agile with a long, non-prehensile tail used purely for perfect balance while running across branches.",
        "funFact": "They live in huge troops and often rub sweet-smelling leaves on their bodies as perfume and bug spray!",
        "ecosystemRole": "Seed disperser and insect controller.",
        "diet": "Fruit, insects, and small frogs.",
        "size": "Small monkey.",
        "sound": "High-pitched chirps and squeaks."
      }
    ]
  },
  {
    "id": "coral-reef",
    "name": "Coral Reef",
    "location": "Raja Ampat, Indonesia",
    "description": "The 'Rainforests of the Sea.' Tiny coral polyps build massive colorful cities. This underwater paradise is home to a quarter of all ocean life.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/coralreef-raja-ampat-hero.webp?v=15445256006580722550",
    "color": "bg-cyan-400",
    "facts": [
      {
        "title": "Cities of Bone",
        "content": "Coral reefs aren't just rocks; they're actually made of millions of tiny animals called polyps that build hard skeletons around themselves!",
        "icon": "shield"
      },
      {
        "title": "Rainforests of the Sea",
        "content": "Even though they cover less than 1% of the ocean floor, coral reefs are home to a massive 25% of all marine life.",
        "icon": "globe"
      },
      {
        "title": "Sunlight Seekers",
        "content": "Corals need sunlight to grow because they have tiny plants living right inside their cells that make food for them.",
        "icon": "sun"
      },
      {
        "title": "Cleaning Stations",
        "content": "Big fish actually wait in line at 'cleaning stations' where tiny shrimp and fish pick off parasites and dead skin for a free meal!",
        "icon": "droplets"
      }
    ],
    "animals": [
      {
        "id": "blue-spotted-stingray",
        "name": "Blue-spotted Stingray",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-blue-spotted-stingray.webp?v=6873782436481064478",
        "evolutionaryTrait": "Vibrant blue spots warn predators of their venomous tail barb.",
        "funFact": "They bury themselves under the sand with only their eyes sticking out to surprise their prey!",
        "ecosystemRole": "Controls populations of bottom-dwelling invertebrates.",
        "diet": "Crabs, shrimp, and small fish.",
        "size": "Length of a skateboard.",
        "sound": "Silent swish."
      },
      {
        "id": "clam",
        "name": "Clam",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-clam.webp?v=6434369054786556131",
        "evolutionaryTrait": "Giant clams farm algae in their lips to get free solar-powered food.",
        "funFact": "A single giant clam can live for over 100 years and weigh as much as three humans!",
        "ecosystemRole": "Filters the water to keep it crystal clear.",
        "diet": "Sunlight and microscopic plankton.",
        "size": "Can grow as big as a bathtub.",
        "sound": "A quiet snap when closing."
      },
      {
        "id": "clownfish",
        "name": "Clownfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-clownfish.webp?v=1633252402637193194",
        "evolutionaryTrait": "A thick layer of protective slime lets them safely hug stinging anemones.",
        "funFact": "All clownfish are born male, and the largest one turns into a female!",
        "ecosystemRole": "Protects their anemone home from nibbling fish.",
        "diet": "Leftovers from their anemone, plus tiny zooplankton.",
        "size": "Size of an orange wedge.",
        "sound": "Aggressive popping sounds."
      },
      {
        "id": "cone-snail",
        "name": "Cone Snail",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-cone-snail.webp?v=17400968807975054126",
        "evolutionaryTrait": "Fires a venomous harpoon tooth fast enough to paralyze a swimming fish instantly.",
        "funFact": "Their venom is incredibly deadly, but scientists use it to create amazing new medicines!",
        "ecosystemRole": "Apex predator of the micro-reef environment.",
        "diet": "Worms, small fish, and other snails.",
        "size": "Size of an ice cream cone.",
        "sound": "A silent, speedy shot."
      },
      {
        "id": "cuttlefish",
        "name": "Cuttlefish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-cuttlefish.webp?v=13165416085451163009",
        "evolutionaryTrait": "Millions of color-changing cells in their skin create hypnotic flashing patterns.",
        "funFact": "They have a surfboard-shaped bone inside their body completely full of gas for perfect floating!",
        "ecosystemRole": "Mid-level predator controlling small fish and crabs.",
        "diet": "Crabs, shrimp, and fish.",
        "size": "Size of a football.",
        "sound": "Silent water jets."
      },
      {
        "id": "decorator-crab",
        "name": "Decorator Crab",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-decorator-crab.webp?v=3106322916431282638",
        "evolutionaryTrait": "Velcro-like hooks completely cover their shell so they can physically stick sea sponges to their back.",
        "funFact": "They literally dress themselves up in toxic corals to ensure nobody ever tries to eat them!",
        "ecosystemRole": "Transports sponges and corals around the reef.",
        "diet": "Algae, small meaty bits, and plankton.",
        "size": "Size of a tennis ball.",
        "sound": "Tiny clicking claws."
      },
      {
        "id": "emperor-angelfish",
        "name": "Emperor Angelfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-emperor-angelfish.webp?v=15499222361886094880",
        "evolutionaryTrait": "Their striking horizontal stripes act like dazzle camouflage among complicated coral branches.",
        "funFact": "As babies, they look perfectly circular with a dazzling bullseye pattern that completely changes!",
        "ecosystemRole": "Spongivore that stops sponges from taking over the reef.",
        "diet": "Sea sponges and tunicates.",
        "size": "Size of a dinner plate.",
        "sound": "Loud grunting knocks."
      },
      {
        "id": "epaulette-shark",
        "name": "Epaulette Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-epaulette-shark.webp?v=7400854304187577774",
        "evolutionaryTrait": "Can perfectly survive completely out of the water for hours by slowing down their breathing.",
        "funFact": "They actually use their fins to literally walk over the exposed reef at low tide looking for crabs!",
        "ecosystemRole": "Controls crab populations in shallow tide pools.",
        "diet": "Crabs, shrimp, and small bottom fish.",
        "size": "Length of a baseball bat.",
        "sound": "Splashing tide pool steps."
      },
      {
        "id": "feather-star",
        "name": "Feather Star",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-feather-star.webp?v=13941475615913517422",
        "evolutionaryTrait": "Dozens of sticky, feathery arms strictly designed for catching tiny drifting plankton.",
        "funFact": "They are ancient starfish relatives that can actually detach completely and gracefully swim away!",
        "ecosystemRole": "Filters plankton completely out of the water current.",
        "diet": "Microscopic drifting plankton.",
        "size": "Size of a basketball.",
        "sound": "Silent feathery waving."
      },
      {
        "id": "frogfish",
        "name": "Frogfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-frogfish.webp?v=15267437545212964668",
        "evolutionaryTrait": "Their front fins have perfectly evolved to act specifically like little walking hands.",
        "funFact": "They suck down their prey faster than a blink of an eye—the fastest bite in the ocean!",
        "ecosystemRole": "Ultimate ambush predator entirely controlling small fish.",
        "diet": "Any fish roughly their exact same size.",
        "size": "Size of a textured grapefruit.",
        "sound": "A huge, silent gulp."
      },
      {
        "id": "giant-grouper",
        "name": "Giant Grouper",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-giant-grouper.webp?v=3916216310895237485",
        "evolutionaryTrait": "A massive mouth flawlessly designed to inhale large passing prey whole.",
        "funFact": "They grow so remarkably huge they are sometimes seen swallowing small sharks!",
        "ecosystemRole": "Apex reef predator securing the fish population naturally.",
        "diet": "Large fish, turtles, and crustaceans.",
        "size": "Size of a small car.",
        "sound": "A low, boomy grunt."
      },
      {
        "id": "leopard-coral-grouper",
        "name": "Leopard Coral Grouper",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-leopard-coral-grouper.webp?v=190610917494512007",
        "evolutionaryTrait": "Striking bright red skin entirely covered in hundreds of tiny blue spots for reef camouflage.",
        "funFact": "They team up with moray eels to hunt, shaking their heads to point out hidden fish!",
        "ecosystemRole": "Keeps populations of grazing fish balanced.",
        "diet": "Small fish and crustaceans.",
        "size": "About the length of an arm.",
        "sound": "Quiet fin snaps."
      },
      {
        "id": "lionfish",
        "name": "Lionfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-lionfish.webp?v=14622633366837484026",
        "evolutionaryTrait": "Long, flowing pectoral fins hiding extremely venomous spines along their back.",
        "funFact": "They herd their prey into a corner using their giant fins like a net before striking!",
        "ecosystemRole": "Predator of small fish in native reefs.",
        "diet": "Small fish, shrimp, and crabs.",
        "size": "Size of a volleyball.",
        "sound": "Silent hunter."
      },
      {
        "id": "mandarin-fish",
        "name": "Mandarin Fish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-mandarin-fish.webp?v=15155200179066016061",
        "evolutionaryTrait": "Secretes a foul-tasting, toxic slime to keep predators from eating them.",
        "funFact": "They are famously one of the only animals in the world to produce their own true blue pigment!",
        "ecosystemRole": "Eats small invertebrates hiding in the coral.",
        "diet": "Tiny worms and crustaceans.",
        "size": "Size of a thumb.",
        "sound": "Silent fluttering."
      },
      {
        "id": "manta-ray",
        "name": "Manta Ray",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-manta-ray.webp?v=9610205837519084502",
        "evolutionaryTrait": "Special horns on their face perfectly funnel plankton straight into their huge gaping mouths.",
        "funFact": "They have one of the largest brains of any fish and are extremely curious about humans!",
        "ecosystemRole": "Pelagic filter feeder cleaning the open water.",
        "diet": "Plankton.",
        "size": "Wingspan as wide as a garage door.",
        "sound": "Graceful underwater swooshes."
      },
      {
        "id": "mantis-shrimp",
        "name": "Mantis Shrimp",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-mantis-shrimp.webp?v=14499442397558199201",
        "evolutionaryTrait": "Spring-loaded punching arms that strike with the speed of a fired bullet.",
        "funFact": "Their punch is so fast it boils the water around it and creates a flash of light!",
        "ecosystemRole": "Benthic predator breaking open hardshell prey.",
        "diet": "Crabs, clams, and snails.",
        "size": "Length of a banana.",
        "sound": "A loud popping snap."
      },
      {
        "id": "moorish-idol",
        "name": "Moorish Idol",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-moorish-idol.webp?v=6887579884165233773",
        "evolutionaryTrait": "A tubular snout ending in a small mouth, perfectly shaped for picking at narrow coral cracks.",
        "funFact": "They are notoriously dramatic divas and rarely survive inside aquariums!",
        "ecosystemRole": "Feeds on sponges and benthic invertebrates.",
        "diet": "Sponges, coral polyps, and small invertebrates.",
        "size": "Size of a dinner plate.",
        "sound": "Silent nipping."
      },
      {
        "id": "napoleon-wrasse",
        "name": "Napoleon Wrasse",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-napoleon-wrasse.webp?v=1973363693591917074",
        "evolutionaryTrait": "Thick, tough lips that let them crush toxic sea hares and boxfish without getting stung.",
        "funFact": "They have a huge, bumpy forehead that grows larger as they get older!",
        "ecosystemRole": "One of the few predators of the destructive crown-of-thorns starfish.",
        "diet": "Hard-shelled prey and toxic animals.",
        "size": "Bigger than a grown man.",
        "sound": "Loud crunching sounds."
      },
      {
        "id": "nautilus",
        "name": "Nautilus",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-nautilus.webp?v=12074000473683306728",
        "evolutionaryTrait": "A gas-filled chambered shell acting as a submarine buoyancy system to rise and sink.",
        "funFact": "They haven't changed their appearance in 500 million years, making them a living fossil!",
        "ecosystemRole": "Deep-water scavenger.",
        "diet": "Dead fish and crabs.",
        "size": "Size of a volleyball.",
        "sound": "Water jet spurts."
      },
      {
        "id": "nudibranch",
        "name": "Nudibranch",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-nudibranch.webp?v=9600932831873523569",
        "evolutionaryTrait": "Eats venomous anemones and somehow steals their stinging cells to use for its own defense.",
        "funFact": "They are basically shell-less colorful sea slugs that look like tiny, fiery dragons!",
        "ecosystemRole": "Specialized predator of toxic sponges and anemones.",
        "diet": "Sponges, anemones, and coral.",
        "size": "Size of an eraser.",
        "sound": "Silent creeping."
      },
      {
        "id": "octopus",
        "name": "Octopus",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-octopus.webp?v=16101294739505619293",
        "evolutionaryTrait": "No bones at all, allowing them to squeeze through holes no bigger than a coin.",
        "funFact": "They have exactly three hearts and incredibly smart alien-like brains in their arms!",
        "ecosystemRole": "Highly intelligent trap-setter and ambush predator.",
        "diet": "Crabs, clams, and fish.",
        "size": "Arm span of a hula hoop.",
        "sound": "Silent jetting."
      },
      {
        "id": "pearl-oyster",
        "name": "Pearl Oyster",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-pearl-oyster.webp?v=13529552440247701832",
        "evolutionaryTrait": "Coats irritating sand grains in smooth nacre, accidentally creating beautiful shiny pearls.",
        "funFact": "Only a few special types of oysters make the shiny pearls used in expensive necklaces!",
        "ecosystemRole": "Water-filtration engine of the lower reef.",
        "diet": "Plankton and floating organic particles.",
        "size": "Size of a saucer.",
        "sound": "Silent filtering."
      },
      {
        "id": "picasso-triggerfish",
        "name": "Picasso Triggerfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-picasso-triggerfish.webp?v=5098741745405214554",
        "evolutionaryTrait": "A dorsal spine that completely locks into place to wedge themselves tightly inside coral holes.",
        "funFact": "They look like a chaotic painting, earning them their famous artist name!",
        "ecosystemRole": "Eats hard-shelled invertebrates hiding in the rubble.",
        "diet": "Sea urchins and crustaceans.",
        "size": "Length of a ruler.",
        "sound": "A loud grunting noise when distressed."
      },
      {
        "id": "porcelain-crab",
        "name": "Porcelain Crab",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-porcelain-crab.webp?v=3623685421126561501",
        "evolutionaryTrait": "Shed their limbs easily if grabbed by a predator to successfully escape and hide.",
        "funFact": "They aren't technically crabs; they are actually more closely related to squat lobsters!",
        "ecosystemRole": "Cleans up drifting food crumbs around the anemone.",
        "diet": "Plankton caught with their fan-like mouthparts.",
        "size": "Size of a bottle cap.",
        "sound": "Tiny clicking sounds."
      },
      {
        "id": "pufferfish",
        "name": "Pufferfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-pufferfish.webp?v=17120098732742666594",
        "evolutionaryTrait": "Rapidly swallows massive amounts of water to inflate into an unswallowable spiky balloon.",
        "funFact": "They are incredibly toxic and their poison is 1,200 times deadlier than cyanide!",
        "ecosystemRole": "Controls snail and crustacean populations.",
        "diet": "Clams, crabs, and sea urchins.",
        "size": "Size of a grapefruit.",
        "sound": "A squeaky gulping sound when inflating."
      },
      {
        "id": "pygmy-seahorse",
        "name": "Pygmy Seahorse",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-pygmy-seahorse.webp?v=15422462496722089847",
        "evolutionaryTrait": "Covered in tiny pink bumps that flawlessly mimic the natural texture of sea fans.",
        "funFact": "They are so unbelievably tiny that scientists didn't even know they existed until recently!",
        "ecosystemRole": "Micro-predator hiding inside gorgonian corals.",
        "diet": "Microscopic crustaceans.",
        "size": "Size of a grain of rice.",
        "sound": "Silent."
      },
      {
        "id": "reef-squid",
        "name": "Reef Squid",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-reef-squid.webp?v=11646332951886068891",
        "evolutionaryTrait": "Fins that run along their entire body let them gracefully hover like an underwater helicopter.",
        "funFact": "They can actually shoot themselves out of the water to escape angry predators!",
        "ecosystemRole": "Important food source for larger pelagic hunters.",
        "diet": "Small fish and tiny shrimp.",
        "size": "Length of an eggplant.",
        "sound": "Water jet blasts."
      },
      {
        "id": "sea-star",
        "name": "Sea Star",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-sea-star.webp?v=11194583987239034554",
        "evolutionaryTrait": "Can uniquely turn their stomach completely inside-out to digest food outside of their body.",
        "funFact": "They don't have blood; instead, they impressively pump ocean water right through their bodies!",
        "ecosystemRole": "Predator of slow-moving mollusks.",
        "diet": "Clams, oysters, and dead fish.",
        "size": "Size of a dinner plate.",
        "sound": "Silent creeping."
      },
      {
        "id": "sea-turtle",
        "name": "Sea Turtle",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-sea-turtle.webp?v=13709327461335207388",
        "evolutionaryTrait": "Salt glands near their eyes leak out extra ocean salt, looking like they are crying.",
        "funFact": "They remarkably return to the exact same beach where they were born to lay their own eggs!",
        "ecosystemRole": "Grazes on seagrass to keep it healthy.",
        "diet": "Seagrass, jellyfish, and sponges.",
        "size": "Size of a coffee table.",
        "sound": "Large breathing gasps at the surface."
      },
      {
        "id": "sea-urchin",
        "name": "Sea Urchin",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-sea-urchin.webp?v=11388844813153599674",
        "evolutionaryTrait": "Covered in painfully sharp spines specifically meant to deter anyone from taking a bite.",
        "funFact": "Their mouth is perfectly located underneath them and is called 'Aristotle's lantern'!",
        "ecosystemRole": "Crucial algae grazer keeping the coral clean.",
        "diet": "Algae covering rocks and coral.",
        "size": "Size of a tennis ball.",
        "sound": "Scratching against rock."
      },
      {
        "id": "seahorse",
        "name": "Seahorse",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-seahorse.webp?v=16335096469882525693",
        "evolutionaryTrait": "A prehensile tail built perfectly to wrap tightly around coral and seaweed stalks safely.",
        "funFact": "The devoted fathers actually get pregnant and give birth to thousands of tiny babies!",
        "ecosystemRole": "Ambushing microscopic prey in sea grass beds.",
        "diet": "Tiny shrimp and plankton.",
        "size": "Length of a pencil.",
        "sound": "Tiny clicking jaws."
      },
      {
        "id": "spotted-eagle-ray",
        "name": "Spotted Eagle Ray",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-spotted-eagle-ray.webp?v=12936588220850616530",
        "evolutionaryTrait": "A duck-like flattened snout perfectly designed for rooting around in sandy bottoms.",
        "funFact": "They are known to spectacular leap entirely out of the ocean and glide in the air!",
        "ecosystemRole": "Hard-shell crusher digging in the sand flats.",
        "diet": "Snails, clams, and hermit crabs.",
        "size": "Wingspan of a dining table.",
        "sound": "A swooping swish."
      },
      {
        "id": "spotted-jellyfish",
        "name": "Spotted Jellyfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-spotted-jellyfish.webp?v=13575605468597506965",
        "evolutionaryTrait": "They lack traditional tentacles and instead use ruffled oral arms to grab food.",
        "funFact": "They host algae inside them, so they swim up to the surface every day to get sunlight!",
        "ecosystemRole": "Filters floating plankton from the water column.",
        "diet": "Microscopic zooplankton and sunlight.",
        "size": "Size of a beach ball.",
        "sound": "Silent pulsing."
      },
      {
        "id": "tasselled-wobbegong-shark",
        "name": "Tasselled Wobbegong Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-tasselled-wobbegong-shark.webp?v=5985668062585550297",
        "evolutionaryTrait": "A spectacular fringe of beard-like flaps around their mouth breaks up their outline.",
        "funFact": "They are incredibly lazy hunters; they just sit on the bottom and wait for fish to swim into their mouth!",
        "ecosystemRole": "Master benthic ambush predator.",
        "diet": "Bottom-dwelling fish and octopuses.",
        "size": "Length of a human.",
        "sound": "Sudden snapping jaws."
      },
      {
        "id": "white-tip-reef-shark",
        "name": "White-tip Reef Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-white-tip-reef-shark.webp?v=13338620359843924002",
        "evolutionaryTrait": "A slender, incredibly flexible body tailored for wriggling deep into tight coral caves.",
        "funFact": "Unlike many sharks, they don't have to keep swimming to breathe; they can sleep on the sea floor!",
        "ecosystemRole": "Nighttime predator hunting inside coral crevices.",
        "diet": "Sleeping fish, octopuses, and crabs.",
        "size": "Length of a couch.",
        "sound": "A smooth, slicing swish."
      },
      {
        "id": "wobbegong-shark",
        "name": "Wobbegong Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-wobbegong-shark.webp?v=11577100117494611349",
        "evolutionaryTrait": "A remarkably flat body featuring detailed, carpet-like camouflage to perfectly match the reef floor.",
        "funFact": "They are incredibly flexible and can actually bite their own tail if someone grabs it!",
        "ecosystemRole": "Patient ambush predator of the lower reef.",
        "diet": "Fish, crabs, and even other smaller sharks.",
        "size": "Length of a human.",
        "sound": "A startling, sudden snap."
      },
      {
        "id": "yellow-boxfish",
        "name": "Yellow Boxfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/coralreef-yellow-boxfish.webp?v=12437761126209129369",
        "evolutionaryTrait": "A rigid, perfectly box-shaped skeleton made of fused bone plates acts as tough armor.",
        "funFact": "When stressed, they release a deadly soapy toxin from their skin into the water around them!",
        "ecosystemRole": "A strange, hovering browser of bottom-dwelling invertebrates.",
        "diet": "Sponges, worms, and small crustaceans.",
        "size": "Size of a coffee mug.",
        "sound": "A quiet, whirring flutter."
      }
    ]
  },
  {
    "id": "deep-sea",
    "name": "Deep Sea",
    "location": "Monterey Bay, California",
    "description": "A pitch-black, freezing cold world where the water pressure is heavy enough to crush a car. No sunlight reaches here, so animals create their own light.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/deepsea-monterey-bay-hero.webp?v=788237822326779029",
    "color": "bg-indigo-900",
    "facts": [
      {
        "title": "Bioluminescence",
        "content": "Up to 90% of deep-sea animals make their own glowing light to communicate, hunt, or hide in the pitch black.",
        "icon": "lightbulb"
      },
      {
        "title": "Crushing Pressure",
        "content": "The water pressure down here is so intense it’s like having an elephant standing on your thumb! Animals survive by having squishy, gelatinous bodies.",
        "icon": "waves"
      },
      {
        "title": "Marine Snow",
        "content": "Food is scarce, so many deep-sea creatures survive by eating 'marine snow'—tiny bits of dead plants and animals that slowly drift down from the surface.",
        "icon": "snowflake"
      },
      {
        "title": "Freezing Cold",
        "content": "The water temperature is constantly near freezing (around 39°F or 4°C), so life moves very slowly to conserve energy.",
        "icon": "thermometer-snowflake"
      }
    ],
    "animals": [
      {
        "id": "anglerfish",
        "name": "Anglerfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-anglerfish.webp?v=12581320052957694589",
        "evolutionaryTrait": "Extends a glowing, bacteria-filled 'fishing lure' from its head to attract curious prey in total darkness.",
        "funFact": "In some species, the male is tiny and physically merges with the female forever to share her bloodstream!",
        "ecosystemRole": "Ambush predator of the midnight zone.",
        "diet": "Fish and crustaceans.",
        "size": "Size of a teacup to a basketball.",
        "sound": "A sudden jaw snap."
      },
      {
        "id": "armhook-squid",
        "name": "Armhook Squid",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-armhook-squid.webp?v=5837134148146739376",
        "evolutionaryTrait": "Thick, muscular hooks instead of gentle suction cups on their arms for viciously gripping slippery prey.",
        "funFact": "They move incredibly fast in the dark, acting like deep-sea cheetahs!",
        "ecosystemRole": "Fast-moving midwater predator.",
        "diet": "Lanternfish and smaller squid.",
        "size": "Length of a human arm.",
        "sound": "Silent jetting."
      },
      {
        "id": "baby-lanternfish",
        "name": "Baby Lanternfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-lanternfish.webp?v=7800403547736528838",
        "evolutionaryTrait": "Small glowing dots that act like counter-illumination camouflage against the dim light from above.",
        "funFact": "They are part of the largest animal migration on Earth, swimming up to feed every single night!",
        "ecosystemRole": "Crucial food source for almost all larger deep-sea predators.",
        "diet": "Tiny zooplankton.",
        "size": "Size of a fingernail.",
        "sound": "Silent."
      },
      {
        "id": "barreleye-fish",
        "name": "Barreleye Fish",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-barreleye-fish.webp?v=10637931116242867150",
        "evolutionaryTrait": "A completely transparent, fluid-filled head that lets them literally look straight up through their own skull.",
        "funFact": "Their eyes are actually the glowing green tubes inside their head, not the spots on their face!",
        "ecosystemRole": "Visual predator scanning for silhouettes above.",
        "diet": "Jellyfish tentacles and small crustaceans.",
        "size": "Length of a dollar bill.",
        "sound": "A gentle flutter."
      },
      {
        "id": "comb-jelly",
        "name": "Comb Jelly",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-comb-jelly.webp?v=8962847560499512749",
        "evolutionaryTrait": "Rows of tiny beating hairs (cilia) that magically diffract light into rainbow lasers as they swim.",
        "funFact": "They don't sting like regular jellyfish; instead, they have sticky tentacles that act like flypaper catching prey!",
        "ecosystemRole": "Midwater filter feeder.",
        "diet": "Zooplankton and small fish larvae.",
        "size": "Size of a walnut to a football.",
        "sound": "Silent pulsing."
      },
      {
        "id": "corals",
        "name": "Corals",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-corals.webp?v=13322412113437309718",
        "evolutionaryTrait": "Deep-water species grow without any sunlight at all, relying entirely on catching drifting food in the dark.",
        "funFact": "Some of them can live to be over 4,000 years old, making them the oldest living animals on Earth!",
        "ecosystemRole": "Forms vital habitat structures on the barren sea floor.",
        "diet": "Falling marine snow and microscopic plankton.",
        "size": "Can form reefs miles long.",
        "sound": "Silent."
      },
      {
        "id": "deep-sea-amphipod",
        "name": "Deep Sea Amphipod",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-amphipod.webp?v=4478897703799689572",
        "evolutionaryTrait": "An incredibly tough, pressurized exoskeleton that allows them to survive the crushing depths of the abyss.",
        "funFact": "They are essentially giant, deep-sea versions of the tiny 'sand fleas' you might see hopping at the beach!",
        "ecosystemRole": "Essential benthic scavenger cleaning the sea floor.",
        "diet": "Dead fish, whale falls, and detritus.",
        "size": "Size of a potato.",
        "sound": "Tiny scurrying crunches."
      },
      {
        "id": "deep-sea-basket-star",
        "name": "Deep Sea Basket Star",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-basket-star.webp?v=1735253339978096196",
        "evolutionaryTrait": "Hundreds of wildly branching, curling arms that form a giant living net to catch falling debris.",
        "funFact": "If alarmed, they impressively curl up into a tightly bound ball that looks exactly like a tumbleweed!",
        "ecosystemRole": "Benthic suspension feeder catching marine snow.",
        "diet": "Zooplankton and detritus.",
        "size": "Arm span of a hula hoop.",
        "sound": "Silent uncoiling."
      },
      {
        "id": "deep-sea-brittle-star",
        "name": "Deep Sea Brittle Star",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-brittle-star.webp?v=10099545010852864612",
        "evolutionaryTrait": "Long, fragile-looking, whip-like arms that easily snap off if a predator bites them so they can crawl away fast.",
        "funFact": "They move by practically walking on their five fast-moving arms, instead of sliding like regular starfish!",
        "ecosystemRole": "Scavenger and deep-sea cleanup crew.",
        "diet": "Marine snow and tiny carcasses.",
        "size": "Size of a dinner plate.",
        "sound": "Faint rustling on the sand."
      },
      {
        "id": "deep-sea-crab",
        "name": "Deep Sea Crab",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-crab.webp?v=12365488605860001707",
        "evolutionaryTrait": "Spiky, heavily armored shells specifically designed to protect them from larger deep-water squids and octopuses.",
        "funFact": "Some use their fuzzy claws to farm bacteria near hot underwater vents like little chemical farmers!",
        "ecosystemRole": "Omnivorous scavenger of the abyss.",
        "diet": "Almost anything they can find.",
        "size": "Size of a dinner plate.",
        "sound": "Loud, clicking claws."
      },
      {
        "id": "deep-sea-grenadier-fish",
        "name": "Deep Sea Grenadier Fish",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-grenadier-fish.webp?v=611596354469539125",
        "evolutionaryTrait": "A highly sensitive, elongated tail shaped like a rat's tail that feels for faint water movements behind them.",
        "funFact": "They are commonly nicknamed 'rattails' and are one of the most abundant deep-sea bottom fish!",
        "ecosystemRole": "Abyssal predator controlling bottom-dweller populations.",
        "diet": "Small crustaceans and squid.",
        "size": "Length of a baseball bat.",
        "sound": "A low drumming sound using their swim bladder."
      },
      {
        "id": "deep-sea-shrimp",
        "name": "Deep Sea Shrimp",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-shrimp.webp?v=10198645321889519938",
        "evolutionaryTrait": "Can aggressively vomit out a brilliant cloud of glowing blue slime to utterly blind predators and escape.",
        "funFact": "Their dark red color actually makes them completely invisible in the deep sea because red light doesn't reach down there!",
        "ecosystemRole": "Crucial link in the deep sea food web.",
        "diet": "Marine snow and tiny zooplankton.",
        "size": "Length of a finger.",
        "sound": "A sudden swooshing escape."
      },
      {
        "id": "deep-sea-siphonophore",
        "name": "Deep Sea Siphonophore",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-siphonophore.webp?v=6157865652649569755",
        "evolutionaryTrait": "It’s not one animal, but actually a massive colony of thousands of tiny clones constantly working together like a ship.",
        "funFact": "Some species can reach lengths of over 150 feet, making them longer than a blue whale!",
        "ecosystemRole": "Drifting net filtering out zooplankton.",
        "diet": "Small fish and crustaceans.",
        "size": "Can grow longer than a school bus.",
        "sound": "Silent drifting."
      },
      {
        "id": "deep-sea-cucumber",
        "name": "Deep-Sea Cucumber",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-deep-sea-cucumber.webp?v=5177519561011202133",
        "evolutionaryTrait": "A totally transparent, gelatinous body that lets them float just above the muddy bottom like a jelly ghost.",
        "funFact": "They roam the mud like slow, glowing underwater roombas, eating absolute garbage and leaving clean trails!",
        "ecosystemRole": "Recycles nutrients resting on the sea floor.",
        "diet": "Mud mixed with dead organic matter.",
        "size": "Length of a zucchini.",
        "sound": "A quiet squelch."
      },
      {
        "id": "deep-sea-jellyfish",
        "name": "Deep-Sea Jellyfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-jellyfish.webp?v=11249582878522112503",
        "evolutionaryTrait": "Dazzling bioluminescent displays surrounding the bell designed perfectly to startle attackers or signal for help.",
        "funFact": "Some can actually swim backwards if they accidentally crash into something in the dark!",
        "ecosystemRole": "Soft-bodied predator of the midnight zone.",
        "diet": "Tiny crustaceans and other jellies.",
        "size": "Size of a dinner plate.",
        "sound": "Silent pulsing."
      },
      {
        "id": "deep-sea-snailfish",
        "name": "Deep-Sea Snailfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-deep-sea-snailfish.webp?v=7585356793158794915",
        "evolutionaryTrait": "They lack normal bones and scales entirely, evolving squishy gelatin bodies to withstand the most extreme crushing depths.",
        "funFact": "They are officially the deepest known living fish in the entire world, found almost 5 miles down!",
        "ecosystemRole": "Apex predator of the ultra-deep hadal zone trenches.",
        "diet": "Small crustaceans floating in trenches.",
        "size": "Length of a ruler.",
        "sound": "Silent wiggles."
      },
      {
        "id": "deepstaria-jelly",
        "name": "Deepstaria Jelly",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-deepstaria-jelly.webp?v=10277215270603559976",
        "evolutionaryTrait": "A giant, incredibly thin, bag-like bell shaped perfectly to close like a giant sack around trapped prey.",
        "funFact": "They don't even have stinging tentacles; they literally just envelope you like a floating ghost sheet!",
        "ecosystemRole": "Engulfing predator of the midwater column.",
        "diet": "Small fish and crustaceans.",
        "size": "Size of a large umbrella.",
        "sound": "A gentle waft."
      },
      {
        "id": "dumbo-octopus",
        "name": "Dumbo Octopus",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-dumbo-octopus.webp?v=18106514274662053062",
        "evolutionaryTrait": "Two incredibly cute ear-like fins on their head that they flap simultaneously to awkwardly flutter through the water.",
        "funFact": "They are the deepest living octopus in the ocean, found cheerfully flapping miles down in total darkness!",
        "ecosystemRole": "Benthic forager floating above the mud.",
        "diet": "Snails, worms, and tiny crustaceans.",
        "size": "Size of a large grapefruit.",
        "sound": "Silent flapping."
      },
      {
        "id": "frilled-shark",
        "name": "Frilled Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-frilled-shark.webp?v=4638251423241270457",
        "evolutionaryTrait": "A terrifying mouthful of 300 tri-pointed, needle-sharp teeth perfectly designed to snatch slippery squid.",
        "funFact": "They swim fiercely by wriggling their body just like an eel instead of swimming like a normal shark!",
        "ecosystemRole": "Ancient deep-water ambush predator.",
        "diet": "Mainly deep-sea squid and octopus.",
        "size": "Length of a tall human.",
        "sound": "A surprisingly speedy swoosh."
      },
      {
        "id": "giant-larvacean",
        "name": "Giant Larvacean",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-giant-larvacean.webp?v=16365423746075837774",
        "evolutionaryTrait": "Secretes an enormous, intricate 'snot palace' around itself to perfectly filter out tiny bits of drifting food.",
        "funFact": "When their mucus house gets clogged with trash, they literally just swim out and build a brand new one!",
        "ecosystemRole": "Essential marine snow creator when they abandon their 'houses.'",
        "diet": "Microscopic drifting particles.",
        "size": "Their 'house' can be the size of an armchair.",
        "sound": "Silent."
      },
      {
        "id": "glass-squid",
        "name": "Glass Squid",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-glass-squid.webp?v=3215251355751021932",
        "evolutionaryTrait": "A completely transparent, glass-like body with only their strange eyeballs and a single glowing organ visible.",
        "funFact": "Normally they float completely upside down like an umbrella floating in a creepy dream!",
        "ecosystemRole": "Midwater prey species relying intensely on invisibility.",
        "diet": "Tiny crustaceans and zooplankton.",
        "size": "Length of a cucumber.",
        "sound": "Silent."
      },
      {
        "id": "goblin-shark",
        "name": "Goblin Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-goblin-shark.webp?v=6946744889586520895",
        "evolutionaryTrait": "Nightmarish terrifying jaws that can violently shoot entirely forward out of its mouth to snag passing fish.",
        "funFact": "They have a super weird, long, flat nose specifically packed with electrical sensors to feel hidden prey in the dark!",
        "ecosystemRole": "Slow-moving benthic predator.",
        "diet": "Squid, crabs, and bottom fish.",
        "size": "Length of a small car.",
        "sound": "A sudden, snapping crunch."
      },
      {
        "id": "isopod",
        "name": "Isopod",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-isopod.webp?v=186378883235639519",
        "evolutionaryTrait": "Due to a weird deep-sea rule called 'abyssal gigantism,' they evolved to grow huge instead of pill-bug tiny.",
        "funFact": "They can gorge themselves so heavily on a dead whale that they actually forget how to walk and just roll over!",
        "ecosystemRole": "The ultimate scavenger of the sea floor.",
        "diet": "Dead fish, whale meat, and carrion.",
        "size": "Size of a football.",
        "sound": "Scurrying clicking legs."
      },
      {
        "id": "jellyfish-larvae",
        "name": "Jellyfish Larvae",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-jellyfish-larvae.webp?v=11950462266521936905",
        "evolutionaryTrait": "Start life entirely as tiny, hairy specks floating invisibly among the plankton to avoid any attention.",
        "funFact": "Some settle on rocks and literally clone off dozens of tiny baby jellyfish like a factory line!",
        "ecosystemRole": "Food source for filter feeders before they grow.",
        "diet": "Microscopic plankton.",
        "size": "Size of a grain of sand.",
        "sound": "Silent."
      },
      {
        "id": "lanternfish",
        "name": "Lanternfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-lanternfish.webp?v=7800403547736528838",
        "evolutionaryTrait": "Stomach full of glowing photophores on their belly perfectly match the faint light coming from the surface.",
        "funFact": "They are arguably the most common fish on the entire actual planet, numbering in the multi-quadrillions!",
        "ecosystemRole": "The primary food source driving the entire deep sea ecosystem.",
        "diet": "Tiny crustaceans and zooplankton.",
        "size": "Length of a finger.",
        "sound": "A quiet glimmering swish."
      },
      {
        "id": "pelican-eel",
        "name": "Pelican Eel",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-pelican-eel.webp?v=13950532857678007951",
        "evolutionaryTrait": "A massive, scoop-like mouth resembling a pelican's pouch built to swallow gigantic prey much larger than itself.",
        "funFact": "At the very tip of their weirdly long, whip-like tail is a tiny glowing pink light to lure in a snack!",
        "ecosystemRole": "Midwater engulfing predator.",
        "diet": "Fish, crustaceans, and squid.",
        "size": "Length of a baseball bat.",
        "sound": "A huge, silent gulp."
      },
      {
        "id": "sea-anemone",
        "name": "Sea Anemone",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-sea-anemone.webp?v=12489689400161328501",
        "evolutionaryTrait": "Sticky tentacles armed with harpoon-like stinging cells flawlessly designed to snag passing swimmers in the dark.",
        "funFact": "Some uniquely ride around on the backs of deep-sea hermit crabs like living bodyguards!",
        "ecosystemRole": "Benthic ambush predator.",
        "diet": "Small fish and plankton.",
        "size": "Size of a teacup.",
        "sound": "Silent swaying."
      },
      {
        "id": "sea-pig",
        "name": "Sea Pig",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-sea-pig.webp?v=12052886115756579313",
        "evolutionaryTrait": "Fleshy legs filled with water allow these adorable strange blobs to slowly, carefully walk across the muddy floor.",
        "funFact": "They often face directly entirely into the deep ocean currents by the thousands to sniff out the best muddy food!",
        "ecosystemRole": "Mud-scouring vacuum cleaner.",
        "diet": "Detritus settling on the sea floor.",
        "size": "Size of a potato.",
        "sound": "A squishy stomp."
      },
      {
        "id": "sea-spider",
        "name": "Sea Spider",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-sea-spider.webp?v=5413682299681119037",
        "evolutionaryTrait": "Legs so long and incredibly thin that they actually have to hold their internal organs entirely inside their legs!",
        "funFact": "They are technically not spiders at all, but rather bizarre ancient marine arthropods perfectly built for the dark!",
        "ecosystemRole": "Slow predator that sucks juices from soft-bodied animals.",
        "diet": "Sea anemones and sponges.",
        "size": "Leg span of a dinner plate.",
        "sound": "Spooky silent creeping."
      },
      {
        "id": "shrimps",
        "name": "Shrimps",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-shrimp.webp?v=10198645321889519938",
        "evolutionaryTrait": "Some blind deep-water species have evolved specialized bacteria on their shells just to survive toxic deep-sea vents.",
        "funFact": "They casually hang out in boiling hot water that would cook a normal shrimp in seconds!",
        "ecosystemRole": "Scavenger and prey item.",
        "diet": "Marine snow and dead organisms.",
        "size": "Size of a thumb.",
        "sound": "Tiny clicks."
      },
      {
        "id": "silky-jelly",
        "name": "Silky Jelly",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-silky-jelly.webp?v=15684463057440788386",
        "evolutionaryTrait": "An intricately ruffled bell beautifully glowing with purple bioluminescence to confuse deep sea predators.",
        "funFact": "They casually float through the freezing pitch black without a brain, heart, or even real eyes!",
        "ecosystemRole": "Midwater pelagic predator.",
        "diet": "Tiny crustaceans and other smaller jellies.",
        "size": "Size of a dinner plate.",
        "sound": "Silent wave."
      },
      {
        "id": "squid",
        "name": "Squid",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-squid-ink.webp?v=16541141757584547909",
        "evolutionaryTrait": "Giant eyes precisely engineered to capture every single photon of light existing in the deep ocean.",
        "funFact": "Some can release a thick glowing ink cloud to completely dazzle hungry predators instead of blinding them!",
        "ecosystemRole": "Lightning-fast midwater predator.",
        "diet": "Fish and smaller squids.",
        "size": "Length of a forearm.",
        "sound": "A sudden jetting blast."
      },
      {
        "id": "starfish",
        "name": "Starfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-starfish.webp?v=5053245768439849828",
        "evolutionaryTrait": "A remarkable ability to regenerate ripped off arms, which is highly useful when crabs try to take a bite.",
        "funFact": "In the deep ocean, some species actually glow a neon green color if you poke them in the dark!",
        "ecosystemRole": "Benthic predator of mussels and slow-moving creatures.",
        "diet": "Dead fish and small invertebrates.",
        "size": "Size of a small pizza.",
        "sound": "Silent slinking."
      },
      {
        "id": "strawberry-squid",
        "name": "Strawberry Squid",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-strawberry-squid.webp?v=3717057091423589139",
        "evolutionaryTrait": "Mismatched eyes—one huge bright yellow eye looking up for shadows, and one tiny eye looking down for glowing spots.",
        "funFact": "It got its funny nickname because its red body is completely covered in tiny glowing bumps like strawberry seeds!",
        "ecosystemRole": "Twilight zone midwater predator.",
        "diet": "Fish and crustaceans.",
        "size": "Length of a cucumber.",
        "sound": "Silent."
      },
      {
        "id": "vampire-squid",
        "name": "Vampire Squid",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-vampire-squid.webp?v=17541761328310041051",
        "evolutionaryTrait": "A terrifying dark red cloak of webbing perfectly connects its arms, giving it a spooky vampire look.",
        "funFact": "They don't drink blood! They actually just peacefully eat falling 'marine snow' using two sticky threads!",
        "ecosystemRole": "Peaceful detritivore of the dark zone.",
        "diet": "Marine snow (dead plankton and detritus).",
        "size": "Size of a football.",
        "sound": "Silent gliding."
      },
      {
        "id": "whiptail-gulper-eel",
        "name": "Whiptail Gulper Eel",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-whiptail-gulper-eel.webp?v=17595712581202882955",
        "evolutionaryTrait": "An incredibly skinny tail completely ending in a bioluminescent glowing red light intended to attract curious snacks.",
        "funFact": "They can literally tie their long, skinny body entirely into knots to squirm out of dangerous spots!",
        "ecosystemRole": "Midwater engulfing predator.",
        "diet": "Squid, crustaceans, and fish.",
        "size": "Length of a broomstick.",
        "sound": "A quiet thrashing."
      },
      {
        "id": "sea-butterfly",
        "name": "Sea Butterfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/deepsea-sea-butterfly.webp?v=2674605874575884412",
        "evolutionaryTrait": "Snail that evolved flipper-like wings to delicately flutter through the open ocean.",
        "funFact": "They are completely transparent and build huge gooey webs to catch falling marine snow!",
        "ecosystemRole": "Vital prey for larger pelagic animals.",
        "diet": "Microscopic plankton.",
        "size": "Size of a pea.",
        "sound": "Silent."
      }
    ]
  },
  {
    "id": "fynbos",
    "name": "Fynbos",
    "location": "Cape Floristic Region, South Africa",
    "description": "A unique scrubland that features more plant species than almost anywhere else. Wildfires help release seeds, and life recovers fast.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-hero.webp?v=5260318349968356457",
    "color": "bg-pink-500",
    "facts": [
      {
        "title": "Fire Dependency",
        "content": "Many Fynbos plants actually need wildfires to survive! The heat from fires cracks open their hard seed pods to start a new generation.",
        "icon": "flame"
      },
      {
        "title": "Incredible Diversity",
        "content": "The Cape Floral Kingdom is the smallest of the world's six floral kingdoms, but it is the richest per square area with over 9,000 plant species!",
        "icon": "flower2"
      },
      {
        "title": "Nutrient-Poor Soil",
        "content": "The soil here is incredibly sandy and lacks nutrients. Plants evolved special roots to extract every tiny drop of sustenance, and animals follow suit.",
        "icon": "mountain"
      },
      {
        "title": "Endemic Haven",
        "content": "Almost 70% of the plants found in the Fynbos grow absolutely nowhere else on the entire planet!",
        "icon": "globe"
      }
    ],
    "animals": [
      {
        "id": "african-striped-weasel",
        "name": "African Striped Weasel",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-african-striped-weasel.webp?v=10256750722086554189",
        "evolutionaryTrait": "A long, slender body designed for effortlessly squeezing into narrow rodent burrows.",
        "funFact": "When threatened, they can release a foul-smelling liquid to deter predators, much like a skunk!",
        "ecosystemRole": "Controls populations of small rodents and insects.",
        "diet": "Mice, rats, insects, and small birds.",
        "size": "Length of a ruler.",
        "sound": "High-pitched squeaks and warning growls."
      },
      {
        "id": "angulate-tortoise",
        "name": "Angulate Tortoise",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-angulate-tortoise.webp?v=5177479746268446638",
        "evolutionaryTrait": "A thickened front shell extension ('gular scute') used by males as a weapon in fierce pushing battles.",
        "funFact": "They are the only strictly endemic tortoise to southern Africa!",
        "ecosystemRole": "Herbivore that aids in dispersing seeds across the Fynbos.",
        "diet": "Tough grasses, succulents, and seasonal wildflowers.",
        "size": "Length of a dinner plate.",
        "sound": "Hissing when startled."
      },
      {
        "id": "bontebok",
        "name": "Bontebok",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-bontebok.webp?v=9016874362542981026",
        "evolutionaryTrait": "Vibrant, starkly contrasting purple-brown and white coloration serves as a striking visual signal to their herd.",
        "funFact": "They were once hunted nearly to extinction, but a single historic farm saved the entire species!",
        "ecosystemRole": "Grazing herbivore that manages grass height.",
        "diet": "Short grasses of the coastal Fynbos.",
        "size": "Size of a large pony.",
        "sound": "Grunts and snorts."
      },
      {
        "id": "cape-cobra",
        "name": "Cape Cobra",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-cobra.webp?v=13518888716353660002",
        "evolutionaryTrait": "Highly potent neurotoxic venom that quickly immobilizes fast-moving Fynbos rodents and birds.",
        "funFact": "They are incredible climbers and frequently raid sociable weaver bird nests high up in trees!",
        "ecosystemRole": "Apex snake predator controlling rodent and bird populations.",
        "diet": "Rodents, birds, toads, and other snakes.",
        "size": "Length of an adult human.",
        "sound": "A sharp, warning hiss."
      },
      {
        "id": "cape-dwarf-gecko",
        "name": "Cape Dwarf Gecko",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-dwarf-gecko.webp?v=10976192343048299289",
        "evolutionaryTrait": "Microscopic hairs on their toe pads act like a dry adhesive, allowing them to perfectly grip smooth Fynbos leaves.",
        "funFact": "They lack eyelids! Instead, they possess a clear scale over their eye which they clean by licking it.",
        "ecosystemRole": "Micro-predator that limits tiny insect numbers.",
        "diet": "Small insects and spiders.",
        "size": "Length of a pinky finger.",
        "sound": "Soft clicking sounds."
      },
      {
        "id": "cape-fox",
        "name": "Cape Fox",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-fox.webp?v=8082467208747224597",
        "evolutionaryTrait": "Enlarged ears provide excellent hearing for detecting the faintest rustle of mice in the thick brush.",
        "funFact": "It is the only true fox species found in the southern part of Africa!",
        "ecosystemRole": "Nocturnal mesopredator keeping rodent numbers in check.",
        "diet": "Mice, insects, and wild fruits.",
        "size": "Size of a small house cat.",
        "sound": "High-pitched yelps and barks."
      },
      {
        "id": "cape-grassbird",
        "name": "Cape Grassbird",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-grassbird.webp?v=4059155593771250198",
        "evolutionaryTrait": "A long, floppy tail and strong legs designed for clambering through extremely dense, reedy Fynbos vegetation.",
        "funFact": "They frequently sing their beautiful, cascading song from the absolute highest tip of a bush!",
        "ecosystemRole": "Insect eater specific to thick, low-lying scrub.",
        "diet": "Insects and spiders.",
        "size": "Length of a pencil.",
        "sound": "A melodic, trilling song."
      },
      {
        "id": "cape-grey-mongoose",
        "name": "Cape Grey Mongoose",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-grey-mongoose.webp?v=3773317908089262922",
        "evolutionaryTrait": "A sleek, elongated body offering immense agility for violently thrashing venomous snakes during combat.",
        "funFact": "They have special thick skin and quick reflexes that make them highly resistant to snake bites!",
        "ecosystemRole": "Active daytime predator of small mammals and reptiles.",
        "diet": "Mice, reptiles, insects, and birds.",
        "size": "Length of a man's forearm.",
        "sound": "Churrs and warning growls."
      },
      {
        "id": "cape-grysbok",
        "name": "Cape Grysbok",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-grysbok.webp?v=15614047840118048955",
        "evolutionaryTrait": "A hunched posture and reddish-brown coat speckled with white, providing perfect camouflage in dense shrubland.",
        "funFact": "When frightened, they will dramatically drop to the ground and play dead instead of running!",
        "ecosystemRole": "Small browsing herbivore shaping plant growth.",
        "diet": "Leaves, buds, and fruits of Fynbos shrubs.",
        "size": "Size of a large dog.",
        "sound": "Usually silent, occasional grunts."
      },
      {
        "id": "cape-leopard-toad",
        "name": "Cape Leopard Toad",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-mountain-leopard-toad.webp?v=3212657578534551574",
        "evolutionaryTrait": "Striking, leopard-like reddish-brown spots with yellow borders offering disruptive camouflage on the forest floor.",
        "funFact": "They are huge! Some females can grow to be as big as a dinner plate.",
        "ecosystemRole": "Amphibious apex predator of insects.",
        "diet": "Snails, beetles, and other large insects.",
        "size": "Size of a large grapefruit.",
        "sound": "A deep, snoring croak."
      },
      {
        "id": "cape-longclaw",
        "name": "Cape Longclaw",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-longclaw.webp?v=17672441783051730424",
        "evolutionaryTrait": "Extraordinarily long hind claws developed specifically for walking over soft, thick grass without sinking.",
        "funFact": "In flight, they utter a bright, distinct call that sounds exactly like a referee's whistle!",
        "ecosystemRole": "Ground-foraging insectivore in open Fynbos.",
        "diet": "Insects and occasionally seeds.",
        "size": "Size of a plump thrush.",
        "sound": "A mewing 'mew' and a whistling call."
      },
      {
        "id": "cape-mole-rat",
        "name": "Cape Mole-rat",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-mole-rat.webp?v=13207970993285560003",
        "evolutionaryTrait": "Massive, protruding front teeth used as heavy-duty excavators to dig tunnels without getting dirt in their mouths.",
        "funFact": "They are almost entirely blind but use seismic vibrations to communicate through the soil!",
        "ecosystemRole": "Crucial soil aerator and root unearther.",
        "diet": "Underground bulbs, tubers, and roots.",
        "size": "Size of a guinea pig.",
        "sound": "Soft grunts and squeaks."
      },
      {
        "id": "cape-mountain-zebra",
        "name": "Cape Mountain Zebra",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-mountain-zebra.webp?v=15468299105316150058",
        "evolutionaryTrait": "Exceptionally hard, fast-growing hooves specifically adapted for climbing rocky, mountainous Fynbos slopes.",
        "funFact": "They have a distinctive 'gridiron' pattern of black stripes right across their rump!",
        "ecosystemRole": "Large grazer maintaining grassland diversity.",
        "diet": "Tough mountain grasses.",
        "size": "Smaller than plains zebras, pony-sized.",
        "sound": "High-pitched whinnies and alarm snorts."
      },
      {
        "id": "cape-porcupine",
        "name": "Cape Porcupine",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-porcupine.webp?v=6732164163354213922",
        "evolutionaryTrait": "A formidable crest of black and white hollow quills they rattle loudly and ram into attackers in self-defense.",
        "funFact": "They are the largest rodent in Southern Africa and can powerfully dig up massive roots!",
        "ecosystemRole": "Modifies the landscape by extensive foraging and digging.",
        "diet": "Bulbs, tubers, roots, and bark.",
        "size": "Size of a medium-large dog.",
        "sound": "Grunts, snuffles, and rattling quills."
      },
      {
        "id": "cape-rock-thrush",
        "name": "Cape Rock-thrush",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-rock-thrush.webp?v=17741128923494299385",
        "evolutionaryTrait": "A striking slate-blue head and bright orange belly acting as visual territorial flags on barren rocky outcrops.",
        "funFact": "They love to perch confidently on the absolute highest boulders to survey their entire rocky kingdom!",
        "ecosystemRole": "Insectivorous bird of rocky Fynbos ridges.",
        "diet": "Insects, small frogs, and occasional berries.",
        "size": "Size of a standard thrush.",
        "sound": "A melodic, ringing whistle."
      },
      {
        "id": "cape-rockjumper",
        "name": "Cape Rockjumper",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-rockjumper.webp?v=4150199225669162870",
        "evolutionaryTrait": "Muscular legs perfectly adapted for agilely leaping and bounding between giant sandstone boulders.",
        "funFact": "They mostly refuse to fly! They much prefer hopping quickly across the craggy mountain tops.",
        "ecosystemRole": "Specialized ground predator in high altitude Fynbos.",
        "diet": "Insects, spiders, and small lizards.",
        "size": "Bigger than a robin.",
        "sound": "A loud, shrill whistling call."
      },
      {
        "id": "cape-siskin",
        "name": "Cape Siskin",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-siskin.webp?v=18209197063255895005",
        "evolutionaryTrait": "A precisely pointed, conical beak specifically evolved to flawlessly extract tiny seeds from tough Fynbos seedpods.",
        "funFact": "They always build incredibly well-hidden little nests tucked deeply inside prickly Fynbos bushes!",
        "ecosystemRole": "Seed disperser and consumer.",
        "diet": "Fynbos seeds and small insects.",
        "size": "Size of a sparrow.",
        "sound": "A sweet, twittering song."
      },
      {
        "id": "cape-sugarbird",
        "name": "Cape Sugarbird",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-sugarbird.webp?v=13951854000618276830",
        "evolutionaryTrait": "A ridiculously long, gracefully curved beak perfectly shaped to drill into deep Protea flowers for nectar.",
        "funFact": "Males have absurdly long, ribbon-like tail feathers they flutter wildly to attract a mate!",
        "ecosystemRole": "Primary pollinator of giant Protea flowers.",
        "diet": "Nectar and small flying insects.",
        "size": "Length of a ruler (including tail).",
        "sound": "A harsh, grating 'chack' sound."
      },
      {
        "id": "cape-white-eye",
        "name": "Cape White-eye",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-white-eye.webp?v=14406687085214618515",
        "evolutionaryTrait": "A glaringly bright white ring of feathers around their eyes that helps the flock stay together in dense foliage.",
        "funFact": "They are hyperactive acrobats, often hanging completely upside down to pick bugs off leaves!",
        "ecosystemRole": "Canopy insectivore and pollinator.",
        "diet": "Insects, nectar, and small fruits.",
        "size": "Barely larger than a thumb.",
        "sound": "A constantly peeping, sweet trill."
      },
      {
        "id": "caracal",
        "name": "Caracal",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-caracal.webp?v=5165983752629225147",
        "evolutionaryTrait": "Powerful, spring-loaded hind legs capable of launching them 10 feet straight into the air to swat birds in flight.",
        "funFact": "Their name comes from a Turkish word meaning 'black ear,' thanks to their stunning black ear-tufts!",
        "ecosystemRole": "Apex predator of the Fynbos shrublands.",
        "diet": "Rodents, birds, and small antelope.",
        "size": "Size of a medium-large dog.",
        "sound": "Hisses, purrs, and a leopard-like cough."
      },
      {
        "id": "chacma-baboon",
        "name": "Chacma Baboon",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-chacma-baboon.webp?v=11949408724250841169",
        "evolutionaryTrait": "Incredibly versatile hands and a complex brain allowing them to easily forage everything from roots to shellfish.",
        "funFact": "They are one of the largest monkeys in the world and have impressively huge, dog-like fangs!",
        "ecosystemRole": "Omnivorous generalist and seed disperser.",
        "diet": "Roots, insects, fruits, and small animals.",
        "size": "Size of a large dog.",
        "sound": "Loud, booming 'wahoo' barks."
      },
      {
        "id": "common-duiker",
        "name": "Common Duiker",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-common-duiker.webp?v=14222064349780529226",
        "evolutionaryTrait": "A sleek, arched back explicitly meant for aggressively diving straight into thick bushes to escape (duiker means 'diver').",
        "funFact": "They have a shockingly varied diet and will even eat caterpillars or carrion if they need to!",
        "ecosystemRole": "Solitary, evasive browser.",
        "diet": "Leaves, shoots, fruits, and seeds.",
        "size": "Size of a medium dog.",
        "sound": "A snorting alarm whistle."
      },
      {
        "id": "fynbos-buttonquail",
        "name": "Fynbos Buttonquail",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-fynbos-buttonquail.webp?v=3670956567602392202",
        "evolutionaryTrait": "Perfectly mottled brown and grey feathers allowing them to completely vanish against Fynbos soil.",
        "funFact": "The females are actually more brightly colored than the males, and the males incubate the eggs entirely alone!",
        "ecosystemRole": "Ground-dwelling seed and insect eater.",
        "diet": "Seeds and ground insects.",
        "size": "Size of a plump field mouse.",
        "sound": "A low, booming 'hoooo'."
      },
      {
        "id": "fynbos-golden-mole",
        "name": "Fynbos Golden Mole",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-fynbos-golden-mole.webp?v=16920416603268808116",
        "evolutionaryTrait": "Iridescent, completely frictionless fur that dramatically reduces drag as they 'swim' rapidly through loose sandy soil.",
        "funFact": "They have beautifully shiny coats that gleam green and purple, and absolutely no visible eyes!",
        "ecosystemRole": "Underground insectivore controlling soil invertebrates.",
        "diet": "Earthworms, insect larvae, and bugs.",
        "size": "Length of a computer mouse.",
        "sound": "Mostly silent, faint squeaks."
      },
      {
        "id": "grey-rhebok",
        "name": "Grey Rhebok",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-grey-rhebok.webp?v=10838827729676279318",
        "evolutionaryTrait": "Uniquely thick, woolly grey fur acting as incredible insulation against freezing, high-altitude Fynbos winds.",
        "funFact": "The famous sportswear brand 'Reebok' is actually named directly after this speedy antelope!",
        "ecosystemRole": "High-altitude mountain grazer.",
        "diet": "Grasses and leafy Fynbos shrubs.",
        "size": "Size of a large dog.",
        "sound": "A sharp, coughing alarm snort."
      },
      {
        "id": "ground-woodpecker",
        "name": "Ground Woodpecker",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-ground-woodpecker.webp?v=15403817973647162472",
        "evolutionaryTrait": "A woodpecker that totally abandoned trees! Evolved strong legs for hopping directly over Fynbos boulders.",
        "funFact": "They nest in deep tunnels they specifically excavate into the dirt banks of rivers instead of trees!",
        "ecosystemRole": "Ground-dwelling ant specialist.",
        "diet": "Ants and termite pupae.",
        "size": "Size of a dove.",
        "sound": "A harsh, screaming 'kheerrr'."
      },
      {
        "id": "jackal-buzzard",
        "name": "Jackal Buzzard",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-jackal-buzzard.webp?v=7507911008794367476",
        "evolutionaryTrait": "Broad, powerful wings effortlessly designed to infinitely ride the strong updrafts rising heavily off mountain cliffs.",
        "funFact": "It earns its unique name because its echoing call perfectly mimics the howling of a black-backed jackal!",
        "ecosystemRole": "Lifts thermal currents to strictly hunt rodents.",
        "diet": "Mice, moles, lizards, and small birds.",
        "size": "Wingspan of a large eagle.",
        "sound": "A sharp, yelping 'weeeoh'."
      },
      {
        "id": "malachite-sunbird",
        "name": "Malachite Sunbird",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-malachite-sunbird.webp?v=920491778692651557",
        "evolutionaryTrait": "Males boast an incredibly brilliant metallic green color that violently flashes in the sun to fiercely defend territory.",
        "funFact": "When not mating, the males actually lose their bright green feathers and turn completely dull brown!",
        "ecosystemRole": "Highly aggressive pollinator of tubular Fynbos flowers.",
        "diet": "Nectar and small flying insects.",
        "size": "Length of a sparrow.",
        "sound": "A sharp, metallic 'tseep'."
      },
      {
        "id": "micro-frog",
        "name": "Micro Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-micro-frog.webp?v=14228902638789020477",
        "evolutionaryTrait": "Incredibly tiny size allowing them to safely hide effectively in the smallest trickles of Fynbos black-water.",
        "funFact": "They are amongst the smallest strictly locally-restricted amphibian species entirely in the world!",
        "ecosystemRole": "Microscopic insect predator.",
        "diet": "Tiny flies and mosquitoes.",
        "size": "Smaller than a thumbnail.",
        "sound": "A scratchy, insect-like chirp."
      },
      {
        "id": "mole-snake",
        "name": "Mole Snake",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-mole-snake-2.webp?v=9011818017682467946",
        "evolutionaryTrait": "A sharply pointed snout powerfully reinforced with bone perfectly built for forcefully tunneling through hard dirt.",
        "funFact": "They are completely non-venomous but have an incredibly fierce bite entirely capable of fighting off dogs!",
        "ecosystemRole": "Subterranean predator controlling mole-rat populations.",
        "diet": "Mole-rats, mice, and bird eggs.",
        "size": "Length of an adult human.",
        "sound": "Aggressive, loud hissing."
      },
      {
        "id": "mountain-pride-butterfly",
        "name": "Mountain Pride Butterfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-mountain-pride-butterfly.webp?v=434902345319353787",
        "evolutionaryTrait": "Brightly colored orange wings acting exclusively to brilliantly signal specifically to mates across wide mountain valleys.",
        "funFact": "They exclusively lay their eggs entirely on one specific type of mountain Fynbos plant and nothing else!",
        "ecosystemRole": "Pollinator tied to specialized flora.",
        "diet": "Nectar from specific Fynbos orchids.",
        "size": "Wingspan of a teacup.",
        "sound": "Silent fluttering."
      },
      {
        "id": "orange-breasted-sunbird",
        "name": "Orange-breasted Sunbird",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-orange-breasted-sunbird.webp?v=32737575958903859",
        "evolutionaryTrait": "A deeply curved bill evolutionarily matched completely perfectly to the specific curve of Erica flower tubes.",
        "funFact": "They are exclusively distinctly endemic purely to Fynbos and literally cannot gracefully exist gracefully gracefully anywhere else!",
        "ecosystemRole": "Essential endemic pollinator of Fynbos Ericas.",
        "diet": "Erica nectar and small spiders.",
        "size": "Length of a sparrow.",
        "sound": "A twanging, metallic 'tchu-tchu'."
      },
      {
        "id": "rock-hyrax",
        "name": "Rock Hyrax",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-rock-hyrax-dassie.webp?v=3217589571845771909",
        "evolutionaryTrait": "Thick, rubbery foot pads constantly kept moist by sweat glands acting exactly perfectly like rock-climbing suction cups.",
        "funFact": "Despite looking like a giant fuzzy potato, their closest living completely relative is the elephant!",
        "ecosystemRole": "Colonial herbivore of strictly rocky outcrops.",
        "diet": "Grasses, leaves, and tough Fynbos plants.",
        "size": "Size of a plump rabbit.",
        "sound": "A terrifyingly loud, rising screaming chatter."
      },
      {
        "id": "small-spotted-genet",
        "name": "Small-spotted Genet",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-small-spotted-genet.webp?v=1829247654215763479",
        "evolutionaryTrait": "Extensively long, ringed tail providing absolute flawless balance for acrobatically sprinting securely along thin tree branches.",
        "funFact": "They look like exactly a mix between a cat and a ferret, but uniquely belong firmly to their own distinct family!",
        "ecosystemRole": "Nocturnal acrobatic predator.",
        "diet": "Mice, birds, insects, and frogs.",
        "size": "Size of a slender house cat.",
        "sound": "Hisses, spits, and a cat-like purr."
      },
      {
        "id": "table-mountain-ghost-frog",
        "name": "Table Mountain Ghost Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-table-mountain-ghost-frog.webp?v=3987526593841162992",
        "evolutionaryTrait": "Specialized, flattened tadpoles with massive sucker-mouths allow them to grip firmly onto slippery rocks in fast-flowing mountain streams.",
        "funFact": "They are found exclusively on the slopes of Table Mountain in South Africa and nowhere else in the world!",
        "ecosystemRole": "Indicator of clean, unpolluted mountain water systems.",
        "diet": "Insects and aquatic invertebrates.",
        "size": "Smaller than a thumb.",
        "sound": "A quiet, ghostly squeak."
      },
      {
        "id": "victorins-warbler",
        "name": "Victorin’s Warbler",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-victorin-s-warbler-2.webp?v=13691482422669975281",
        "evolutionaryTrait": "Dull, cryptic plumage that perfectly camouflages it within the dense undergrowth.",
        "funFact": "They are famously secretive and are much more often heard singing loudly than ever seen!",
        "ecosystemRole": "Ground-foraging insectivore.",
        "diet": "Small insects and seeds.",
        "size": "Small bird.",
        "sound": "A loud, melodious song."
      },
      {
        "id": "cape-carpenter-bee",
        "name": "Cape Carpenter Bee",
        "image": "//cleverfoxplay.com/cdn/shop/files/fynbos-cape-carpenter-bee.webp?v=13821925141801319658",
        "evolutionaryTrait": "Powerful jaws for chewing tunnels into dead wood to build their hidden nests.",
        "funFact": "They 'buzz pollinate' by vibrating their flight muscles to shake pollen loose from flowers!",
        "ecosystemRole": "Vital pollinator for many unique and deep-throated Fynbos flowers.",
        "diet": "Nectar and pollen from local flowers.",
        "size": "Size of an acorn.",
        "sound": "A very loud, deep buzzing."
      }
    ]
  },
  {
    "id": "galapagos",
    "name": "Galápagos Islands",
    "location": "Ecuador",
    "description": "Volcanic islands isolated in the Pacific Ocean. Famous for unique species that evolved without fear of humans, inspiring the theory of evolution.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/galapagos-island-hero.webp?v=388738052129459423",
    "color": "bg-blue-600",
    "facts": [
      {
        "title": "Volcanic Origins",
        "content": "These islands were formed by undersea volcanoes pushing up from the ocean floor. Animals had to arrive by swimming, flying, or floating on rafts of vegetation!",
        "icon": "mountain"
      },
      {
        "title": "Fearless Residents",
        "content": "Because there were almost no natural mammal predators here for millions of years, most Galapagos animals have absolutely no fear of humans.",
        "icon": "shieldCheck"
      },
      {
        "title": "Meeting Point of Currents",
        "content": "Deep cold ocean currents mix with warm tropical waters here, bringing huge amounts of nutrients that support everything from penguins to tropical fish.",
        "icon": "waves"
      },
      {
        "title": "Island Giants",
        "content": "Some animals that are small elsewhere (like tortoises) grew to enormous sizes on the islands because of a lack of competition for food.",
        "icon": "maximize"
      }
    ],
    "animals": [
      {
        "id": "blue-footed-booby",
        "name": "Blue-footed Booby",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-blue-footed-booby.webp?v=7465809786618451123",
        "evolutionaryTrait": "Vibrant blue feet used in high-stepping courtship dances; the bluer the feet, the healthier the bird.",
        "funFact": "They dive like arrows from the sky straight into the ocean to catch fish!",
        "ecosystemRole": "Marine predator that keeps small fish populations balanced.",
        "diet": "Sardines, anchovies, and flying fish.",
        "size": "About the size of a large goose.",
        "sound": "High-pitched whistles and honks."
      },
      {
        "id": "brown-noddy",
        "name": "Brown Noddy",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-brown-noddy-landing.webp?v=13171336372236666200",
        "evolutionaryTrait": "A sleek, completely waterproof plumage that lets them comfortably rest right on the ocean surface.",
        "funFact": "They boldly steal fish right out of the mouths of diving pelicans!",
        "ecosystemRole": "Surface forager that cycles nutrients from the sea to the islands.",
        "diet": "Small fish and squid.",
        "size": "Size of a small seagull.",
        "sound": "A low, purring croak."
      },
      {
        "id": "brown-pelican",
        "name": "Brown Pelican",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-brown-pelican.webp?v=1286922380906907053",
        "evolutionaryTrait": "A giant throat pouch that acts as a scooping net to trap gallons of water and fish at once.",
        "funFact": "When they crash into the water, special air sacs under their skin act like bubble wrap!",
        "ecosystemRole": "Massive fish predator connecting the open ocean to the coast.",
        "diet": "Menhaden, mullet, and sardines.",
        "size": "Wingspan up to 7 feet wide.",
        "sound": "Adults are mostly silent, but babies squawk loudly."
      },
      {
        "id": "darwins-finch",
        "name": "Darwin’s Finch",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-darwin-s-finch.webp?v=11918669522457024623",
        "evolutionaryTrait": "Different beak shapes on every island, perfectly adapted to crush seeds, catch bugs, or even drink blood!",
        "funFact": "These tiny birds helped Charles Darwin figure out the whole theory of evolution!",
        "ecosystemRole": "Seed disperser and insect controller.",
        "diet": "Seeds, insects, cactus flowers, and sometimes tick blood.",
        "size": "Smaller than a tennis ball.",
        "sound": "A series of sharp chirps and buzzes."
      },
      {
        "id": "flightless-cormorant",
        "name": "Flightless Cormorant",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-flightless-cormorant.webp?v=8437486127097740122",
        "evolutionaryTrait": "Traded in flying for underwater speed; their wings have shrunken down because there were no predators to fly away from.",
        "funFact": "Even though they can't fly, they still dramatically spread their tiny wings to dry them out in the sun after a dive!",
        "ecosystemRole": "Benthic predator keeping bottom-dwelling fish in check.",
        "diet": "Eels and bottom-dwelling fish.",
        "size": "Length of a large duck.",
        "sound": "Low grunts and growls."
      },
      {
        "id": "frigatebird",
        "name": "Frigatebird",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-frigatebird.webp?v=5233763172190791188",
        "evolutionaryTrait": "Males have an enormous, inflatable bright red throat balloon to attract a mate from high in the sky.",
        "funFact": "Their feathers aren't waterproof, so they can never land on the ocean; they have to steal food from other birds mid-air!",
        "ecosystemRole": "Apex aerial predator and kleptoparasite.",
        "diet": "Flying fish and stolen meals.",
        "size": "Wingspan over 7 feet wide.",
        "sound": "Guttural rattles and bill-clattering."
      },
      {
        "id": "galapagos-fur-seal",
        "name": "Galápagos Fur Seal",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-fur-seal.webp?v=14122916568533172253",
        "evolutionaryTrait": "A crazy thick double layer of fur keeps them incredibly warm, even in cold deep-sea currents.",
        "funFact": "They have special huge eyes that let them hunt squid deep in the pitch black ocean at night!",
        "ecosystemRole": "Nighttime pelagic hunter.",
        "diet": "Lanternfish and squid.",
        "size": "Size of a large dog.",
        "sound": "A hoarse bark like a cough."
      },
      {
        "id": "galapagos-gecko",
        "name": "Galápagos Gecko",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-gecko.webp?v=10135418380515391859",
        "evolutionaryTrait": "Specialized gripping toe pads that act like powerful sticky-tape for climbing straight up volcanic rock.",
        "funFact": "They don't have eyelids! They have to lick their own eyeballs to keep them clean and wet.",
        "ecosystemRole": "Nocturnal insect hunter.",
        "diet": "Moths, beetles, and crickets.",
        "size": "Length of a crayon.",
        "sound": "A rapid clicking noise."
      },
      {
        "id": "galapagos-giant-tortoise",
        "name": "Galápagos Giant Tortoise",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-giant-tortoise.webp?v=17627150400967897953",
        "evolutionaryTrait": "Saddleback shells allow them to crane their incredibly long necks up high to reach tall cactus pads.",
        "funFact": "They can survive up to a whole year without eating or drinking, and can live over 150 years!",
        "ecosystemRole": "The mega-herbivore 'lawnmower' of the islands.",
        "diet": "Grasses, leaves, and cactus fruit.",
        "size": "Can weigh over 500 pounds.",
        "sound": "A deep, raspy hiss."
      },
      {
        "id": "galapagos-hawk",
        "name": "Galápagos Hawk",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-hawk.webp?v=11492609153257876238",
        "evolutionaryTrait": "Broader wings uniquely built for riding the warm, rising air currents over hot volcanic craters.",
        "funFact": "Because they are the top predator on land, they have absolutely no fear and will comfortably land right on human tourists!",
        "ecosystemRole": "The apex predator of the island hills.",
        "diet": "Lava lizards, young iguanas, and centipedes.",
        "size": "Wingspan up to 4 feet.",
        "sound": "A loud, piercing scream."
      },
      {
        "id": "galapagos-land-iguana",
        "name": "Galápagos Land Iguana",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-land-iguana.webp?v=9151200222526560986",
        "evolutionaryTrait": "An impossibly tough mouth and leathery lips to safely chew and swallow cactus complete with huge sharp spikes.",
        "funFact": "They invite tiny birds to land on their face to eat the ticks off their scales!",
        "ecosystemRole": "Primary consumer of prickly pear cacti.",
        "diet": "Cactus pads and fruit.",
        "size": "Length of a guitar.",
        "sound": "A short, sharp huffing sneeze."
      },
      {
        "id": "galapagos-mockingbird",
        "name": "Galápagos Mockingbird",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-mockingbird.webp?v=13999492479729983590",
        "evolutionaryTrait": "Fierce curved beaks have adapted them to become omnivores when water is scarce, even eating turtle eggs or blood.",
        "funFact": "They actually prefer running fast across the hot lava rocks instead of flying!",
        "ecosystemRole": "Island scavenger and bold opportunist.",
        "diet": "Insects, eggs, berries, and carrion.",
        "size": "Size of a regular robin.",
        "sound": "A squeaky, chattering whistle."
      },
      {
        "id": "galapagos-penguin",
        "name": "Galápagos Penguin",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-penguin.webp?v=13794749407814681824",
        "evolutionaryTrait": "Much smaller than other penguins so they can easily lose body heat and survive right on the blazing hot equator.",
        "funFact": "They pant just like pet dogs to cool down when they are standing in the hot sun!",
        "ecosystemRole": "Cold-water current predator.",
        "diet": "Mullet, sardines, and small crustaceans.",
        "size": "Height of an average bowling pin.",
        "sound": "A raspy honk exactly like a donkey."
      },
      {
        "id": "galapagos-racer",
        "name": "Galápagos Racer",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-racer-snake.webp?v=12573246196145747358",
        "evolutionaryTrait": "Mild venom specifically evolved to effortlessly paralyze swift-moving lava lizards and grasshoppers.",
        "funFact": "They famously hunt in huge coordinated packs, swarming baby iguanas the second they hatch from their eggs!",
        "ecosystemRole": "Population controller of island reptiles.",
        "diet": "Lava lizards, baby iguanas, and mice.",
        "size": "Length of a broomstick.",
        "sound": "A quiet, warning hiss."
      },
      {
        "id": "galapagos-sea-lion",
        "name": "Galápagos Sea Lion",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-sea-lion.webp?v=3732609290947664338",
        "evolutionaryTrait": "A sleek, incredibly aerodynamic body for tearing through the chaotic wave currents among jagged coastal rocks.",
        "funFact": "They are the 'puppies of the sea' and love to play tag underwater with scuba divers!",
        "ecosystemRole": "Master coastal hunter and playful ambassador.",
        "diet": "Sardines and lanternfish.",
        "size": "Can weigh up to 550 pounds.",
        "sound": "A loud, dog-like bark."
      },
      {
        "id": "lava-gull",
        "name": "Lava Gull",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-lava-gull.webp?v=3660508211413772618",
        "evolutionaryTrait": "Pitch black body feathers that act as the ultimate camouflage against pure dark volcanic rocks.",
        "funFact": "They are officially the rarest seagull in the entire world, found nowhere else on earth!",
        "ecosystemRole": "Coastal scavenger keeping the shoreline entirely clean.",
        "diet": "Dead fish, crabs, and leftover scraps.",
        "size": "Size of a crow.",
        "sound": "A laughing 'kee-kee-kee'."
      },
      {
        "id": "lava-heron",
        "name": "Lava Heron",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-lava-heron.webp?v=3153934721354577102",
        "evolutionaryTrait": "Dark, slate-grey feathers make them practically invisible while standing painfully still on fresh black lava.",
        "funFact": "When mating season starts, the skin right around their sharp beak turns a brilliant bright blue!",
        "ecosystemRole": "Silent shoreline ambush predator.",
        "diet": "Small crabs, lizards, and fish.",
        "size": "Height of a fire extinguisher.",
        "sound": "A harsh 'kauk' when suddenly startled."
      },
      {
        "id": "lava-lizard",
        "name": "Lava Lizard",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-lava-lizard.webp?v=6581394975356385624",
        "evolutionaryTrait": "Changes color quickly like a mood ring depending exactly on the island they are currently on to stay completely hidden.",
        "funFact": "Whenever two males meet, they violently do 'push-ups' at each other to prove squarely who is the strongest!",
        "ecosystemRole": "Invertebrate hunter and major food source for larger predators.",
        "diet": "Flies, ants, and spiders.",
        "size": "Length of a pencil.",
        "sound": "A tiny rustle against the rocks."
      },
      {
        "id": "manta-ray",
        "name": "Manta Ray",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-manta-ray.webp?v=16723762695563567690",
        "evolutionaryTrait": "Huge, paddle-shaped flaps perfectly scoop nutrient-rich Galapagos plankton right into their open mouths.",
        "funFact": "Every manta ray has a completely unique spray of spots cleanly on its belly, just naturally like a human fingerprint!",
        "ecosystemRole": "Giant pelagic filter feeder.",
        "diet": "Microscopic zooplankton.",
        "size": "Wingspan the size of a small car.",
        "sound": "A massive, sweeping swoosh."
      },
      {
        "id": "marine-iguana",
        "name": "Marine Iguana",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-marine-iguana.webp?v=8232370217713314640",
        "evolutionaryTrait": "Flattened tail efficiently powers them squarely through crashing waves, making them the only successfully ocean-feeding iguana.",
        "funFact": "They practically sneeze out giant clouds of salt onto their own heads safely to get rid of ocean water!",
        "ecosystemRole": "Intertidal algae grazer.",
        "diet": "Red and green sea algae.",
        "size": "Length of a small broom.",
        "sound": "A sneezing 'spshh'."
      },
      {
        "id": "nazca-booby",
        "name": "Nazca Booby",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-nazca-booby.webp?v=13389386063409025479",
        "evolutionaryTrait": "A heavy, brilliantly un-aerodynamic body meant squarely for plunging cleanly deep into the ocean exactly at top speeds.",
        "funFact": "Moms normally lay two eggs, but the first baby firmly always aggressively pushes its poor sibling out of the nest!",
        "ecosystemRole": "Pelagic plunge-diver.",
        "diet": "Flying fish and sardines.",
        "size": "Size of a turkey.",
        "sound": "A duck-like quack."
      },
      {
        "id": "red-footed-booby",
        "name": "Red-footed Booby",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-red-footed-booby.webp?v=4285528757104355091",
        "evolutionaryTrait": "Prehensile feet that are the exact only booby securely capable of perching firmly strictly cleanly on tree branches.",
        "funFact": "They boldly zoom exactly alongside boats strictly to safely catch practically flying fish that jump clearly into the air!",
        "ecosystemRole": "Offshore flying fish interceptor.",
        "diet": "Squid and flying fish.",
        "size": "Size of a small chicken.",
        "sound": "A chattering rattle."
      },
      {
        "id": "sally-lightfoot-crab",
        "name": "Sally Lightfoot Crab",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-sally-lightfoot-crab.webp?v=7609474859897943202",
        "evolutionaryTrait": "Ten sturdy legs meant to bravely grip tightly onto crashing ocean rocks.",
        "funFact": "They boldly jump across rocks, making them look like little red acrobats!",
        "ecosystemRole": "Shoreline cleanup crew keeping the rocky tidal zone healthy.",
        "diet": "Algae, dead fish, and small crustaceans.",
        "size": "Size of a large saucer.",
        "sound": "A clicking clatter from their claws."
      },
      {
        "id": "swallow-tailed-gull",
        "name": "Swallow-tailed Gull",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-swallow-tailed-gull.webp?v=1960524361128508337",
        "evolutionaryTrait": "Special reflective eyes and excellent night vision to hunt squid under the moonlight.",
        "funFact": "They are the only fully nocturnal gull in the entire world!",
        "ecosystemRole": "Nocturnal pelagic predator.",
        "diet": "Deep ocean squid and small fish.",
        "size": "Size of a large crow.",
        "sound": "A clicking, rattle-like call."
      },
      {
        "id": "waved-albatross",
        "name": "Waved Albatross",
        "image": "//cleverfoxplay.com/cdn/shop/files/galapagos-waved-albatross.webp?v=15560107139920548987",
        "evolutionaryTrait": "Enormous wingspan perfectly built for gliding thousands of miles over the open ocean without flapping.",
        "funFact": "They perform a hilarious, complex sword-fighting mating dance with their giant yellow beaks!",
        "ecosystemRole": "Wandering apex scavenger of the high seas.",
        "diet": "Squid, fish, and crustaceans.",
        "size": "Wingspan up to 8 feet wide.",
        "sound": "A loud, wailing moo and bill clapping."
      }
    ]
  },
  {
    "id": "kelp-forest",
    "name": "Kelp Forest",
    "location": "Channel Islands, USA",
    "description": "Underwater forests of giant kelp that can grow 2 feet a day. A swaying, emerald green world full of life.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/kelpforest-hero-img.webp?v=4761396705074207009",
    "color": "bg-green-700",
    "facts": [
      {
        "title": "Fastest Growing",
        "content": "Giant kelp grows up to 2 feet per day under ideal conditions!",
        "icon": "sprout"
      },
      {
        "title": "Underwater Skyscrapers",
        "content": "Giant kelp plants can reach up to 150 feet from the ocean floor to the surface, creating massive, multi-layered habitats just like a terrestrial rainforest.",
        "icon": "waves"
      },
      {
        "title": "Floating on Gas",
        "content": "To keep their fronds near the sunlit surface to photosynthesize, kelp grow small, gas-filled bladders called pneumatocysts at the base of every blade.",
        "icon": "sun"
      },
      {
        "title": "Keystone Protectors",
        "content": "Sea otters act as the ultimate guardians of the kelp forest by eating sea urchins. Without otters, urchins would rapidly multiply and gnaw the kelp down to the bare rock.",
        "icon": "shield"
      }
    ],
    "animals": [
      {
        "id": "bat-ray",
        "name": "Bat Ray",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-bat-ray.webp?v=12088040729245156817",
        "evolutionaryTrait": "A specialized snout for digging up buried clams and a pair of crushing plates to break hard shells.",
        "funFact": "They use their large 'wings' to flap wildly against the sand and uncover hidden prey!",
        "ecosystemRole": "Benthic predator that controls shellfish populations.",
        "diet": "Clams, crabs, and small fish.",
        "size": "Wingspan up to 6 feet.",
        "sound": "A sweeping swish of water."
      },
      {
        "id": "bat-sea-star",
        "name": "Bat Sea Star",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-bat-sea-star.webp?v=9738540225796275071",
        "evolutionaryTrait": "Webbing between its arms gives it a bat-like shape, making it durable in rough surge.",
        "funFact": "Like many sea stars, it can push its stomach outside of its body to digest food externally!",
        "ecosystemRole": "Scavenger that cleans up dead material on the reef floor.",
        "diet": "Algae, dead animals, and small invertebrates.",
        "size": "Size of a dinner plate.",
        "sound": "Silent creeping."
      },
      {
        "id": "black-rockfish",
        "name": "Black Rockfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-black-rockfish.webp?v=14544862157502527227",
        "evolutionaryTrait": "A sleek, dark grey body providing camouflage among the shadowy strands of giant kelp.",
        "funFact": "They can live to be over 50 years old in the cool waters of the kelp forest!",
        "ecosystemRole": "Midwater predator holding a central place in the food web.",
        "diet": "Zooplankton and small fish.",
        "size": "Length of a skateboard.",
        "sound": "Low drumming sounds."
      },
      {
        "id": "blackeye-goby",
        "name": "Blackeye Goby",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-blackeye-goby.webp?v=13007463881862760589",
        "evolutionaryTrait": "Fused pelvic fins under their belly that act like a suction cup to hold onto rocks.",
        "funFact": "Males turn completely black to guard their nests of eggs under a shell!",
        "ecosystemRole": "Benthic micro-predator grazing the rocky bottom.",
        "diet": "Small crustaceans and worms.",
        "size": "Length of a crayon.",
        "sound": "Quick darts in the water."
      },
      {
        "id": "blacksmith",
        "name": "Blacksmith",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-blacksmith.webp?v=3008955878705621786",
        "evolutionaryTrait": "A deep-bodied shape that allows them to maneuver swiftly through twisting kelp fronds.",
        "funFact": "They produce a thick mucus when hiding in rock crevices at night to keep predators away!",
        "ecosystemRole": "Crucial midwater planktivore serving as food for larger predators.",
        "diet": "Floating zooplankton.",
        "size": "Size of a human hand.",
        "sound": "Faint clicking sounds."
      },
      {
        "id": "cabezon",
        "name": "Cabezon",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-cabezon.webp?v=8787628519729837746",
        "evolutionaryTrait": "A giant, bony, spine-covered head that perfectly mimics algae-covered rocks.",
        "funFact": "Their name means 'big-headed' in Spanish, and their eggs are actually toxic!",
        "ecosystemRole": "Ambush predator controlling crabs and abalone.",
        "diet": "Crustaceans, mollusks, and small fish.",
        "size": "Length of an arm.",
        "sound": "A sudden thrash in the water."
      },
      {
        "id": "california-moray-eel",
        "name": "California Moray Eel",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-california-moray-eel.webp?v=3475788960528482686",
        "evolutionaryTrait": "A second set of 'alien' jaws completely hidden in their throat that pulls prey down.",
        "funFact": "They don't have pectoral fins, which lets them easily slither into tight, rocky crevices backwards!",
        "ecosystemRole": "Crevice-dwelling apex predator.",
        "diet": "Fish, octopuses, and crustaceans.",
        "size": "Length of a man.",
        "sound": "Panting, open-mouthed breaths."
      },
      {
        "id": "california-sea-lion",
        "name": "California Sea Lion",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-california-sea-lion.webp?v=1823214654366961510",
        "evolutionaryTrait": "Flexible flippers and a streamlined torpedo body for explosive speed underwater.",
        "funFact": "They are incredibly smart and are famously the 'seal' that balances balls on their noses in shows!",
        "ecosystemRole": "Highly active apex predator keeping fish numbers in check.",
        "diet": "Squid and schooling fish.",
        "size": "Size of a large dog or small bear.",
        "sound": "A loud, echoing bark."
      },
      {
        "id": "california-sheephead",
        "name": "California Sheephead",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-california-sheephead.webp?v=1605813024559260162",
        "evolutionaryTrait": "Large buckteeth perfectly engineered for prying sea urchins forcefully off thick rocks.",
        "funFact": "They all start their lives as females, and the biggest, oldest ones turn into males!",
        "ecosystemRole": "Critical urchin predator that protects the kelp forest from overgrazing.",
        "diet": "Sea urchins, crabs, and lobsters.",
        "size": "Length of a baseball bat.",
        "sound": "A heavy crunching sound."
      },
      {
        "id": "california-spiny-lobster",
        "name": "California Spiny Lobster",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-california-spiny-lobster.webp?v=12354756697759609558",
        "evolutionaryTrait": "Massive, wildly spiky antennae used to ward off predators instead of claws.",
        "funFact": "Unlike Maine lobsters, they have absolutely no large front claws, just powerful spiny legs!",
        "ecosystemRole": "Nocturnal scavenger cleaning the reef floor.",
        "diet": "Sea urchins, clams, and dead fish.",
        "size": "Length of a ruler.",
        "sound": "A loud squeak made by rubbing their antennae."
      },
      {
        "id": "garibaldi",
        "name": "Garibaldi",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-garibaldi.webp?v=11419062495884594649",
        "evolutionaryTrait": "Fiercely bright glowing orange color warns others aggressively away from their carefully tended algae farm.",
        "funFact": "Papa Garibaldi fish will furiously attack scuba divers if they get too close to his prized eggs!",
        "ecosystemRole": "Aggressive algae farmer and protector.",
        "diet": "Sponges, algae, and small tube worms.",
        "size": "Size of a dinner plate.",
        "sound": "A loud thumping pop."
      },
      {
        "id": "giant-kelpfish",
        "name": "Giant Kelpfish",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-giant-kelpfish.webp?v=12967236586318777984",
        "evolutionaryTrait": "A beautifully thin body that looks exactly like a gently swaying leaf of giant kelp.",
        "funFact": "They can rapidly change their skin color between bright green, deep red, or golden brown!",
        "ecosystemRole": "Camouflaged ambush predator.",
        "diet": "Small fish and crustaceans.",
        "size": "Length of an arm.",
        "sound": "Silent."
      },
      {
        "id": "giant-sea-bass",
        "name": "Giant Sea Bass",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-giant-sea-bass.webp?v=16277896062237297978",
        "evolutionaryTrait": "An impossibly massive mouth capable of casually inhaling an entire large stingray whole.",
        "funFact": "They are the true gentle giants of the kelp forest, growing over 7 feet long and living up to 75 years!",
        "ecosystemRole": "Top apex predator of the kelp ecosystem.",
        "diet": "Rays, crabs, squid, and smaller fish.",
        "size": "Size of a golf cart.",
        "sound": "A deep, booming bass knock."
      },
      {
        "id": "halfmoon",
        "name": "Halfmoon",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-halfmoon.webp?v=11055854059751542692",
        "evolutionaryTrait": "A half-moon shaped tail allows them to swim efficiently in large, synchronized schools.",
        "funFact": "They are named uniquely for their sharply curved tail resembling a precise crescent moon!",
        "ecosystemRole": "Schooling herbivore cutting back algae.",
        "diet": "Algae, sponges, and small invertebrates.",
        "size": "Size of a human hand.",
        "sound": "Faint flashing."
      },
      {
        "id": "harbor-seal",
        "name": "Harbor Seal",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-harbor-seal.webp?v=6653669263613152496",
        "evolutionaryTrait": "A gorgeously speckled, thickly blubbered body built safely to keep them perfectly warm in freezing waters.",
        "funFact": "Unlike sea lions, they have no ear flaps, just tiny delicate holes on their head!",
        "ecosystemRole": "Agile aquatic predator keeping fish and squid in balance.",
        "diet": "Flounder, sole, squid, and octopus.",
        "size": "Size of a large dog.",
        "sound": "A soft grunt or snort."
      },
      {
        "id": "horn-shark",
        "name": "Horn Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-horn-shark.webp?v=10900133133208407859",
        "evolutionaryTrait": "Sharp spines standing up vertically in front of their dorsal fins for fierce protection.",
        "funFact": "They lay extremely weird, spiral screw-shaped eggs that mother sharks wedge tightly into rock crevices!",
        "ecosystemRole": "Benthic predator that naturally manages sea urchins.",
        "diet": "Urchins, crabs, and tough-shelled mollusks.",
        "size": "Length of a typical skateboard.",
        "sound": "Silent swishing."
      },
      {
        "id": "kelp-bass",
        "name": "Kelp Bass",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-kelp-bass.webp?v=15826230814921010887",
        "evolutionaryTrait": "Mottled checkered camouflage that safely masks them inside the kelp forest shadows.",
        "funFact": "They are renowned for their intense curiosity, and regularly follow scuba divers around closely!",
        "ecosystemRole": "Ambush predator of the midwater kelp canopy.",
        "diet": "Small fish and squid.",
        "size": "Length of a fisherman's forearm.",
        "sound": "Loud splashes when leaping."
      },
      {
        "id": "leopard-shark",
        "name": "Leopard Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-leopard-shark.webp?v=3993395092455569645",
        "evolutionaryTrait": "Beautiful dark gray spots acting seamlessly as camouflage against the sandy bottom.",
        "funFact": "They are completely harmless to humans and gather peacefully in warm bays during summer.",
        "ecosystemRole": "Bottom-dwelling predator helping control crustacean populations.",
        "diet": "Crabs, clam siphons, and small fish.",
        "size": "Length of an adult human.",
        "sound": "Silent."
      },
      {
        "id": "lingcod",
        "name": "Lingcod",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-lingcod.webp?v=14610437602018135817",
        "evolutionaryTrait": "A massive mouth filled with 18 razor-sharp teeth for catching large slippery prey.",
        "funFact": "Despite their cod-like looks, their meat is sometimes completely bright blue (though it turns white when cooked).",
        "ecosystemRole": "An extremely voracious ambush predator that devours anything it can swallow.",
        "diet": "Octopus, large fish, and smaller lingcod.",
        "size": "Can grow over 5 feet long.",
        "sound": "Silent waiting."
      },
      {
        "id": "opaleye",
        "name": "Opaleye",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-opaleye.webp?v=5287956991740593321",
        "evolutionaryTrait": "Two bright white spots perfectly set right below their dorsal fin acting as 'fake eyes' to confuse predators.",
        "funFact": "Unlike almost all other fish in the kelp forest, they are primarily vegetarian!",
        "ecosystemRole": "Essential grazer that keeps algae overgrowth from suffocating the kelp.",
        "diet": "Giant kelp and various types of seaweeds.",
        "size": "Size of a dinner plate.",
        "sound": "Tiny grazing snaps."
      },
      {
        "id": "pacific-angel-shark",
        "name": "Pacific Angel Shark",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-pacific-angel-shark.webp?v=16442384086702480635",
        "evolutionaryTrait": "Incredibly flat, wide body adapted seamlessly for fully burying themselves invisibly under the sand.",
        "funFact": "They sit perfectly still for so long that sometimes algae literally grows right on their backs!",
        "ecosystemRole": "Patient benthic ambush predator waiting for careless fish.",
        "diet": "Sand-dwelling fish and free-swimming squid.",
        "size": "Length of a broomstick.",
        "sound": "A sudden burst of moving sand."
      },
      {
        "id": "purple-sea-urchin",
        "name": "Purple Sea Urchin",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-purple-sea-urchin.webp?v=2228153920104548614",
        "evolutionaryTrait": "Thousands of sharp, venomous purple spines point outward defensively against all approaching predators.",
        "funFact": "If left completely unchecked without their natural predators like sea otters, they can eat an entire kelp forest down to bare rock!",
        "ecosystemRole": "Voracious kelp grazer pivotal in forest health.",
        "diet": "Living giant kelp.",
        "size": "Size of a baseball.",
        "sound": "Scratching."
      },
      {
        "id": "red-abalone",
        "name": "Red Abalone",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-red-abalone.webp?v=3991423525912667124",
        "evolutionaryTrait": "An incredibly tough, thick shell coated on the inside in spectacularly beautiful, shimmering mother-of-pearl.",
        "funFact": "They possess an enormous muscular 'foot' capable of latching onto rocks so tightly they can survive huge storm surges.",
        "ecosystemRole": "Sessile grazer contributing essential nutrients back into the ecosystem.",
        "diet": "Drifting pieces of detached kelp.",
        "size": "Size of a football.",
        "sound": "Silent."
      },
      {
        "id": "rock-crab",
        "name": "Rock Crab",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-rock-crab.webp?v=11362377325719153885",
        "evolutionaryTrait": "A brick-red, brick-hard carapace completely covering their vulnerable body and powerful crushing claws.",
        "funFact": "They can easily regenerate their massively strong claws if they lose one during an underwater fight!",
        "ecosystemRole": "Hardy benthic scavenger cleaning up the reef.",
        "diet": "Snails, clams, and dead marine life.",
        "size": "The span of two outspread human hands.",
        "sound": "Clicking claws."
      },
      {
        "id": "sea-hare",
        "name": "Sea Hare",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-sea-hare.webp?v=3373676245009605194",
        "evolutionaryTrait": "Two prominent ear-like sensory organs on their head give them the distinct appearance of a soggy underwater rabbit.",
        "funFact": "When threatened, they blast a huge cloud of stunning neon purple ink straight into the water!",
        "ecosystemRole": "Vital invertebrate grazer converting algae energy.",
        "diet": "Red and green algae.",
        "size": "Size of a loaf of bread.",
        "sound": "Silent."
      },
      {
        "id": "sea-otter",
        "name": "Sea Otter",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-sea-otter.webp?v=16070642294203742108",
        "evolutionaryTrait": "The densest fur in the world, with over a million hairs per square inch, acting as a fully waterproof winter coat.",
        "funFact": "They actively wrap themselves carefully in long strands of kelp before falling asleep so they won't float away!",
        "ecosystemRole": "The ultimate keystone species defining kelp forest survival.",
        "diet": "Sea urchins, clams, and crabs.",
        "size": "Length of a typical human toddler.",
        "sound": "Squeak."
      },
      {
        "id": "sea-slug",
        "name": "Sea Slug",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-sea-slug.webp?v=7988783912936990010",
        "evolutionaryTrait": "Bright, contrasting neon colors boldly warning predators that they are absolutely loaded with stolen toxic chemicals.",
        "funFact": "They can actually steal the stinging cells from their anemone prey and use them on their own backs as weapons!",
        "ecosystemRole": "Microscopic predator hunting in the kelp fronds.",
        "diet": "Toxic sponges and tiny hydroids.",
        "size": "Length of a small finger.",
        "sound": "Silent."
      },
      {
        "id": "senorita",
        "name": "Senorita",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-senorita.webp?v=15781308423240366488",
        "evolutionaryTrait": "A sharp, pointy beak perfectly evolved to meticulously pick tiny hidden parasites right off the scales of much larger fish.",
        "funFact": "They provide a very popular 'cleaning station' service where giant fish line up completely patiently waiting their turn to be cleaned!",
        "ecosystemRole": "Essential cleaner fish protecting community health.",
        "diet": "Tiny parasitic crustaceans.",
        "size": "Length of a pencil.",
        "sound": "Silent."
      },
      {
        "id": "sheep-crab",
        "name": "Sheep Crab",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-sheep-crab.webp?v=3181577062000386013",
        "evolutionaryTrait": "A bumpy, fuzzy shell explicitly designed to easily grow algae securely on top of them as naturally-grown camouflage.",
        "funFact": "As they grow, they take small sponges and seaweed from the bottom and deliberately plant them neatly on their own shell!",
        "ecosystemRole": "Important scavenger and detrivore recycling nutrients.",
        "diet": "Decaying fish and invertebrates.",
        "size": "Size of a car tire when legs are spread.",
        "sound": "Clicking."
      },
      {
        "id": "sunflower-star",
        "name": "Sunflower Star",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-sunflower-star.webp?v=370736221588318085",
        "evolutionaryTrait": "Up to 24 flexible arms explicitly equipped with thousands of tiny suctioning tube feet, making them incredibly fast sprinters.",
        "funFact": "They are the largest sea stars on earth, and can swallow an entire sea urchin completely whole!",
        "ecosystemRole": "Crucial invertebrate apex predator terrorizing sea urchins.",
        "diet": "Sea urchins and small clams.",
        "size": "Can span over three feet across.",
        "sound": "Silent."
      },
      {
        "id": "torpedo-ray",
        "name": "Torpedo Ray",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-torpedo-ray.webp?v=14596812374905153614",
        "evolutionaryTrait": "Specialized honeycomb-shaped muscle cells in their wings explicitly capable of generating a massive 50-volt electric shock.",
        "funFact": "Ancient Greeks actually used the electric shocks from these rays safely as an early medical treatment for severe headaches!",
        "ecosystemRole": "Electric ambush predator catching unsuspecting prey.",
        "diet": "Bottom-dwelling fish and small sharks.",
        "size": "Size of a snow saucer.",
        "sound": "Silent."
      },
      {
        "id": "two-spot-octopus",
        "name": "Two-spot Octopus",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-two-spot-octopus.webp?v=2667766914617285716",
        "evolutionaryTrait": "Two brilliant bright blue eye-spots right on their head used to successfully trick predators into thinking they are much larger.",
        "funFact": "They have three hearts, blue blood, and can expertly solve complicated puzzles completely to escape their tanks!",
        "ecosystemRole": "Highly intelligent crevice predator.",
        "diet": "Crabs, lobsters, and shellfish.",
        "size": "Arm span of around two feet.",
        "sound": "Silent."
      },
      {
        "id": "warty-sea-cucumber",
        "name": "Warty Sea Cucumber",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-warty-sea-cucumber.webp?v=11975890984311369457",
        "evolutionaryTrait": "A completely soft, tube-like body covered in bumpy warts that smoothly expands or contracts to fit tightly into tiny rocky holes.",
        "funFact": "When threatened, they actually expel their own toxic internal organs safely into the water to distract a predator and easily grow them firmly back later!",
        "ecosystemRole": "Essential detritivore keeping the ocean floor completely clean of waste.",
        "diet": "Detritus and decaying organic matter.",
        "size": "Length of a zucchini.",
        "sound": "Silent."
      },
      {
        "id": "bluebanded-goby",
        "name": "Bluebanded Goby",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-bluebanded-goby.webp?v=13521607461579172108",
        "evolutionaryTrait": "Vibrant blue stripes and bright orange skin warn predators that it is unpalatable or toxic.",
        "funFact": "They are known to be 'cleaner fish' for larger species in some parts of their range, picking off parasites!",
        "ecosystemRole": "Acts as a micro-predator of tiny crustaceans while serving as a warning-colored prey item.",
        "diet": "Small crustaceans and zooplankton.",
        "size": "About 2 inches long.",
        "sound": "Silent."
      },
      {
        "id": "painted-greenling",
        "name": "Painted Greenling",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-painted-greenling.webp?v=7327446264254504454",
        "evolutionaryTrait": "Distinctive reddish bands help it camouflage perfectly among red algae and rocky substrates.",
        "funFact": "Males aggressively guard their nest of eggs, which can sometimes come from multiple females!",
        "ecosystemRole": "Helps control populations of small benthic invertebrates.",
        "diet": "Small crustaceans, worms, and brittle stars.",
        "size": "Up to 10 inches long.",
        "sound": "Mostly silent."
      },
      {
        "id": "red-sea-urchin",
        "name": "Red Sea Urchin",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-red-sea-urchin.webp?v=6950102229284129470",
        "evolutionaryTrait": "Long, sharp spines and a specialized jaw mechanism called 'Aristotle's lantern' for scraping algae.",
        "funFact": "They are one of the longest-living creatures on Earth, with some individuals living over 200 years!",
        "ecosystemRole": "Major consumer of kelp; kept in check by sea otters and sunflower stars to prevent kelp 'barrens'.",
        "diet": "Kelp and other marine algae.",
        "size": "Up to 7 inches in diameter.",
        "sound": "Scraping noises while feeding."
      },
      {
        "id": "rock-scallop",
        "name": "Rock Scallop",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-rock-scallop.webp?v=5204188721315293349",
        "evolutionaryTrait": "Secretes a strong cement to permanently attach its thick, heavily armored shell to underwater rock faces.",
        "funFact": "When they are young, they can swim freely just like regular scallops by rapidly clapping their shells together!",
        "ecosystemRole": "Filters massive amounts of phytoplankton from the water, improving water clarity.",
        "diet": "Phytoplankton and suspended organic matter.",
        "size": "Up to 10 inches across.",
        "sound": "Occasional dull clicking as shells close."
      },
      {
        "id": "strawberry-anemone",
        "name": "Strawberry Anemone",
        "image": "//cleverfoxplay.com/cdn/shop/files/kelpforest-strawberry-anemone.webp?v=6182405857055647408",
        "evolutionaryTrait": "Club-tipped tentacles packed with venomous stinging cells (nematocysts) for catching prey.",
        "funFact": "Despite their flower-like appearance, they will voraciously swallow small fish and crabs whole!",
        "ecosystemRole": "Provides habitat complexity and preys on small organisms drifting in the current.",
        "diet": "Zooplankton, small fish, and crustaceans.",
        "size": "About 1 to 2 inches across.",
        "sound": "Silent."
      }
    ]
  },
  {
    "id": "madagascar",
    "name": "Madagascar",
    "location": "Tropical Dry Forest, Madagascar",
    "description": "A giant island isolated for millions of years. 90% of its wildlife is found nowhere else on Earth.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/madagascar-hero-img.webp?v=3693984337773359638",
    "color": "bg-red-400",
    "facts": [
      {
        "title": "The Eighth Continent",
        "content": "Because Madagascar broke away from Africa and India millions of years ago, its wildlife evolved in complete isolation, creating species found nowhere else on Earth.",
        "icon": "globe-2"
      },
      {
        "title": "Land of Lemurs",
        "content": "There are absolutely no native monkeys or apes here—just lemurs! Over 100 different species have evolved to fill every ecological niche.",
        "icon": "trees"
      },
      {
        "title": "Master of Disguise",
        "content": "The island is home to over half of the world's chameleon species, ranging from the size of a fingernail to the length of a cat.",
        "icon": "eye"
      },
      {
        "title": "Bizarre Baobabs",
        "content": "Madagascar contains six of the world's nine species of baobabs—massive, thick-trunked trees that look like they have been planted upside down with their roots in the air.",
        "icon": "trees"
      }
    ],
    "animals": [
      {
        "id": "aye-aye",
        "name": "Aye-aye",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-aye-aye.webp?v=17603598647596277665",
        "evolutionaryTrait": "A crazy long, skeletal middle finger used to tap on wood and fish out juicy grubs.",
        "funFact": "They are the world's largest nocturnal primate and were once thought to be an evil omen!",
        "ecosystemRole": "Fills the ecological niche of a woodpecker by controlling wood-boring insects.",
        "diet": "Grubs, nectar, and seeds.",
        "size": "Size of a small dog.",
        "sound": "A high, scratchy screech."
      },
      {
        "id": "broad-billed-roller",
        "name": "Broad-billed Roller",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-broad-billed-roller.webp?v=8811571639457044858",
        "evolutionaryTrait": "A short, incredibly wide yellow beak perfectly designed for catching large insects mid-air.",
        "funFact": "They perform spectacular rolling acrobatics in the air during their courtship displays!",
        "ecosystemRole": "Aerial predator controlling flying insect populations.",
        "diet": "Moths, beetles, and locusts.",
        "size": "Size of a pigeon.",
        "sound": "A loud, harsh 'k-k-k-k-k'."
      },
      {
        "id": "chestnut-vented-coua",
        "name": "Chestnut-vented Coua",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-chestnut-vented-coua.webp?v=13103170281618488935",
        "evolutionaryTrait": "Powerful, long legs that help it sprint through dense forest undergrowth instead of flying.",
        "funFact": "Like all couas, they are part of the cuckoo family but remarkably, they build their own nests and raise their own chicks!",
        "ecosystemRole": "Ground-foraging seed and insect disperser.",
        "diet": "Insects, fruits, and seeds.",
        "size": "Length of a ruler.",
        "sound": "A melodic, ringing 'koo-a'."
      },
      {
        "id": "coquerels-sifaka",
        "name": "Coquerel’s Sifaka",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-coquerel-s-sifaka.webp?v=10050493931186679569",
        "evolutionaryTrait": "Massively powerful hind legs that allow them to leap up to 30 feet between thorny trees.",
        "funFact": "When they have to cross the ground, they bound sideways like they are doing a joyful dance!",
        "ecosystemRole": "Canopy seed disperser.",
        "diet": "Leaves, flowers, and fruit.",
        "size": "Size of a large house cat.",
        "sound": "A loud 'shif-auk' alarm call."
      },
      {
        "id": "crested-coua",
        "name": "Crested Coua",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-crested-coua.webp?v=10407282441734971775",
        "evolutionaryTrait": "A striking crest of feathers on their head and bright blue bare skin around their eyes.",
        "funFact": "They are surprisingly clumsy flyers and much prefer gliding or hopping gracefully from branch to branch!",
        "ecosystemRole": "Canopy omnivore and seed disperser.",
        "diet": "Insects, fruits, and small reptiles.",
        "size": "Size of a thin crow.",
        "sound": "A descending 'koa-koa' call."
      },
      {
        "id": "fat-tailed-dwarf-lemur",
        "name": "Fat-tailed Dwarf Lemur",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-fat-tailed-dwarf-lemur.webp?v=3241573226802881590",
        "evolutionaryTrait": "An ability to store vast amounts of fat entirely in their tail to survive the dry season.",
        "funFact": "They are the only primate known to truly hibernate, sleeping for up to seven months a year in a hollow tree!",
        "ecosystemRole": "Nocturnal pollinator and seed disperser.",
        "diet": "Fruit, nectar, and pollen.",
        "size": "Size of a squirrel.",
        "sound": "Soft squeaks and trills."
      },
      {
        "id": "fossa",
        "name": "Fossa",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-fossa.webp?v=7201990821232849507",
        "evolutionaryTrait": "A terrifyingly muscular feline-like body and long tail for perfect balance while hunting high in the canopy.",
        "funFact": "They look like a cross between a cat, a dog, and a mongoose, but they are actually related to mongooses!",
        "ecosystemRole": "Apex predator of the forest.",
        "diet": "Lemurs, reptiles, and birds.",
        "size": "Size of a slim cheetah cub.",
        "sound": "A cat-like yowl."
      },
      {
        "id": "giraffe-weevil",
        "name": "Giraffe Weevil",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-giraffe-weevil.webp?v=15706190371756206975",
        "evolutionaryTrait": "Males have an incredibly long, crane-like neck used specifically for battling other males for mates.",
        "funFact": "Females cleverly roll a single leaf up like a tiny burrito to build a perfect, protective nest for their single egg!",
        "ecosystemRole": "Specialized herbivore.",
        "diet": "Leaves of the giraffe beetle tree.",
        "size": "Size of a fingernail.",
        "sound": "Silent."
      },
      {
        "id": "golden-mantella-frog",
        "name": "Golden Mantella Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-golden-mantella-frog.webp?v=11479093747068866729",
        "evolutionaryTrait": "A stunning, bright orange-gold poisonous skin that acts as a neon warning sign to predators.",
        "funFact": "They are totally completely deaf; they rely entirely on feeling vibrations instead of hearing calls!",
        "ecosystemRole": "Controls small toxic insects.",
        "diet": "Tiny toxic ants and termites.",
        "size": "Size of an almond.",
        "sound": "A high, tiny click."
      },
      {
        "id": "indri-lemur",
        "name": "Indri Lemur",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-indri-lemur.webp?v=14073014232021348731",
        "evolutionaryTrait": "Almost completely lacking a tail, a rarity among lemur species, relying on raw jump power.",
        "funFact": "Their incredibly loud, haunting morning songs sound like an echoing opera that carries for miles through the forest!",
        "ecosystemRole": "Primary canopy leaf eater.",
        "diet": "Young leaves, seeds, and fruit.",
        "size": "Size of a human toddler.",
        "sound": "A loud, whale-like wailing song."
      },
      {
        "id": "large-eared-tenrec",
        "name": "Large-eared Tenrec",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-large-eared-tenrec.webp?v=14804031272325041557",
        "evolutionaryTrait": "Massive ears and long, sensitive whiskers to detect the tiniest insect movements in total darkness.",
        "funFact": "Even though it resembles a mouse crossed with a hedgehog, it's actually more closely related to elephants!",
        "ecosystemRole": "Nocturnal ground insect predator.",
        "diet": "Insects, spiders, and scorpions.",
        "size": "Size of a gerbil.",
        "sound": "Tiny hisses."
      },
      {
        "id": "leaf-tailed-gecko",
        "name": "Leaf-tailed Gecko",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-leaf-tailed-gecko.webp?v=9755058000179524430",
        "evolutionaryTrait": "Skin and a flat tail that entirely mimic dead, decaying leaves—down to fake insect bite holes!",
        "funFact": "They have no eyelids; they literally have to use their extremely long tongue to lick their eyeballs clean!",
        "ecosystemRole": "Ambush predator of the woody understory.",
        "diet": "Insects and spiders.",
        "size": "Length of a banana.",
        "sound": "A startling, loud scream when angry."
      },
      {
        "id": "lesser-hedgehog-tenrec",
        "name": "Lesser Hedgehog Tenrec",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-lesser-hedgehog-tenrec.webp?v=14810958677268406803",
        "evolutionaryTrait": "A dense coat of intimidating, short spines used entirely to roll into a protective ball.",
        "funFact": "If threatened, they will furiously head-butt predators to drive their spiky quills right into their attacker's nose!",
        "ecosystemRole": "Controls ground-dwelling invertebrate populations.",
        "diet": "Insects, earthworms, and grubs.",
        "size": "Size of a baked potato.",
        "sound": "Squeaks and defensive hisses."
      },
      {
        "id": "lowland-streaked-tenrec",
        "name": "Lowland Streaked Tenrec",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-lowland-streaked-tenrec.webp?v=1975493562776198125",
        "evolutionaryTrait": "Special quills on their back that they rub together rapidly to buzz and communicate with their family.",
        "funFact": "They are the only mammal known directly to use 'stridulation' for communication—just like a cricket does!",
        "ecosystemRole": "Social ground-foraging insectivore.",
        "diet": "Earthworms and insects.",
        "size": "Size of a large rat.",
        "sound": "A high-frequency vibrating chatter."
      },
      {
        "id": "madagascar-coucal",
        "name": "Madagascar Coucal",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-coucal.webp?v=15306820104134607759",
        "evolutionaryTrait": "Incredibly long, sharp hind claws that help them aggressively scramble up thick vines.",
        "funFact": "They are notoriously messy nest builders, fashioning gigantic dome-shaped nests complete with a woven roof!",
        "ecosystemRole": "Mid-level predator controlling amphibian and reptile numbers.",
        "diet": "Insects, small frogs, and chameleons.",
        "size": "Length of a ruler.",
        "sound": "A bubbling 'bou-bou' sequence."
      },
      {
        "id": "madagascar-crested-ibis",
        "name": "Madagascar Crested Ibis",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-crested-ibis.webp?v=878755893043435667",
        "evolutionaryTrait": "A wildly bright red face mask and impressive crest that flares up when they are excited or alarmed.",
        "funFact": "Unlike typical wading ibises, they fiercely prefer deep dry forests and aggressively hunt for food on the leafy floor!",
        "ecosystemRole": "Forest floor predator.",
        "diet": "Insects, frogs, and snails.",
        "size": "Size of a chicken.",
        "sound": "A sudden, harsh squawk."
      },
      {
        "id": "madagascar-fish-eagle",
        "name": "Madagascar Fish Eagle",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-fish-eagle.webp?v=10130143472075855226",
        "evolutionaryTrait": "Incredibly powerful talons studded with tiny, sharp spikes to perfectly grasp slippery live fish.",
        "funFact": "It is one of the rarest birds of prey entirely in the world, with only a few hundred left in the wild!",
        "ecosystemRole": "Apex aerial predator of lakes and rivers.",
        "diet": "Mainly fish.",
        "size": "Wingspan of nearly 6 feet.",
        "sound": "A sharp, gull-like cry."
      },
      {
        "id": "madagascar-flying-fox",
        "name": "Madagascar Flying Fox",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-flying-fox.webp?v=11508532740960735258",
        "evolutionaryTrait": "Gigantic leathery wings that allow them to fly long distances to reach blooming fruit trees.",
        "funFact": "They don't use echolocation at all; instead they have massive eyes and an incredible sense of smell to find sweet food!",
        "ecosystemRole": "Crucial night-time pollinator and seed disperser.",
        "diet": "Fruit, nectar, and pollen.",
        "size": "Wingspan over 3 feet.",
        "sound": "Noisy monkey-like chatter."
      },
      {
        "id": "madagascar-giant-day-gecko",
        "name": "Madagascar Giant Day Gecko",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-giant-day-gecko.webp?v=4013747054773851220",
        "evolutionaryTrait": "Specialized microscopic hairs on their toe pads allow them to sprint directly up vertical, remarkably smooth glass-like leaves.",
        "funFact": "Unlike most secretive geckos, they love to be completely active strictly during the absolute brightest part of the hot sunny day!",
        "ecosystemRole": "Controls fast-moving diurnal insect populations.",
        "diet": "Insects, sweet nectar, and fruit.",
        "size": "Length of a typical pencil.",
        "sound": "A loud, distinct clicking bark."
      },
      {
        "id": "madagascar-green-pigeon",
        "name": "Madagascar Green Pigeon",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-green-pigeon.webp?v=8267516214527064716",
        "evolutionaryTrait": "Feathers specifically shaded in a vibrant olive-green that perfectly camouflages them amongst thick forest foliage.",
        "funFact": "They are amazingly acrobatic while eating, often happily hanging completely upside down simply to reach the best berries!",
        "ecosystemRole": "Canopy fruit consumer and seed distributor.",
        "diet": "Fruits, berries, and seeds.",
        "size": "Size of a street pigeon.",
        "sound": "A melodic, laughing 'hoo-hoo-hoo'."
      },
      {
        "id": "madagascar-kestrel",
        "name": "Madagascar Kestrel",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-kestrel-hovering.webp?v=15352852225940230031",
        "evolutionaryTrait": "Incredible hovering abilities letting them float completely stationary in the air while scanning the ground for prey.",
        "funFact": "They boldly take over the abandoned towering nests of loud crows instead of bothering to build their own!",
        "ecosystemRole": "Aerial hunter of small ground-dwellers.",
        "diet": "Insects, small birds, and lizards.",
        "size": "Size of a dove.",
        "sound": "A shrill, repetitive 'kee-kee-kee'."
      },
      {
        "id": "madagascar-pygmy-kingfisher",
        "name": "Madagascar Pygmy Kingfisher",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-pygmy-kingfisher.webp?v=427438690126635553",
        "evolutionaryTrait": "A surprisingly large, heavy beak relative to its tiny body size for snatching fast lizards out of leaves.",
        "funFact": "Despite its name, it extremely rarely eats fish and intensely prefers hunting small frogs in absolutely dry forests!",
        "ecosystemRole": "Micro predator of the forest understory.",
        "diet": "Insects, small frogs, and lizards.",
        "size": "Smaller than a sparrow.",
        "sound": "A sharp, high-pitched 'tsip'."
      },
      {
        "id": "madame-berthes-mouse-lemur",
        "name": "Madame Berthe’s Mouse Lemur",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-madame-berthe-s-mouse-lemur.webp?v=4633796458660169317",
        "evolutionaryTrait": "An extraordinarily tiny body size cleverly allowing them to hide safely from predators inside the thinnest tree branches.",
        "funFact": "It holds the incredible record for being the absolute smallest known primate in the entire world!",
        "ecosystemRole": "Night-time insect controller and prey species.",
        "diet": "Insects, sweet honeydew, and fruit.",
        "size": "Weight of a large strawberry (1 ounce!).",
        "sound": "Barely audible tiny squeaks."
      },
      {
        "id": "malagasy-giant-jumping-rat",
        "name": "Malagasy Giant Jumping Rat",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-malagasy-giant-jumping-rat.webp?v=16107689461291046470",
        "evolutionaryTrait": "Massive kangaroo-like hind legs distinctly built for explosive three-foot jumping to furiously escape predators.",
        "funFact": "They behave remarkably like rabbits and fiercely mate for absolute life, which is extremely rare for rodents!",
        "ecosystemRole": "Ground herbivore and seed disperser.",
        "diet": "Fallen fruit, seeds, and leaves.",
        "size": "Size of a rabbit.",
        "sound": "Thumping their back feet when alarmed."
      },
      {
        "id": "malagasy-paradise-flycatcher",
        "name": "Malagasy Paradise Flycatcher",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-malagasy-paradise-flycatcher.webp?v=10770505649800342638",
        "evolutionaryTrait": "Males possess stunning, excessively long white tail streamers dramatically used primarily for dazzling courtship displays.",
        "funFact": "Incredibly, some males are bright chestnut red with short tails, and others are stark white with incredibly long tails!",
        "ecosystemRole": "Mid-air insect hunting specialist.",
        "diet": "Flying insects.",
        "size": "Body the size of a sparrow, tail much longer.",
        "sound": "A harsh 'tzit' call."
      },
      {
        "id": "mongoose-lemur",
        "name": "Mongoose Lemur",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-mongoose-lemur.webp?v=4853476367547686464",
        "evolutionaryTrait": "A uniquely flexible activity pattern, cleverly shifting from strictly nocturnal to boldly diurnal depending intensely on the season.",
        "funFact": "A crucial part of their diet is simply heavily drinking the sweet nectar from massive kapok flowers without destroying the blossom!",
        "ecosystemRole": "Major pollinator of the tropical kapok trees.",
        "diet": "Nectar, flowers, and fruit.",
        "size": "Size of a typical house cat.",
        "sound": "Pig-like grunts."
      },
      {
        "id": "narrow-striped-mongoose",
        "name": "Narrow-striped Mongoose",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-narrow-striped-mongoose.webp?v=14500583492012552110",
        "evolutionaryTrait": "Crisp, narrow tiger-like back stripes providing excellent disruptive camouflage within dense, shadowy dry forests.",
        "funFact": "Families sleep huddled together tightly inside cozy tree holes rather than underground burrows!",
        "ecosystemRole": "Day-active ground hunter.",
        "diet": "Insects, small mammals, and eggs.",
        "size": "Size of a squirrel.",
        "sound": "Small chatters."
      },
      {
        "id": "panther-chameleon",
        "name": "Panther Chameleon",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-panther-chameleon.webp?v=17759921428009000473",
        "evolutionaryTrait": "A tongue literally twice the length of its entire body that perfectly shoots out in milliseconds to silently catch flies.",
        "funFact": "They don't furiously change color entirely to blend in; they change spectacularly to communicate their intense mood!",
        "ecosystemRole": "Masters of ambush insect hunting.",
        "diet": "Insects and spiders.",
        "size": "Length of a ruler.",
        "sound": "A quiet defensive hiss."
      },
      {
        "id": "radiated-tortoise",
        "name": "Radiated Tortoise",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-radiated-tortoise.webp?v=17968502997309669565",
        "evolutionaryTrait": "A wildly beautiful, high-domed shell intricately patterned with yellow stars to brilliantly break up its outline in the shadows.",
        "funFact": "When it intensely rains, they joyfully stretch out their legs and literally 'dance' to properly shake off the water!",
        "ecosystemRole": "Ground herbivore and seed spreader.",
        "diet": "Grasses, fruit, and succulents.",
        "size": "Size of a large mixing bowl.",
        "sound": "A faint grunt."
      },
      {
        "id": "red-ruffed-lemur",
        "name": "Red Ruffed Lemur",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-red-ruffed-lemur.webp?v=14134050273298564211",
        "evolutionaryTrait": "A thick, violently red coat of fur heavily insulating them during torrential rainforest downpours.",
        "funFact": "Moms build safe, cozy nests high in the trees for their tiny babies instead of frantically carrying them around!",
        "ecosystemRole": "Canopy pollinator and fruit eater.",
        "diet": "Mostly fruit.",
        "size": "Size of a medium dog.",
        "sound": "Deafening, booming roars."
      },
      {
        "id": "red-capped-coua",
        "name": "Red-capped Coua",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-red-capped-coua.webp?v=4056561896687348830",
        "evolutionaryTrait": "A prominently vivid red cap of head feathers sharply contrasting with smooth blue facial skin.",
        "funFact": "They are spectacularly agile long-jumpers, practically bouncing through the treetops completely without heavily relying on flying!",
        "ecosystemRole": "Forest canopy omnivore.",
        "diet": "Insects, fruit, and seeds.",
        "size": "Size of a crow.",
        "sound": "A loud 'c-r-r-r-a'."
      },
      {
        "id": "ring-tailed-lemur",
        "name": "Ring-tailed Lemur",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-ring-tailed-lemur.webp?v=10955415667663877480",
        "evolutionaryTrait": "Long, famously black-and-white striped tails proudly used as tall visual flags continuously to keep the troop closely together in tall grass.",
        "funFact": "They hilariously participate in furious 'stink fights' where they aggressively rub smelly scents on their tails and waft them fiercely at furious rivals!",
        "ecosystemRole": "Social ground and tree forager.",
        "diet": "Fruit, leaves, and sap.",
        "size": "Size of a house cat.",
        "sound": "Cats meowing and angry barks."
      },
      {
        "id": "ring-tailed-mongoose",
        "name": "Ring-tailed Mongoose",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-ring-tailed-mongoose.webp?v=17136131885940678146",
        "evolutionaryTrait": "Distinctive dark tail rings and incredible climbing agility thoroughly allowing them to relentlessly hunt in trees unlike most bottom-dwelling mongooses.",
        "funFact": "They are so playfully agile they can actively run completely straight down trees entirely headfirst exactly like a bizarre squirrel!",
        "ecosystemRole": "Versatile omnivore of both canopy and ground.",
        "diet": "Insects, frogs, and small lemurs.",
        "size": "Size of a ferret.",
        "sound": "A tiny growling purr."
      },
      {
        "id": "sickle-billed-vanga",
        "name": "Sickle-billed Vanga",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-sickle-billed-vanga.webp?v=10058386632734016631",
        "evolutionaryTrait": "A spectacularly curved, razor-sharp beak explicitly evolved to effortlessly probe deep into thick wood for remarkably hidden grubs.",
        "funFact": "Flocks often loudly surround an entire massive tree from top to strictly bottom just to fiercely coordinate hunting together!",
        "ecosystemRole": "A specialized bark-probing insectivore.",
        "diet": "Spiders, roaches, and grubs.",
        "size": "Size of a blue jay.",
        "sound": "A loud, wailing whistle."
      },
      {
        "id": "tomato-frog",
        "name": "Tomato Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-tomato-frog.webp?v=666446895822413768",
        "evolutionaryTrait": "A stunning, intensely bright red body color aggressively signaling its awful violently toxic taste to desperately hungry predators.",
        "funFact": "When viciously threatened, they suddenly shockingly puff completely up exactly like a dangerously angry, squishy red balloon!",
        "ecosystemRole": "Ambush predator of the damp undergrowth.",
        "diet": "Insects and worms.",
        "size": "Size of a fist.",
        "sound": "A series of low grunts."
      },
      {
        "id": "verreauxs-sifaka-lemur",
        "name": "Verreaux’s Sifaka Lemur",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-verreaux-s-sifaka-lemur.webp?v=18174581010816651428",
        "evolutionaryTrait": "Specialized jumping muscles enabling them to gracefully launch sideways from aggressively spiky trees without actually getting severely poked.",
        "funFact": "They are wildly famous as intensely crazy 'dancing lemurs' simply because they comically skip sideways wildly across the desert sand!",
        "ecosystemRole": "Folivore strictly adapted to harsh dry forests.",
        "diet": "Leaves, fruit, and bark.",
        "size": "Size of a small dog.",
        "sound": "A loud 'shi-fak' alarm call."
      },
      {
        "id": "western-falanouc",
        "name": "Western Falanouc",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-western-falanouc.webp?v=15632184335639620602",
        "evolutionaryTrait": "Peculiar, un-retractable claws uniquely evolved entirely for rapidly efficiently digging up wriggling earthworms rather than viciously catching fast prey.",
        "funFact": "They store vast quantities of solid fat aggressively inside their extremely thick tail simply to survive periods entirely when extremely dry weather stops wet rain!",
        "ecosystemRole": "A specialized nocturnal earthworm hunter.",
        "diet": "Earthworms and soft insects.",
        "size": "Size of a heavily built cat.",
        "sound": "Usually silent."
      },
      {
        "id": "ghost-mantis",
        "name": "Ghost Mantis",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-ghost-mantis.webp?v=11697321407031847741",
        "evolutionaryTrait": "Possesses incredible leaf-like camouflage with irregular edges and leaf-vein patterns.",
        "funFact": "They 'sway' in the wind when they walk to perfectly mimic a dead leaf blowing in the breeze!",
        "ecosystemRole": "An ambush predator that helps control populations of smaller insects.",
        "diet": "Small insects, especially flies and moths.",
        "size": "About 2 inches long.",
        "sound": "Mostly silent."
      },
      {
        "id": "hissing-cockroach",
        "name": "Madagascar Hissing Cockroach",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-hissing-cockroach.webp?v=893336952815562945",
        "evolutionaryTrait": "Lacks wings but possesses modified respiratory spiracles to produce a loud hiss when threatened.",
        "funFact": "They are one of the few insects to give birth to live young instead of laying eggs!",
        "ecosystemRole": "Important detritivore, breaking down fallen fruit and rotting wood on the forest floor.",
        "diet": "Fallen fruit, rotting wood, and other decaying plant matter.",
        "size": "Up to 3 inches long.",
        "sound": "A loud, startling hiss."
      },
      {
        "id": "jewel-scarab",
        "name": "Jewel Scarab (Madagascar)",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-jewel-scarab.webp?v=18110252929201359737",
        "evolutionaryTrait": "Iridescent, metallic armor that acts as camouflage in dappled sunlight and surprises predators.",
        "funFact": "Their bright, metallic colors are actually produced by structural coloration rather than pigment!",
        "ecosystemRole": "Aids in nutrient cycling by burying dung and decaying matter.",
        "diet": "Dung, decaying matter, and sometimes nectar.",
        "size": "About 1 inch long.",
        "sound": "A heavy buzzing when in flight."
      },
      {
        "id": "spiny-kite-spider",
        "name": "Spiny Kite Spider",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-spiny-kite-spider-gasteracantha.webp?v=9041193961880865815",
        "evolutionaryTrait": "A hard, spiky abdomen that acts as defensive armor against bird predators.",
        "funFact": "The elaborate spines are often brightly colored, varying dramatically to match their local environment!",
        "ecosystemRole": "Helps regulate flying insect populations within the forest canopy.",
        "diet": "Small flying insects caught in its orb web.",
        "size": "Around half an inch across (including spines).",
        "sound": "Silent."
      },
      {
        "id": "spiny-succulent-cluster",
        "name": "Spiny Forest Succulent",
        "image": "//cleverfoxplay.com/cdn/shop/files/madagascar-spiny-succulent-cluster.webp?v=6535806401173017100",
        "evolutionaryTrait": "Fleshy water-storing stems protected by formidable spikes to deter thirsty herbivores.",
        "funFact": "These plants belong to an entirely unique family of flora (Didiereaceae) almost totally endemic to Madagascar!",
        "ecosystemRole": "Provides critical moisture and shelter for specialized animals in the arid southern ranges.",
        "diet": "Sunlight and limited water (Photosynthesis).",
        "size": "Varies from small clusters to towering 40-foot spires.",
        "sound": "Silent."
      }
    ]
  },
  {
    "id": "mangrove",
    "name": "Mangrove Forest",
    "location": "The Sundarbans, India & Bangladesh",
    "description": "Forests that grow in salty ocean water. Tangled roots act as a nursery for sea life and a maze for land hunters.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/sundarbans-hero-img.webp?v=5010917888007251324",
    "color": "bg-emerald-800",
    "facts": [
      {
        "title": "Roots of the Sea",
        "content": "Mangroves are the only highly specialized trees in the world capable of thriving and growing entirely entirely in saltwater.",
        "icon": "trees"
      },
      {
        "title": "Nature's Nursery",
        "content": "Their incredibly dense, tangled roots act as crucial nurseries safely hiding juvenile fish and sharks from large predators.",
        "icon": "fish"
      },
      {
        "title": "Storm Shields",
        "content": "Mangrove forests are highly vital coastal defenders, significantly effectively absorbing the violent energy from deadly hurricanes and tsunamis.",
        "icon": "shield-alert"
      },
      {
        "title": "Incredible Carbon Sinks",
        "content": "Mangrove forests are incredibly efficient at capturing and storing carbon dioxide from the atmosphere, holding up to four times more carbon per acre than most tropical rainforests!",
        "icon": "leaf"
      }
    ],
    "animals": [
      {
        "id": "asian-palm-civet",
        "name": "Asian Palm Civet",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-asian-palm-civet.webp?v=1362620450328687049",
        "evolutionaryTrait": "A long, semi-prehensile tail to help them elegantly balance on thin, slippery mangrove branches at night.",
        "funFact": "They famously eat coffee cherries and pass the beans, which are collected to make incredibly expensive coffee!",
        "ecosystemRole": "Nocturnal seed disperser and omnivore.",
        "diet": "Fruits, insects, and small reptiles.",
        "size": "Size of a small, slender cat.",
        "sound": "Harsh metallic clucks."
      },
      {
        "id": "asian-small-clawed-otter",
        "name": "Asian Small-clawed Otter",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-asian-small-clawed-otter.webp?v=6151468076606187220",
        "evolutionaryTrait": "Extremely dexterous, partially webbed paws rather than fully webbed feet, allowing them to carefully feel for crabs in muddy water.",
        "funFact": "They are the absolute smallest otter species in the world and are incredibly social, living in large noisy families!",
        "ecosystemRole": "Mid-level aquatic predator controlling crustacean populations.",
        "diet": "Crabs, snails, and small fish.",
        "size": "Size of an American football.",
        "sound": "High-pitched squeaks and chirps."
      },
      {
        "id": "bengal-monitor",
        "name": "Bengal Monitor",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-bengal-monitor.webp?v=5502754278525082999",
        "evolutionaryTrait": "Powerful, sharply clawed limbs explicitly adapted for rapidly scrambling up thick mangrove trunks to completely escape floods.",
        "funFact": "They can cleverly stand entirely upright strictly on their hind legs to get a much better view of their surroundings!",
        "ecosystemRole": "Large opportunistic scavenger and predator.",
        "diet": "Insects, birds, and dead fish.",
        "size": "Length of a typical adult's leg.",
        "sound": "Loud, intimidating hisses."
      },
      {
        "id": "black-capped-kingfisher",
        "name": "Black-capped Kingfisher",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-black-capped-kingfisher.webp?v=1788436233145172845",
        "evolutionaryTrait": "A stunning, massive bright red bill that severely contrasts with its black cap, heavily used exactly like a spear.",
        "funFact": "They often intensely prefer chasing large insects instead of simply diving into the water for fish!",
        "ecosystemRole": "Coastal aerial predator.",
        "diet": "Crabs, insects, and small fish.",
        "size": "Size of a blue jay.",
        "sound": "A loud, ringing 'ki-ki-ki-ki'."
      },
      {
        "id": "blue-tailed-bee-eater",
        "name": "Blue-tailed Bee-eater",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-blue-tailed-bee-eater.webp?v=16043286078992520445",
        "evolutionaryTrait": "An incredibly sharp beak adapted to vigorously smash a bee's stinger against a branch before swallowing.",
        "funFact": "They are fully immune to bee stings and brilliantly rub the bee against rough bark to remove the venom!",
        "ecosystemRole": "Aerial insectivore.",
        "diet": "Bees, wasps, and dragonflies.",
        "size": "Size of a starling.",
        "sound": "A soft, rolling 'prurrup'."
      },
      {
        "id": "brown-winged-kingfisher",
        "name": "Brown-winged Kingfisher",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-brown-winged-kingfisher.webp?v=180289459929452433",
        "evolutionaryTrait": "An extraordinarily large, incredibly strong beak designed exclusively for crushing hard-shelled mangrove crabs.",
        "funFact": "They almost never hunt fish, preferring to furiously smash crabs against mangrove roots!",
        "ecosystemRole": "Specialized crustacean predator.",
        "diet": "Crabs and insects.",
        "size": "Size of a pigeon.",
        "sound": "A loud, yelping 'kew'."
      },
      {
        "id": "checkered-keelback",
        "name": "Checkered Keelback",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-checkered-keelback.webp?v=9229303228513346442",
        "evolutionaryTrait": "Highly textured, keeled scales giving them a firm grip moving over dangerously slippery mud.",
        "funFact": "When threatened, they will furiously rear up just like a cobra to appear immensely terrifying!",
        "ecosystemRole": "Semi-aquatic predator of amphibians.",
        "diet": "Frogs, fish, and toads.",
        "size": "Length of an adult's arm.",
        "sound": "A warning hiss."
      },
      {
        "id": "collared-kingfisher",
        "name": "Collared Kingfisher",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-collared-kingfisher.webp?v=6769422153545545565",
        "evolutionaryTrait": "An exceptionally loud, startling call piercing clearly precisely through dense, aggressively tangled mangrove roots.",
        "funFact": "They are spectacularly aggressive and will recklessly dive-bomb huge animals closely approaching their nest!",
        "ecosystemRole": "Common coastal and mangrove predator.",
        "diet": "Crabs, small fish, and insects.",
        "size": "Size of a robin.",
        "sound": "A harsh, repeated 'kek-kek-kek'."
      },
      {
        "id": "common-krait",
        "name": "Common Krait",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-common-krait.webp?v=4399606065908054442",
        "evolutionaryTrait": "A smooth, glossy body distinctly patterned in contrasting black and stark white carefully for nocturnal camouflage.",
        "funFact": "Their incredibly potent venom is entirely neurotoxic, famously inducing practically painless sleep rather than stinging pain!",
        "ecosystemRole": "Nocturnal apex venomous predator heavily controlling other snakes.",
        "diet": "Mainly other snakes and mice.",
        "size": "Length of a broomstick.",
        "sound": "A quiet hiss."
      },
      {
        "id": "estuarine-crocodile",
        "name": "Estuarine Crocodile",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-estuarine-crocodile.webp?v=11522565030143320196",
        "evolutionaryTrait": "Specialized, highly advanced salt glands precisely located directly on their tongue securely filtering deadly salt from ocean water.",
        "funFact": "They are the absolute largest living reptiles widely on Earth, capable of easily reaching over 20 feet long!",
        "ecosystemRole": "Apex aquatic predator perfectly maintaining ecosystem balance.",
        "diet": "Fish, monkeys, and wild pigs.",
        "size": "Length of a large car.",
        "sound": "Deep, rumbling highly resonant roars."
      },
      {
        "id": "fiddler-crab",
        "name": "Fiddler Crab",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-fiddler-crab.webp?v=11301442167967132972",
        "evolutionaryTrait": "Males exclusively possess exactly one absolutely giant claw exclusively used intensely for frantic dating waves.",
        "funFact": "If a male brutally loses his massive giant waving claw, the entirely small claw fully grows completely into the new giant one!",
        "ecosystemRole": "Vital detritivore closely aerating mudflats.",
        "diet": "Algae and microscopic decaying matter.",
        "size": "Size of a golf ball.",
        "sound": "Tiny, fast clicking noises."
      },
      {
        "id": "fishing-cat",
        "name": "Fishing Cat",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-fishing-cat.webp?v=7099522969390286086",
        "evolutionaryTrait": "Partially webbed paws intricately evolved specifically for quickly catching slippery silvery fish underwater.",
        "funFact": "Instead of wildly hating water safely like most cats do, they happily and fiercely love to swim right underwater!",
        "ecosystemRole": "Specialized semi-aquatic feline predator.",
        "diet": "Fish, frogs, and crabs.",
        "size": "Size of a stout, heavy dog.",
        "sound": "A deep, guttural meow."
      },
      {
        "id": "ganges-river-dolphin",
        "name": "Ganges River Dolphin",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-ganges-river-dolphin.webp?v=12264119052007774263",
        "evolutionaryTrait": "They are functionally blind due to living in muddy deep water, exclusively relying entirely on echolocation.",
        "funFact": "Because they lack a lens in their eye, they swim completely sideways to navigate the turbid waters!",
        "ecosystemRole": "Top aquatic predator in turbid muddy rivers.",
        "diet": "Fish and shrimp.",
        "size": "Length of a tall human.",
        "sound": "High-pitched clicking sounds."
      },
      {
        "id": "green-whip-snake",
        "name": "Green Whip Snake",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-green-whip-snake.webp?v=15419617053448541975",
        "evolutionaryTrait": "An incredibly thin and vividly green body that flawlessly mimics a living vine.",
        "funFact": "When threatened, they will dramatically puff up their neck to appear larger and more dangerous!",
        "ecosystemRole": "Canopy predator controlling small vertebrates.",
        "diet": "Lizards, frogs, and small birds.",
        "size": "Length of an adult's wingspan.",
        "sound": "A quiet hiss."
      },
      {
        "id": "hawksbill-sea-turtle",
        "name": "Hawksbill Sea Turtle",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-hawksbill-sea-turtle.webp?v=9803981458369365279",
        "evolutionaryTrait": "A sharply curved beak perfectly adapted for pulling toxic sponges out of narrow reef crevices.",
        "funFact": "Their shell is famous for its beautiful tortoiseshell pattern, which they use for camouflage among the reefs!",
        "ecosystemRole": "Crucial marine herbivore and sponge controller.",
        "diet": "Sponges, algae, and jellyfish.",
        "size": "Size of a large shield.",
        "sound": "Loud, rhythmic breathing at the surface."
      },
      {
        "id": "indian-cormorant",
        "name": "Indian Cormorant",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-indian-cormorant.webp?v=13288623463978106494",
        "evolutionaryTrait": "Feathers that intentionally lack waterproofing, allowing them to dive deeply without buoyant resistance.",
        "funFact": "After diving, they must stand on the shore with their wings spread wide to actively dry them in the sun!",
        "ecosystemRole": "Mid-level aquatic predator.",
        "diet": "Fish and aquatic invertebrates.",
        "size": "Size of a small duck.",
        "sound": "Low, guttural croaks."
      },
      {
        "id": "indian-skimmer",
        "name": "Indian Skimmer",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-indian-skimmer.webp?v=5853577789188369000",
        "evolutionaryTrait": "A highly specialized beak where the lower mandible is significantly longer than the upper, designed for skimming.",
        "funFact": "They fly low over the water with their lower beak slicing the surface, instantly snapping shut when they hit a fish!",
        "ecosystemRole": "Specialized surface-feeding aquatic predator.",
        "diet": "Small fish and crustaceans.",
        "size": "Size of a crow.",
        "sound": "A sharp, high-pitched yap."
      },
      {
        "id": "irrawaddy-dolphin",
        "name": "Irrawaddy Dolphin",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-irrawaddy-dolphin.webp?v=17241081250358947035",
        "evolutionaryTrait": "A uniquely rounded head without a prominent beak, allowing full rotating movement of their neck.",
        "funFact": "They are famous for spitting water up into the air, possibly to herd fish or simply for playful communication!",
        "ecosystemRole": "Apex predator of estuaries and coastal rivers.",
        "diet": "Fish, cephalopods, and crustaceans.",
        "size": "Length of a typical sofa.",
        "sound": "A low, blunt click."
      },
      {
        "id": "jungle-cat",
        "name": "Jungle Cat",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-jungle-cat-felis-chaus.webp?v=13906877601218087944",
        "evolutionaryTrait": "Long, tufted ears and exceptionally long legs giving them fantastic vertical leaping ability.",
        "funFact": "Despite being called 'jungle cats', they actually prefer wetlands, swamps, and dense reed beds over deep forests!",
        "ecosystemRole": "Versatile terrestrial predator.",
        "diet": "Rodents, frogs, and birds.",
        "size": "Size of a large, slender house cat.",
        "sound": "A raspy, high-pitched meow."
      },
      {
        "id": "lesser-adjutant-stork",
        "name": "Lesser Adjutant Stork",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-lesser-adjutant-stork.webp?v=6291282163061843196",
        "evolutionaryTrait": "A massive, wedge-shaped bill designed specifically to crush the hard shells of turtles and large crabs.",
        "funFact": "They are completely bare-headed and bare-necked to prevent messy feathers when probing deep into the muddy swamp!",
        "ecosystemRole": "Large terrestrial scavenger and predator.",
        "diet": "Fish, frogs, and carrion.",
        "size": "Standing over 4 feet tall.",
        "sound": "Loud bill clattering."
      },
      {
        "id": "mangrove-snake",
        "name": "Mangrove Snake",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-red-banded-mangrove-snake.webp?v=4799926477315329823",
        "evolutionaryTrait": "Strikingly brilliant black and yellow bands offering superb disruptive camouflage amidst the sun-dappled mangrove roots.",
        "funFact": "They have special grooved fangs located at the very back of their mouth to pump venom into their struggling prey!",
        "ecosystemRole": "Arboreal and semi-aquatic predator.",
        "diet": "Birds, lizards, and small mammals.",
        "size": "Length of a tall human.",
        "sound": "A soft, warning hiss."
      },
      {
        "id": "masked-finfoot",
        "name": "Masked Finfoot",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-masked-finfoot.webp?v=3738842207826704828",
        "evolutionaryTrait": "Lobed toes instead of webbed feet, allowing them to swim gracefully and walk dexterously on slippery mud.",
        "funFact": "Male finfoots literally carry their tiny newly hatched chicks safely tucked away in special pouches under their wings!",
        "ecosystemRole": "Elusive aquatic omnivore.",
        "diet": "Insects, snails, and small fish.",
        "size": "Size of a mallard duck.",
        "sound": "A sudden, loud bubbling trill."
      },
      {
        "id": "mudskipper",
        "name": "Mudskipper",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-mudskipper.webp?v=16616301381163888",
        "evolutionaryTrait": "Enlarged gill chambers that trap water securely, allowing these bizarre fish to literally breathe and walk out on land.",
        "funFact": "They violently and aggressively defend their muddy territories by leaping and dancing to impress females!",
        "ecosystemRole": "Amphibious mudflat predator and prey.",
        "diet": "Algae, worms, and tiny crabs.",
        "size": "Length of a cucumber.",
        "sound": "Tiny, wet splashes."
      },
      {
        "id": "oriental-darter",
        "name": "Oriental Darter",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-oriental-darter.webp?v=10014275947703955222",
        "evolutionaryTrait": "A remarkably long, flexible neck that acts like a loaded spring to instantly shoot and spear fish.",
        "funFact": "They swim with only their head and neck above the water, looking exactly like a dangerous slithering snake!",
        "ecosystemRole": "Specialized aquatic ambush predator.",
        "diet": "Primarily fish.",
        "size": "Size of a large heron.",
        "sound": "A clicking, harsh croak."
      },
      {
        "id": "osprey",
        "name": "Osprey",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-osprey.webp?v=8603743192139146265",
        "evolutionaryTrait": "Reversible outer toes and spiky footpads flawlessly adapted exclusively for firmly securing struggling slippery fish.",
        "funFact": "When flying away aggressively with a heavy fish, they smartly turn the catch head-first to be aerodynamically swift!",
        "ecosystemRole": "Apex aerial predator of fish.",
        "diet": "Exclusively fish.",
        "size": "Wingspan of a tall human.",
        "sound": "High-pitched, whistling chirps."
      },
      {
        "id": "painted-stork",
        "name": "Painted Stork",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-painted-stork.webp?v=3480172951341137581",
        "evolutionaryTrait": "A gently curved yellow beak perfectly evolved exactly for intensely sweeping effectively through muddy shallow water.",
        "funFact": "They boldly defecate directly on their own long legs simply to cool themselves off in the hot sun!",
        "ecosystemRole": "Wetland wader and shallow water predator.",
        "diet": "Fish, frogs, and insects.",
        "size": "Standing roughly 3 feet tall.",
        "sound": "Usually silent, occasional bill clattering."
      },
      {
        "id": "pied-kingfisher",
        "name": "Pied Kingfisher",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-pied-kingfisher.webp?v=1584685416271490273",
        "evolutionaryTrait": "Uniquely boldly black and white patterned feathers that provide excellent camouflage against the sparkling water surface.",
        "funFact": "They are one of the few kingfishers capable of hovering perfectly still over the water before plunging straight down!",
        "ecosystemRole": "Aerial predator of small fish.",
        "diet": "Small fish and aquatic insects.",
        "size": "Size of a large thrush.",
        "sound": "A sharp, chattering 'kik-kik-kik'."
      },
      {
        "id": "rhesus-macaque",
        "name": "Rhesus Macaque",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-rhesus-macaque.webp?v=8904334021017323172",
        "evolutionaryTrait": "Highly adaptable, generalized teeth explicitly incredibly intelligently distinctly adapted for a vast omnivorous diet.",
        "funFact": "They are amazingly strong swimmers and are completely comfortable diving into mangrove waters to escape danger!",
        "ecosystemRole": "Intelligent omnivorous primate and seed disperser.",
        "diet": "Fruits, seeds, roots, and sometimes crabs.",
        "size": "Size of a medium dog.",
        "sound": "Loud chatters and warning barks."
      },
      {
        "id": "royal-bengal-tiger",
        "name": "Royal Bengal Tiger",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-royal-bengal-tiger.webp?v=2269138046029706806",
        "evolutionaryTrait": "Massively muscular builds and broad paving-stone paws meant to traverse deep sticky mud without sinking.",
        "funFact": "They are the only tigers in the world that live and hunt completely within mangrove forests!",
        "ecosystemRole": "Apex terrestrial and semi-aquatic predator.",
        "diet": "Deer, wild boar, and monkeys.",
        "size": "Weight of three adult humans.",
        "sound": "Deafening, resonant roars."
      },
      {
        "id": "ruddy-kingfisher",
        "name": "Ruddy Kingfisher",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-ruddy-kingfisher.webp?v=12978341267548711920",
        "evolutionaryTrait": "A huge, striking bright red bill acting as a heavy-duty pair of pliers to crack open tough forest prey.",
        "funFact": "Despite being completely neon orange-red, they perfectly disappear when sitting silently in the dappled mangrove shade!",
        "ecosystemRole": "Forest understory predator.",
        "diet": "Large insects, frogs, and lizards.",
        "size": "Size of a typical kingfisher.",
        "sound": "A descending 'cor-cor-cor'."
      },
      {
        "id": "small-indian-civet",
        "name": "Small Indian Civet",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-small-indian-civet.webp?v=14452517761031653689",
        "evolutionaryTrait": "A sleek, elongated body enabling it to effortlessly slip through unbelievably dense thickets of tangled mangrove roots.",
        "funFact": "They produce a highly pungent scent from special glands that historically was collected to make expensive perfumes!",
        "ecosystemRole": "Nocturnal ground-dwelling omnivore.",
        "diet": "Rodents, birds, snakes, and fruit.",
        "size": "Size of an elongated house cat.",
        "sound": "Spits and hisses."
      },
      {
        "id": "small-mongoose",
        "name": "Small Mongoose",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-small-mongoose.webp?v=9993625007726614099",
        "evolutionaryTrait": "Lightning-fast reflexes enabling it to effortlessly dodge the lethal strikes of venomous snakes.",
        "funFact": "They have thick, stiff fur that fluffs up dramatically when fighting to make snake bites miss their actual skin!",
        "ecosystemRole": "Terrestrial predator controlling snake and rodent populations.",
        "diet": "Rodents, snakes, insects.",
        "size": "Size of a squirrel.",
        "sound": "High-pitched chatters and squeaks."
      },
      {
        "id": "spotted-pond-turtle",
        "name": "Spotted Pond Turtle",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-spotted-pond-turtle.webp?v=13604123336516583087",
        "evolutionaryTrait": "A beautifully spotted, slightly flattened shell aiding in hydrodynamics and muddy camouflage.",
        "funFact": "They are incredibly shy and will quickly dive straight to the muddy bottom at the slightest hint of any danger!",
        "ecosystemRole": "Aquatic omnivore and scavenger.",
        "diet": "Aquatic plants, snails, and dead fish.",
        "size": "Size of a dinner plate.",
        "sound": "Quiet hiss."
      },
      {
        "id": "stork-billed-kingfisher",
        "name": "Stork-billed Kingfisher",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-stork-billed-kingfisher.webp?v=10350341463194536943",
        "evolutionaryTrait": "An extraordinarily large, terribly strong beak heavily designed explicitly for crushing crabs and fish.",
        "funFact": "They furiously defend their fishing territories and will even confidently dive-bomb eagles and herons!",
        "ecosystemRole": "Dominant kingfisher of the mangrove canopy.",
        "diet": "Fish, crabs, and frogs.",
        "size": "Size of a pigeon.",
        "sound": "A loud, laughing 'ke-ke-ke-ke'."
      },
      {
        "id": "white-throated-kingfisher",
        "name": "White-throated Kingfisher",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-white-throated-kingfisher.webp?v=6061451240998623811",
        "evolutionaryTrait": "A rich chestnut body and blinding white throat helping camouflage them among both dirt banks and foliage.",
        "funFact": "They rarely dive into the water, vastly preferring to aggressively dive-bomb grasshoppers and lizards on dry land!",
        "ecosystemRole": "Pre-dominantly terrestrial predator.",
        "diet": "Large insects, lizards, and small rodents.",
        "size": "Size of a robin.",
        "sound": "A cheerful trill."
      },
      {
        "id": "yellow-monitor",
        "name": "Yellow Monitor",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-yellow-monitor.webp?v=7028938555440797920",
        "evolutionaryTrait": "Strong limbs and sharp claws allowing it to efficiently dig into muddy banks to uncover turtle eggs.",
        "funFact": "Unlike other monitors, they naturally have beautiful yellow and black striped patterns especially vibrant when they are young!",
        "ecosystemRole": "Important scavenger and predator of the mangrove understory.",
        "diet": "Eggs, frogs, and carrion.",
        "size": "Length of an adult's arm.",
        "sound": "Loud, intimidating hisses."
      },
      {
        "id": "eurasian-spoonbill",
        "name": "Eurasian Spoonbill",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-eurasian-spoonbill.webp?v=9757921903425787622",
        "evolutionaryTrait": "Unique spatula-shaped bill used to sweep side-to-side through shallow water to catch prey.",
        "funFact": "They sweep their semi-open bill through the water in a sweeping motion, snapping it shut when they feel prey!",
        "ecosystemRole": "Helps control populations of small aquatic organisms in the shallow mangrove waters.",
        "diet": "Small fish, crustaceans, and aquatic insects.",
        "size": "About 3 feet tall.",
        "sound": "Mostly silent, occasional grunts."
      },
      {
        "id": "great-frigatebird",
        "name": "Great Frigatebird",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-great-frigatebird.webp?v=8360572348961224120",
        "evolutionaryTrait": "Huge wingspan relative to body weight allows them to glide effortlessly for weeks without landing.",
        "funFact": "Males inflate a bright red throat pouch like a balloon to attract females during mating season!",
        "ecosystemRole": "An apex aerial predator that often steals food from other seabirds (kleptoparasitism).",
        "diet": "Fish, squid, and chicks of other seabirds.",
        "size": "Wingspan up to 7.5 feet.",
        "sound": "Silent at sea, clattering and drumming at the nest."
      },
      {
        "id": "lanternfly",
        "name": "Lanternfly (Pyrops)",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-lanternfly-pyrops.webp?v=12489525299643768727",
        "evolutionaryTrait": "Elongated, snout-like head structure that was once mistakenly believed to emit light.",
        "funFact": "Their long 'snout' might act as a resonance chamber to amplify their calls, or to deter predators by mimicking a twig or thorn!",
        "ecosystemRole": "Herbivore that feeds on tree sap; acts as prey for birds and spiders.",
        "diet": "Sap from trees.",
        "size": "About 1.5 to 3 inches long.",
        "sound": "Silent to humans."
      },
      {
        "id": "mangrove-pneumatophore",
        "name": "Pneumatophore Patch",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-mangrove-pneumatophore-patch.webp?v=4939469579420809669",
        "evolutionaryTrait": "Specialized aerial roots that grow upward out of the oxygen-poor mud to breathe air.",
        "funFact": "These roots act like snorkels, allowing the main roots buried in the suffocating mud to survive!",
        "ecosystemRole": "Traps sediment to build land, preventing coastal erosion and providing habitat for crabs and snails.",
        "diet": "Sunlight and nutrients (Photosynthesis).",
        "size": "Roots can stick up several inches to over a foot from the mud.",
        "sound": "Silent."
      },
      {
        "id": "telescope-snail",
        "name": "Telescope Snail",
        "image": "//cleverfoxplay.com/cdn/shop/files/sundarbans-telescope-snail.webp?v=15822839135313497688",
        "evolutionaryTrait": "A tightly coiled, heavily ridged shell that protects it from the crushing claws of hungry crabs.",
        "funFact": "They are often found slowly creeping over the exposed mudflats during low tide, feeding on algae!",
        "ecosystemRole": "Important grazer that processes algae and detritus, cycling nutrients back into the ecosystem.",
        "diet": "Detritus and benthic microalgae.",
        "size": "About 3 to 4 inches long.",
        "sound": "Silent."
      }
    ]
  },
  {
    "id": "namib",
    "name": "Namib Sand Sea",
    "location": "Sossusvlei, Namibia",
    "description": "The world's oldest desert with towering red dunes. Animals drink ocean fog that rolls in from the coast.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/namibdune-hero-img.webp?v=16143554688763610248",
    "color": "bg-amber-600",
    "facts": [
      {
        "title": "Sea of Sand",
        "content": "The Namib is widely considered the oldest desert in the entire world, having been totally arid for at least 55 million years.",
        "icon": "sun"
      },
      {
        "title": "Fog Drinkers",
        "content": "Because rain is incredibly rare, many highly specialized animals survive completely by drinking the thick ocean fog that rolls gently in from the coast.",
        "icon": "cloud-drizzle"
      },
      {
        "title": "Endemic Wonders",
        "content": "The harsh conditions have forced incredible evolution, creating bizarre creatures effectively found nowhere else on earth.",
        "icon": "sparkles"
      },
      {
        "title": "The Oldest Desert",
        "content": "The Namib is widely considered to be the oldest desert in the entire world, having endured relentlessly arid conditions for at least 55 million years.",
        "icon": "hourglass"
      }
    ],
    "animals": [
      {
        "id": "african-wildcat",
        "name": "African Wildcat",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-african-wildcat.webp?v=10741725142761007825",
        "evolutionaryTrait": "Extraordinary hearing allowing them to pinpoint the exact location of a gerbil moving underground.",
        "funFact": "They are the fierce wild ancestors of all the cuddly domestic cats resting in homes today!",
        "ecosystemRole": "Nocturnal predator of small rodents and birds.",
        "diet": "Mice, birds, and insects.",
        "size": "Size of a lean house cat.",
        "sound": "Hisses, purrs, and meows."
      },
      {
        "id": "antlion-larva",
        "name": "Antlion Larva",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-antlion-larva-pit.webp?v=9924378935699705437",
        "evolutionaryTrait": "Massive, hollow jaws designed to inject digestive enzymes into ants trapped in their sand pits.",
        "funFact": "They dig perfectly conical traps in loose sand and wait at the bottom to ambush falling insects!",
        "ecosystemRole": "Micro ambush predator of the sand.",
        "diet": "Ants and small insects.",
        "size": "Size of a fingernail.",
        "sound": "Silent."
      },
      {
        "id": "bat-eared-fox",
        "name": "Bat-eared Fox",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-bat-eared-fox.webp?v=13200475197173738257",
        "evolutionaryTrait": "Enormous ears that radiate intense desert heat and can perfectly hear termites chewing underground.",
        "funFact": "Unlike most foxes, they have specialized jaws rapidly adapted to chew exactly thousands of termites!",
        "ecosystemRole": "Insectivore controlling termite populations.",
        "diet": "Primarily termites and beetles.",
        "size": "Size of a small dog.",
        "sound": "Soft whistling calls."
      },
      {
        "id": "black-backed-jackal",
        "name": "Black-backed Jackal",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-black-backed-jackal.webp?v=2221794846441271117",
        "evolutionaryTrait": "A highly adaptable digestive system that lets them eat almost anything they find in the harsh desert.",
        "funFact": "They boldly steal food directly from the kills of much larger predators like lions and hyenas!",
        "ecosystemRole": "Opportunistic scavenger and predator.",
        "diet": "Carrion, rodents, insects, and berries.",
        "size": "Size of a medium dog.",
        "sound": "A high, wailing howl."
      },
      {
        "id": "brown-hyena",
        "name": "Brown Hyena",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-brown-hyena.webp?v=2466518831901596652",
        "evolutionaryTrait": "Incredibly powerful jaws capable of completely cracking the thickest sun-baked bones left by other hunters.",
        "funFact": "They often walk along the desert beaches to scavenge for washed-up dead seals and fish!",
        "ecosystemRole": "Apex scavenger of the desert.",
        "diet": "Bones, carrion, and eggs.",
        "size": "Size of a large, shaggy dog.",
        "sound": "Deep grunts and squeaks."
      },
      {
        "id": "cape-fox",
        "name": "Cape Fox",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-cape-fox.webp?v=12600986707317844998",
        "evolutionaryTrait": "A silvery-grey coat that perfectly reflects the scorching sun and blends into the dry scrub.",
        "funFact": "They are the only true fox species found natively in the southern part of Africa!",
        "ecosystemRole": "Small nocturnal predator.",
        "diet": "Insects, mice, and fruit.",
        "size": "Size of a house cat.",
        "sound": "A sharp, high bark."
      },
      {
        "id": "cape-ground-squirrel",
        "name": "Cape Ground Squirrel",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-cape-ground-squirrel.webp?v=6570013169710033893",
        "evolutionaryTrait": "A bushy tail they hold over their head explicitly like a built-in umbrella to shade themselves from the sun.",
        "funFact": "They live in bustling subterranean towns and sometimes share burrows with harmless meerkats!",
        "ecosystemRole": "Burrowing herbivore.",
        "diet": "Roots, bulbs, and seeds.",
        "size": "Size of a rat.",
        "sound": "Piercing alarm whistles."
      },
      {
        "id": "cape-hare",
        "name": "Cape Hare",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-cape-hare-bro.webp?v=4671456968095436526",
        "evolutionaryTrait": "Extraordinarily long, powerful hind legs allowing them to sprint away from predators at blinding speeds.",
        "funFact": "Rather than seeking shelter underground, they bravely hide in plain sight relying purely on perfect camouflage!",
        "ecosystemRole": "Primary prey species for desert carnivores.",
        "diet": "Dry grasses and scrub.",
        "size": "Size of a small dog.",
        "sound": "A loud squeal when chased."
      },
      {
        "id": "desert-gerbil",
        "name": "Desert Gerbil",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-desert-gerbil.webp?v=12218322733931319056",
        "evolutionaryTrait": "Highly efficient kidneys allowing them to extract all necessary moisture completely from dry seeds.",
        "funFact": "They thump their large back feet loudly against the sand to warn their family of approaching snakes!",
        "ecosystemRole": "Nocturnal seed consumer.",
        "diet": "Seeds, roots, and insects.",
        "size": "Size of a mouse.",
        "sound": "High-pitched squeaks."
      },
      {
        "id": "desert-scorpion",
        "name": "Desert Scorpion",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-desert-scorpion.webp?v=18161418112729473860",
        "evolutionaryTrait": "A robust exoskeleton covered in tiny sensory hairs to detect the vibrations of approaching prey.",
        "funFact": "Under ultraviolet blacklight, their entire armored body brilliantly glows an alien neon green!",
        "ecosystemRole": "Arthropod predator controlling insect populations.",
        "diet": "Insects and spiders.",
        "size": "Length of a human finger.",
        "sound": "Silent."
      },
      {
        "id": "dune-lark",
        "name": "Dune Lark",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-dune-lark.webp?v=7470577181753664257",
        "evolutionaryTrait": "Plumage that perfectly matches the exact red-orange color of the specific Namib dunes they live on.",
        "funFact": "They are the only bird in the entire world completely restricted solely to the Namib Sand Sea!",
        "ecosystemRole": "Insectivore and seed disperser of the dunes.",
        "diet": "Insects and seeds.",
        "size": "Size of a sparrow.",
        "sound": "A melodic, trilling song."
      },
      {
        "id": "grants-golden-mole",
        "name": "Grant’s Golden Mole",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-grant-s-golden-mole.webp?v=3571264752993025259",
        "evolutionaryTrait": "Complete lack of eyes and incredibly dense, iridescent fur that lets them literally swim smoothly through the sand.",
        "funFact": "Since they are blind, they locate their prey by 'swimming' through the sand and feeling the faint vibrations!",
        "ecosystemRole": "Subterranean predator of the dunes.",
        "diet": "Termites, ants, and legless lizards.",
        "size": "Size of a small potato.",
        "sound": "Silent."
      },
      {
        "id": "grays-lark",
        "name": "Gray’s Lark",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-gray-s-lark.webp?v=15972919995135148275",
        "evolutionaryTrait": "Extra pale, sandy-colored feathers allowing them to blend seamlessly into the gravel plains bordering the dunes.",
        "funFact": "They build their tiny nests cleverly positioned on the shady side of rocks to avoid the baking afternoon sun!",
        "ecosystemRole": "Ground-dwelling insectivore.",
        "diet": "Seeds and small insects.",
        "size": "Size of a sparrow.",
        "sound": "A sharp, simple chirp."
      },
      {
        "id": "greater-kestrel",
        "name": "Greater Kestrel",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-greater-kestrel.webp?v=16468874542046367191",
        "evolutionaryTrait": "A sharp, hooked beak and excellent vision adapted for spotting small movement from high above the arid plains.",
        "funFact": "They frequently hover completely motionless mid-air facing into the strong desert winds while searching for mice!",
        "ecosystemRole": "Aerial predator of small reptiles and mammals.",
        "diet": "Rodents, lizards, and large insects.",
        "size": "Size of a pigeon.",
        "sound": "A repetitive, shrill 'kee-kee'."
      },
      {
        "id": "honey-badger",
        "name": "Honey Badger",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-honey-badger.webp?v=4949574260632417926",
        "evolutionaryTrait": "Loose, incredibly thick skin that allows them to twist around and bite an attacker even if they are grabbed.",
        "funFact": "They are famous for their sheer fearlessness and will boldly stand their ground against lions and venomous snakes!",
        "ecosystemRole": "Fierce opportunistic predator and scavenger.",
        "diet": "Snakes, rodents, honey, and insects.",
        "size": "Size of a stout, medium dog.",
        "sound": "A harsh, rattling growl."
      },
      {
        "id": "horned-viper",
        "name": "Horned Viper",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-horned-viper.webp?v=17684528517827656485",
        "evolutionaryTrait": "Two distinct horn-like scales over its eyes that may help keep blowing sand out of its vision.",
        "funFact": "They move across the hot dunes using a unique 'sidewinding' motion that barely touches the burning sand!",
        "ecosystemRole": "Ambush predator of the dunes.",
        "diet": "Lizards and small rodents.",
        "size": "Length of an adult's arm.",
        "sound": "A rasping hiss created by rubbing scales."
      },
      {
        "id": "lanner-falcon",
        "name": "Lanner Falcon",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-lanner-falcon.webp?v=13014547309392215074",
        "evolutionaryTrait": "Extremely swift, aerodynamic wings built exactly for aggressive horizontal pursuit of smaller birds over open landscapes.",
        "funFact": "Pairs often hunt cooperatively, with one bird flushing a pigeon out while the other swoops in for the catch!",
        "ecosystemRole": "High-speed aerial predator.",
        "diet": "Pigeons, sandgrouse, and small bats.",
        "size": "Size of a crow.",
        "sound": "A loud, shrill 'kak-kak-kak'."
      },
      {
        "id": "lappet-faced-vulture",
        "name": "Lappet-faced Vulture",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-lappet-faced-vulture.webp?v=1845481610157026960",
        "evolutionaryTrait": "A colossal, exceptionally strong beak designed perfectly to tear through tough hides that other scavengers cannot break.",
        "funFact": "Because they are so large and dominant, other smaller vultures must wait until these giants finish eating!",
        "ecosystemRole": "Primary scavenger preventing the spread of disease.",
        "diet": "Carrion and bone fragments.",
        "size": "Wingspan of nearly 9 feet.",
        "sound": "Hisses and grunts."
      },
      {
        "id": "meerkat",
        "name": "Meerkat",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-meerkat.webp?v=17223326745253189296",
        "evolutionaryTrait": "Dark patches around their eyes that act precisely like built-in sunglasses to reduce the glaring desert sun.",
        "funFact": "They take turns standing guard on high mounds to watch for eagles while the rest of the family safely digs!",
        "ecosystemRole": "Social insectivore.",
        "diet": "Scorpions, beetles, and grubs.",
        "size": "Size of a squirrel.",
        "sound": "A constant chirping chatter."
      },
      {
        "id": "namaqua-chameleon",
        "name": "Namaqua Chameleon",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-namaqua-chameleon.webp?v=8208961139132327838",
        "evolutionaryTrait": "The ability to change color not just for camouflage, but specifically to absorb heat when black and reflect heat when white.",
        "funFact": "Unlike typical slow-moving chameleons in trees, they rapidly sprint directly across the hot sand to chase down bugs!",
        "ecosystemRole": "Terrestrial ambush predator.",
        "diet": "Beetles, locusts, and small lizards.",
        "size": "Length of a ruler.",
        "sound": "A defensive hiss."
      },
      {
        "id": "namaqua-dove",
        "name": "Namaqua Dove",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-namaqua-dove.webp?v=12223374177652122572",
        "evolutionaryTrait": "An exceptionally long, pointed tail allowing them to fly extremely fast and maneuver quickly away from falcons.",
        "funFact": "The male has a striking stark black face mask that stands out boldly against his pale body!",
        "ecosystemRole": "Seed consumer and prey species.",
        "diet": "Small seeds.",
        "size": "Size of a small sparrow.",
        "sound": "A soft, quiet 'coo'."
      },
      {
        "id": "namib-desert-beetle",
        "name": "Namib Desert Beetle",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-namib-desert-beetle.webp?v=15634710903410503286",
        "evolutionaryTrait": "A bumpy shell that perfectly collects microscopic ocean fog droplets which then simply roll down directly into its mouth.",
        "funFact": "They boldly stand on their heads facing the morning breeze to drink the fog condensing on their own backs!",
        "ecosystemRole": "Detritivore and vital moisture source for predators.",
        "diet": "Wind-blown plant debris.",
        "size": "Size of a blueberry.",
        "sound": "Silent."
      },
      {
        "id": "namib-sand-gecko",
        "name": "Namib Sand Gecko",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-namib-sand-gecko.webp?v=17134894981105496931",
        "evolutionaryTrait": "Highly specialized webbed feet that act as snowshoes to prevent them from sinking into the loose, shifting sand.",
        "funFact": "They are almost entirely translucent, meaning securely in bright light you can almost see their internal organs!",
        "ecosystemRole": "Nocturnal predator of small dunes insects.",
        "diet": "Termites and small beetles.",
        "size": "Length of a banana.",
        "sound": "A soft click."
      },
      {
        "id": "oryx",
        "name": "Oryx",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-oryx.webp?v=4416585047545476979",
        "evolutionaryTrait": "A specialized network of blood vessels in their nose that safely cools their blood before it reaches their brain.",
        "funFact": "They can survive amazingly for weeks entirely without drinking any water, getting all their moisture just from desert melons!",
        "ecosystemRole": "Large nomadic herbivore.",
        "diet": "Tough desert grasses, roots, and melons.",
        "size": "Size of a small horse.",
        "sound": "Usually silent, occasional snorts."
      },
      {
        "id": "ostrich",
        "name": "Ostrich",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-ostrich.webp?v=11563067384973386966",
        "evolutionaryTrait": "Enormous, heavily muscled legs with only two toes allowing them to run across the blazing desert at highway speeds.",
        "funFact": "They have the largest eye of any land animal, which is actually physically larger than their entire brain!",
        "ecosystemRole": "Dominant massive omnivore of the plains.",
        "diet": "Grasses, seeds, and insects.",
        "size": "Standing over 8 feet tall.",
        "sound": "A deep, booming roar."
      },
      {
        "id": "pale-chanting-goshawk",
        "name": "Pale Chanting Goshawk",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-pale-chanting-goshawk.webp?v=16697405751728012487",
        "evolutionaryTrait": "Long, orange legs specifically adapted to bravely stalk and swiftly strike at venomous snakes amongst the thorn bushes.",
        "funFact": "They frequently politely follow honey badgers around, smartly waiting to grab lizards that the badger scares out of hiding!",
        "ecosystemRole": "Medium aerial and terrestrial predator.",
        "diet": "Lizards, snakes, and small rodents.",
        "size": "Size of a large crow.",
        "sound": "A melodic, chanting whistle."
      },
      {
        "id": "puff-adder",
        "name": "Puff Adder",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-puff-adder.webp?v=7650207411152953336",
        "evolutionaryTrait": "An incredibly stout, muscular body and deadly venom perfectly adapted for a strictly ambush-style hunting approach.",
        "funFact": "Instead of slithering away, they freeze absolutely perfectly still in the dirt which sadly makes them easy to step on!",
        "ecosystemRole": "Ambush predator controlling rodent numbers.",
        "diet": "Rats, mice, and ground birds.",
        "size": "Length of a baseball bat.",
        "sound": "A very loud, warning puffing hiss."
      },
      {
        "id": "rock-hyrax",
        "name": "Rock Hyrax",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-rock-hyrax.webp?v=7323670036079181925",
        "evolutionaryTrait": "Rubber-like footpads equipped with special sweat glands that stick perfectly to smooth, extremely steep rock faces.",
        "funFact": "Despite looking exactly like a large furry guinea pig, their closest living relative is actually the massive elephant!",
        "ecosystemRole": "Herbivore of rocky desert outcrops.",
        "diet": "Grasses, leaves, and bark.",
        "size": "Size of a plump rabbit.",
        "sound": "Loud, screaming barks."
      },
      {
        "id": "ruppells-korhaan",
        "name": "Rüppell’s Korhaan",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-ru-ppell-s-korhaan.webp?v=8948489312396765097",
        "evolutionaryTrait": "Exceptionally camouflaged feathers specifically designed to render them completely invisible against the gravel plains.",
        "funFact": "Males perform a bizarre frog-like croaking display while proudly dropping their head completely below their shoulders!",
        "ecosystemRole": "Ground-dwelling omnivore.",
        "diet": "Insects and seeds.",
        "size": "Size of a chicken.",
        "sound": "A frog-like croak."
      },
      {
        "id": "secretary-bird",
        "name": "Secretary Bird",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-secretary-bird.webp?v=2252536525895575438",
        "evolutionaryTrait": "Remarkably long, crane-like legs equipped with thick scales purposely to protect them from venomous snake bites.",
        "funFact": "They boldly aggressively hunt by furiously stomping venomous snakes to death with the force of a hammer!",
        "ecosystemRole": "Terrestrial bird of prey.",
        "diet": "Snakes, lizards, and rodents.",
        "size": "Standing nearly 4 feet tall.",
        "sound": "A deep, croaking grunt."
      },
      {
        "id": "shovel-snouted-lizard",
        "name": "Shovel-snouted Lizard",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-shovel-snouted-lizard.webp?v=181868603932395190",
        "evolutionaryTrait": "A uniquely flat, shovel-like snout perfectly designed simply to dive instantly and loudly into the loose sand when frightened.",
        "funFact": "To avoid burning their feet, they perform a hilarious 'thermal dance', continuously lifting alternating feet off the hot sand!",
        "ecosystemRole": "Diurnal insectivore of the dunes.",
        "diet": "Beetles and ants.",
        "size": "Length of a hand.",
        "sound": "Silent."
      },
      {
        "id": "spider-hunting-wasp",
        "name": "Spider-hunting Wasp",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-spider-hunting-wasp.webp?v=14875660428890358152",
        "evolutionaryTrait": "A potent venom specifically adapted solely to paralyze, but purposefully not kill, large heavy desert spiders.",
        "funFact": "They drag a paralyzed, fully living spider down into a burrow and lay a single egg securely on it for the larva to eat!",
        "ecosystemRole": "Top predator of large arachnids.",
        "diet": "Large spiders.",
        "size": "Size of a large thumb.",
        "sound": "A loud buzz."
      },
      {
        "id": "springbok",
        "name": "Springbok",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-springbok.webp?v=5079828062311544795",
        "evolutionaryTrait": "A hidden pocket of stark white hair on their back that vividly flashes to warn others when they leap violently into the air.",
        "funFact": "When excited or nervous, they beautifully perform a stiff-legged jumping display famously called 'pronking'!",
        "ecosystemRole": "Highly mobile desert herbivore.",
        "diet": "Grasses and leaves.",
        "size": "Size of a goat.",
        "sound": "A loud snort or whistle."
      },
      {
        "id": "termites",
        "name": "Termites",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-termites.webp?v=8414227133064145511",
        "evolutionaryTrait": "The collective architectural ability distinctly to build massive, towering mud structures that stay naturally cool inside.",
        "funFact": "Their massive underground colonies are secretly the absolute foundational food source supporting entirely almost all small desert predators!",
        "ecosystemRole": "Vital recycler and primary prey base.",
        "diet": "Dead grass and dry wood.",
        "size": "Size of a grain of rice.",
        "sound": "A faint rustling."
      },
      {
        "id": "tractrac-chat",
        "name": "Tractrac Chat",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-tractrac-chat.webp?v=7974808269643428076",
        "evolutionaryTrait": "A highly contrasting white rump that prominently flashes brightly when they surprisingly bound rapidly across the desert floor.",
        "funFact": "They are famous for their remarkable tameness and will easily playfully follow hikers seeking insects kicked up by their boots!",
        "ecosystemRole": "Ground-foraging insectivore.",
        "diet": "Ants, beetles, and termites.",
        "size": "Size of a sparrow.",
        "sound": "A rapid, ticking 'trac-trac' call."
      },
      {
        "id": "dune-snail-trigonephrus",
        "name": "Dune Snail (Trigonephrus)",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-dune-snail-trigonephrus.webp?v=8974605918467939475",
        "evolutionaryTrait": "Thick, white shell reflects intense sunlight and acts as an insulated shelter.",
        "funFact": "They can seal the opening of their shell with a mucous plug and sleep deep under the sand for years waiting for rain!",
        "ecosystemRole": "Processes detritus and serves as an important calcium source for predators like meerkats.",
        "diet": "Dead plant matter and lichens.",
        "size": "About 1 to 2 inches across.",
        "sound": "Silent."
      },
      {
        "id": "giant-velvet-mite",
        "name": "Giant Velvet Mite",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-giant-velvet-mite.webp?v=11097736682521257919",
        "evolutionaryTrait": "Covered in bright red, velvety hairs that warn predators of their terrible taste.",
        "funFact": "They emerge from the sand in huge numbers after rare rains, looking like a moving red carpet!",
        "ecosystemRole": "Important predator that controls termite and small insect populations.",
        "diet": "Termites, small insects, and insect eggs.",
        "size": "About half an inch long.",
        "sound": "Silent."
      },
      {
        "id": "golden-wheel-spider",
        "name": "Golden Wheel Spider",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-golden-wheel-spider.webp?v=12798309224834963781",
        "evolutionaryTrait": "Can fold its legs into a wheel shape to cartwheel rapidly down steep sand dunes to escape predators.",
        "funFact": "They build trapdoors lined with silk in the sand, ambushing prey that walks too close!",
        "ecosystemRole": "Ambush predator controlling insect populations.",
        "diet": "Insects and occasionally small lizards.",
        "size": "About 1 inch across.",
        "sound": "Silent."
      },
      {
        "id": "namib-desert-rose",
        "name": "Namib Desert Rose",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-namib-desert-rose.webp?v=13964740154880910560",
        "evolutionaryTrait": "A swollen, water-storing caudex (trunk) and highly toxic sap to prevent herbivory.",
        "funFact": "Despite its tough, poisonous exterior, it blooms with beautiful, bright pink flowers to attract rare desert pollinators!",
        "ecosystemRole": "Provides nectar for specialized insects in an extremely harsh environment.",
        "diet": "Sunlight and limited water (Photosynthesis).",
        "size": "Can grow up to 10 feet tall.",
        "sound": "Silent."
      },
      {
        "id": "nara-melon-bush",
        "name": "!Nara Melon Bush",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-nara-melon-bush.webp?v=5705465061344661553",
        "evolutionaryTrait": "Lacks leaves entirely to prevent water loss; photosynthesizes using sharp, green thorns.",
        "funFact": "Its roots can plunge up to 150 feet down into the dunes to find hidden groundwater!",
        "ecosystemRole": "Crucial food source for many desert animals like the brown hyena, oryx, and ostriches.",
        "diet": "Sunlight and deep groundwater (Photosynthesis).",
        "size": "Sprawling bush covering up to 1500 square feet.",
        "sound": "Silent."
      },
      {
        "id": "welwitschia-mirabilis",
        "name": "Welwitschia Mirabilis",
        "image": "//cleverfoxplay.com/cdn/shop/files/namibdune-welwitschia-mirabilis.webp?v=1436263079635355237",
        "evolutionaryTrait": "Only ever grows two massive, leathery leaves that continually grow from the base and split over centuries.",
        "funFact": "It is considered a 'living fossil'—some individual plants in the Namib Desert are estimated to be over 2,000 years old!",
        "ecosystemRole": "Provides shade and microhabitats for countless insects and small reptiles in extreme heat.",
        "diet": "Sunlight and coastal fog (Photosynthesis).",
        "size": "Leaves can grow over 13 feet long.",
        "sound": "Silent."
      }
    ]
  },
  {
    "id": "pantanal",
    "name": "Pantanal Wetlands",
    "location": "Brazil",
    "description": "The largest tropical wetland. Annual floods turn the land into a giant shallow sea. A paradise for reptiles and big cats.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-hero-img.webp?v=7722176343085887870",
    "color": "bg-green-600",
    "facts": [
      {
        "title": "The Largest Wetland",
        "content": "The Pantanal is genuinely the absolute largest continuous tropical wetland system anywhere on the entire planet.",
        "icon": "waves"
      },
      {
        "title": "A Shifting Landscape",
        "content": "During the dramatic wet season, up to eighty percent of the entire basin is fully submerged completely underwater.",
        "icon": "cloud-rain"
      },
      {
        "title": "Wildlife Haven",
        "content": "It beautifully boasts the absolute highest concentration of diverse stunning wildlife found anywhere explicitly in South America.",
        "icon": "bird"
      },
      {
        "title": "Fish the Fly",
        "content": "When the waters recede during the dry season, millions of fish become trapped in shrinking pools, drawing massive flocks of wading birds for an absolute feeding frenzy.",
        "icon": "waves"
      }
    ],
    "animals": [
      {
        "id": "black-howler-monkey",
        "name": "Black Howler Monkey",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-black-howler-monkey.webp?v=13090301450628335780",
        "evolutionaryTrait": "A specialized enlarged hyoid bone in their throat that lets them project booming calls for miles.",
        "funFact": "Their howling roar is one of the loudest sounds produced by any land animal on the planet!",
        "ecosystemRole": "Canopy herbivore and seed disperser.",
        "diet": "Leaves, fruit, and flowers.",
        "size": "Size of a small dog.",
        "sound": "A deep, booming, guttural roar."
      },
      {
        "id": "black-tailed-marmoset",
        "name": "Black-tailed Marmoset",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-black-tailed-marmoset.webp?v=14872407735426564780",
        "evolutionaryTrait": "Sharp claws instead of flat nails, allowing them to cling vertically to tree trunks like squirrels.",
        "funFact": "They use their specialized lower teeth to gouge holes in tree bark and drink the flowing sap!",
        "ecosystemRole": "Small arboreal omnivore and pollinator.",
        "diet": "Tree sap, insects, and fruit.",
        "size": "Size of a rat.",
        "sound": "High-pitched bird-like chirps."
      },
      {
        "id": "capybara",
        "name": "Capybara",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-capybara.webp?v=15490709086023080935",
        "evolutionaryTrait": "Eyes, ears, and nostrils aligned perfectly on top of their head to stay mostly submerged while swimming.",
        "funFact": "They are the largest rodents in the world and are famous for letting other animals sit on them!",
        "ecosystemRole": "Major semi-aquatic herbivore.",
        "diet": "Grasses and aquatic plants.",
        "size": "Size of a large dog or small pig.",
        "sound": "Low barks and contented clicking sounds."
      },
      {
        "id": "coati",
        "name": "Coati",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-coati-south-american-coati.webp?v=11414233826189293085",
        "evolutionaryTrait": "A long, flexible snout perfectly shaped to root out hidden insects from leaf litter and rotting logs.",
        "funFact": "They hold their long, distinctly ringed tails straight up in the air to keep their group together in tall grass!",
        "ecosystemRole": "Opportunistic omnivore and forest floor forager.",
        "diet": "Insects, fruit, and small vertebrates.",
        "size": "Size of a large cat.",
        "sound": "Soft grunts and high-pitched squeaks."
      },
      {
        "id": "crab-eating-fox",
        "name": "Crab-eating Fox",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-crab-eating-fox.webp?v=8398630278454061283",
        "evolutionaryTrait": "A highly adaptable digestive system and foraging behavior suited for shifting flood seasons.",
        "funFact": "Despite the name, they only hunt muddy crabs during the wet season and eat almost anything else during the dry season!",
        "ecosystemRole": "Nocturnal omnivore and scavenger.",
        "diet": "Crabs, insects, rodents, and fruit.",
        "size": "Size of a medium dog.",
        "sound": "A hoarse bark and yelp."
      },
      {
        "id": "dragonfly",
        "name": "Dragonfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-dragonfly.webp?v=6558512406678182400",
        "evolutionaryTrait": "Four independently operating wings allowing them to hover, fly backwards, and pivot sharply mid-air.",
        "funFact": "They have beautifully complex eyes that provide an almost 360-degree field of vision for hunting!",
        "ecosystemRole": "Aerial insect predator.",
        "diet": "Mosquitoes and small flying insects.",
        "size": "Length of a human finger.",
        "sound": "A soft humming buzz."
      },
      {
        "id": "giant-anteater",
        "name": "Giant Anteater",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-giant-anteater.webp?v=7669976190135474065",
        "evolutionaryTrait": "A two-foot-long sticky tongue that perfectly flickers in and out rapidly to trap thousands of ants.",
        "funFact": "They are completely toothless and rely on their muscular stomach to grind up the crushed insects they swallow!",
        "ecosystemRole": "Specialized terrestrial insectivore.",
        "diet": "Ants and termites.",
        "size": "Length of a large dog.",
        "sound": "Usually silent, occasional low grunts."
      },
      {
        "id": "giant-river-otter",
        "name": "Giant River Otter",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-giant-river-otter.webp?v=8472363793181577413",
        "evolutionaryTrait": "Massive fully webbed feet and a powerful wing-like tail letting them swim extremely fast.",
        "funFact": "They are highly social and form loud family groups that are brave enough to scare off caimans or jaguars!",
        "ecosystemRole": "Apex aquatic social predator.",
        "diet": "Fish and crustaceans.",
        "size": "Length of a tall human.",
        "sound": "Loud snorts, hums, and whistles."
      },
      {
        "id": "great-southern-white-butterfly",
        "name": "Great Southern White Butterfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-great-southern-white-butterfly.webp?v=6989807650439374499",
        "evolutionaryTrait": "Brightly colored wings that signal to potential predators that they taste bitter and toxic.",
        "funFact": "They gather in huge fluttering groups on muddy river banks specifically to drink vital mineral-rich moisture!",
        "ecosystemRole": "Pollinator and prey item.",
        "diet": "Nectar from wild flowers.",
        "size": "Wingspan of two inches.",
        "sound": "Silent."
      },
      {
        "id": "green-anaconda",
        "name": "Green Anaconda",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-green-anaconda.webp?v=16762539277278770226",
        "evolutionaryTrait": "A massively thick, muscular body capable of crushing huge prey underwater with immense constricting force.",
        "funFact": "They are the heaviest snakes in the world and use the water to comfortably support their incredible weight!",
        "ecosystemRole": "Apex aquatic ambush predator.",
        "diet": "Capybaras, caimans, and wild pigs.",
        "size": "Length of a large car.",
        "sound": "A low, warning hiss."
      },
      {
        "id": "hyacinth-macaw",
        "name": "Hyacinth Macaw",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-hyacinth-macaw.webp?v=2356565712202458659",
        "evolutionaryTrait": "A massive, extraordinarily strong beak perfectly evolved to crack open the hardest palm nuts with ease.",
        "funFact": "They are the largest flying parrots in the world and feature breathtakingly striking cobalt-blue feathers!",
        "ecosystemRole": "Specialized seed consumer and disperser.",
        "diet": "Hard palm nuts and seeds.",
        "size": "Length of an adult's arm.",
        "sound": "A loud, harsh squawk."
      },
      {
        "id": "jabiru-stork",
        "name": "Jabiru Stork",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-jabiru-stork.webp?v=17054012441302597064",
        "evolutionaryTrait": "An incredibly massive bill and tall legs, making it perfectly equipped to wade safely in deep marsh water.",
        "funFact": "This gigantic bird has a noticeable bulging red pouch on its neck that inflates sharply when they get angry!",
        "ecosystemRole": "Large wetland predator and scavenger.",
        "diet": "Fish, frogs, and snakes.",
        "size": "Standing roughly five feet tall.",
        "sound": "Bill clattering."
      },
      {
        "id": "jaguar",
        "name": "Jaguar",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-jaguar.webp?v=8131176151750959752",
        "evolutionaryTrait": "An exceptionally powerful bite force capable of piercing right through the thick skulls of caimans and turtle shells.",
        "funFact": "Unlike typical cats, jaguars absolutely love water and will happily swim deep into rivers to hunt their prey!",
        "ecosystemRole": "Apex terrestrial and aquatic predator.",
        "diet": "Caimans, capybaras, and deer.",
        "size": "Size of a large, stocky canine.",
        "sound": "A deep, rasping grunt."
      },
      {
        "id": "kingfisher",
        "name": "Kingfisher",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-kingfisher.webp?v=6859076271901904992",
        "evolutionaryTrait": "A streamlined torpedo-shaped body that lets them dramatically plunge into the water with almost no splash.",
        "funFact": "They have special eyes that instantly adjust to account for water refraction, helping them spot slippery fish accurately!",
        "ecosystemRole": "Aerial aquatic predator.",
        "diet": "Small fish and insects.",
        "size": "Size of a robin.",
        "sound": "A sharp, chattering laugh."
      },
      {
        "id": "leaf-cutter-ant-colony",
        "name": "Leaf-cutter Ant Worker",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-leaf-cutter-ant.webp?v=15899088735828615044",
        "evolutionaryTrait": "Unbelievable jaw strength capable of shearing through tough vegetation.",
        "funFact": "They don't eat the leaves! They use them to farm a specialized fungus deep underground, which they then eat.",
        "ecosystemRole": "Major ecosystem engineers, pruning vast amounts of foliage and aerating the soil.",
        "diet": "Fungus grown from harvested leaves.",
        "size": "Up to half an inch long.",
        "sound": "Silent."
      },
      {
        "id": "monk-parakeet",
        "name": "Monk Parakeet",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-monk-parakeet.webp?v=12638249676457841246",
        "evolutionaryTrait": "The unique ability specifically among parrots to build massive communal nests out of woven sticks rather than using tree holes.",
        "funFact": "Their huge sprawling stick nests can house multiple families and weigh as much as a small car!",
        "ecosystemRole": "Social seed and fruit consumer.",
        "diet": "Seeds, fruit, and blossoms.",
        "size": "Size of a pigeon.",
        "sound": "A loud, raspy chatter."
      },
      {
        "id": "neotropical-river-turtle",
        "name": "Neotropical River Turtle",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-neotropical-river-turtle.webp?v=4844732787478334195",
        "evolutionaryTrait": "A distinctively flat, hydrodynamically efficient shell perfectly adapted exclusively for smoothly navigating heavy river currents.",
        "funFact": "They regularly bask on logs in big groups precisely to securely absorb warm sun and smartly shake off annoying leeches!",
        "ecosystemRole": "Aquatic omnivore and scavenger.",
        "diet": "Fruit, plants, and dead fish.",
        "size": "Size of a dinner plate.",
        "sound": "Silent."
      },
      {
        "id": "pantanal-marsh-deer",
        "name": "Pantanal Marsh Deer",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-marsh-deer.webp?v=3538225451801592796",
        "evolutionaryTrait": "Particularly elongated hooves connected by a membrane that neatly prevent them from sinking right into the deep swampy mud.",
        "funFact": "They are the largest deer in South America and are magnificent swimmers strongly preferring deep water habitats!",
        "ecosystemRole": "Large semi-aquatic herbivore.",
        "diet": "Aquatic plants and grasses.",
        "size": "Size of a small horse.",
        "sound": "A loud snort when alarmed."
      },
      {
        "id": "red-legged-seriema",
        "name": "Red-legged Seriema",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-red-legged-seriema.webp?v=4538977183969437291",
        "evolutionaryTrait": "Very long, highly capable running legs smartly used to quickly sprint after prey across grassy fields rather than flying.",
        "funFact": "They fiercely grab small snakes and furiously bash them against hard rocks repeatedly to kill them!",
        "ecosystemRole": "Terrestrial bird of prey.",
        "diet": "Insects, reptiles, and rodents.",
        "size": "Standing roughly three feet tall.",
        "sound": "A loud, yelping scream."
      },
      {
        "id": "roseate-spoonbill",
        "name": "Roseate Spoonbill",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-roseate-spoonbill.webp?v=18149892226457274000",
        "evolutionaryTrait": "A distinctly odd, spoon-shaped beak incredibly designed to safely sweep side-to-side through muddy water perfectly filtering out food.",
        "funFact": "Just like flamingos, their stunning pink coloration comes directly from the small crustaceans they constantly eat!",
        "ecosystemRole": "Shallow wetland wading predator.",
        "diet": "Small fish and crustaceans.",
        "size": "Standing over two feet tall.",
        "sound": "Low grunting."
      },
      {
        "id": "scarlet-macaw",
        "name": "Scarlet Macaw",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-scarlet-macaw.webp?v=3739208285774704446",
        "evolutionaryTrait": "A dense, brightly colored coat of highly conspicuous red, yellow, and blue feathers vividly contrasting the green jungle canopy.",
        "funFact": "They mate carefully for life and can peacefully live up to fifty years entirely in the wild!",
        "ecosystemRole": "Canopy frugivore and seed predator.",
        "diet": "Fruits, nuts, and seeds.",
        "size": "Length of an adult's arm.",
        "sound": "A very loud, throaty squawk."
      },
      {
        "id": "southern-screamer",
        "name": "Southern Screamer",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-southern-screamer.webp?v=3424539477944735067",
        "evolutionaryTrait": "Peculiar, highly sharp bone spurs located securely on their wings purposely used exclusively for fiercely defending territory.",
        "funFact": "They are closely related entirely to ducks, but correctly look exactly like a weird mix between a turkey and a goose!",
        "ecosystemRole": "Large wetland herbivore.",
        "diet": "Aquatic vegetation.",
        "size": "Size of a large turkey.",
        "sound": "A deafening, echoing scream."
      },
      {
        "id": "sungrebe",
        "name": "Sungrebe",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-sungrebe.webp?v=17993865953362509464",
        "evolutionaryTrait": "Distinctly striped toes smartly acting like small paddles directly assisting them strongly explicitly smoothly in swimming.",
        "funFact": "The male bird successfully has absolutely unique skin pouches neatly under precisely his wings to completely loudly carry his hatched chicks!",
        "ecosystemRole": "Small aquatic insectivore.",
        "diet": "Insects and small fish.",
        "size": "Size of a small duck.",
        "sound": "A low, barking 'wak'."
      },
      {
        "id": "sunbittern",
        "name": "Sunbittern",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-sunbittern-eurypyga-helias.webp?v=6563202615342659648",
        "evolutionaryTrait": "Beautiful, large eye-spots flawlessly hidden within their wings that can be flashed instantly to startle any aggressive predators.",
        "funFact": "When they open their wings fully, the pattern perfectly resembles a giant, terrifying face!",
        "ecosystemRole": "Riverbank forager and insectivore.",
        "diet": "Insects, spiders, and tiny fish.",
        "size": "Size of a heron.",
        "sound": "A long, drawn-out whistle."
      },
      {
        "id": "wetland-tree-frog",
        "name": "Wetland Tree Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-wetland-tree-frog.webp?v=7157225686526703310",
        "evolutionaryTrait": "Highly specialized, sticky toe pads expressly giving them the ability to smoothly climb smooth wet leaves.",
        "funFact": "Many distinct species can perfectly change their bright color slightly to seamlessly match the current temperature!",
        "ecosystemRole": "Arboreal nocturnal insectivore.",
        "diet": "Flies, moths, and crickets.",
        "size": "Size of a thumb.",
        "sound": "High-pitched chirps and trills."
      },
      {
        "id": "yacare-caiman",
        "name": "Yacare Caiman",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-yacare-caiman.webp?v=5965516564316741238",
        "evolutionaryTrait": "Highly visible, sharp lower teeth distinctly protruding over their upper jaw gracefully, even when their mouth is fully closed.",
        "funFact": "During the intense dry season, hundreds comfortably gather tightly together in vanishing pools to loudly feast on trapped piranhas!",
        "ecosystemRole": "Apex aquatic predator perfectly controlling fish populations.",
        "diet": "Piranhas, snails, and capybaras.",
        "size": "Length of a typical sofa.",
        "sound": "Deep rumbles and hisses."
      },
      {
        "id": "ipe-tree",
        "name": "Ipê Tree",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-ipe-tree.webp?v=14838466833123601897",
        "evolutionaryTrait": "Blooms radiantly in the dry season when most other plants lose their leaves, attracting desperate pollinators.",
        "funFact": "Its incredibly dense wood is heavier than water and naturally sinks!",
        "ecosystemRole": "Provides crucial nectar during the harshest part of the dry season.",
        "diet": "Sunlight and groundwater (Photosynthesis).",
        "size": "Can grow over 100 feet tall.",
        "sound": "Silent."
      },
      {
        "id": "marsh-lily",
        "name": "Marsh Lily (Pontederia)",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-marsh-lily-pontederia.webp?v=1230403424651115970",
        "evolutionaryTrait": "Spongy tissues allow stems to float and quickly adjust to the Pantanal's drastically changing water levels.",
        "funFact": "The purple flowers bloom for just one single day before wilting away!",
        "ecosystemRole": "Provides a spawning ground for fish and food for apple snails and waterfowl.",
        "diet": "Sunlight and water (Photosynthesis).",
        "size": "Can grow 3 feet above the water surface.",
        "sound": "Silent."
      },
      {
        "id": "pink-toed-tarantula",
        "name": "Pink-toed Tarantula",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-pink-toed-tarantula.webp?v=14657960379420846985",
        "evolutionaryTrait": "Specialized 'scopulae' pads on its pink toes act like sticky note adhesive, allowing it to climb sheer surfaces.",
        "funFact": "When threatened, they are known to literally jump out of their trees into the water and swim away!",
        "ecosystemRole": "Arboreal predator hunting large insects and small frogs.",
        "diet": "Insects, small frogs, and sometimes small birds.",
        "size": "Leg span up to 6 inches.",
        "sound": "Silent."
      },
      {
        "id": "southern-screamer-chick",
        "name": "Southern Screamer Chick",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-southern-screamer-chick.webp?v=2294501081909406220",
        "evolutionaryTrait": "Hatch fully feathered and able to run and swim almost immediately (precocial) to escape predators.",
        "funFact": "Even as tiny yellow fluffballs, they have massive, oversized feet to walk on lily pads!",
        "ecosystemRole": "Source of food for caimans and predatory birds, while foraging for small seeds themselves.",
        "diet": "Seeds, small leaves, and insects.",
        "size": "Size of a small chicken.",
        "sound": "Soft peeping."
      },
      {
        "id": "toco-toucan",
        "name": "Toco Toucan",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-toco-toucan.webp?v=7139312177518315878",
        "evolutionaryTrait": "An enormous, lightweight bill acts as a thermal radiator to cool the bird down in the sweltering heat.",
        "funFact": "When they sleep, they turn their head and tuck their huge beak completely under their wing to keep it warm!",
        "ecosystemRole": "A crucial seed disperser for many tropical fruit trees.",
        "diet": "Fruits, insects, and occasionally small reptiles or eggs.",
        "size": "Up to 24 inches long (a third of which is the bill).",
        "sound": "A deep, frog-like croak."
      },
      {
        "id": "water-hyacinth",
        "name": "Water Hyacinth",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-water-hyacinth.webp?v=5212121766452758831",
        "evolutionaryTrait": "Bulbous, air-filled leaf bases act as natural floatation devices.",
        "funFact": "They can double their population size in just two weeks under the right conditions!",
        "ecosystemRole": "Filters the water and provides shelter for juvenile fish and invertebrates.",
        "diet": "Sunlight and dissolved nutrients (Photosynthesis).",
        "size": "Leaves grow roughly 6 inches above the water.",
        "sound": "Silent."
      },
      {
        "id": "water-lily",
        "name": "Water Lily",
        "image": "//cleverfoxplay.com/cdn/shop/files/br-pantanal-water-lily.webp?v=16769049502049630529",
        "evolutionaryTrait": "Massive, buoyant pads engineered with rib-like structures underneath for immense strength.",
        "funFact": "The Victoria amazonica lily pad is strong enough to support the weight of a small child!",
        "ecosystemRole": "Shades the water to prevent algae blooms and provides a hunting platform for wading birds.",
        "diet": "Sunlight and nutrient-rich mud (Photosynthesis).",
        "size": "Pads can be several feet across.",
        "sound": "Silent."
      }
    ]
  },
  {
    "id": "savanna",
    "name": "Savanna",
    "location": "Serengeti, Tanzania",
    "description": "Endless golden plains with scattered acacia trees. Defined by long dry seasons and massive migrations.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/serengeti-savanna-hero-img.webp?v=5107571929997715890",
    "color": "bg-yellow-500",
    "facts": [
      {
        "title": "Golden Grasslands",
        "content": "The iconic African savanna warmly features seemingly endless stretches of tall grass proudly dotted with rugged acacia trees.",
        "icon": "sun"
      },
      {
        "title": "The Great Migration",
        "content": "It beautifully hosts fundamentally the absolute largest dramatic terrestrial mammal migration happening anywhere on the planet.",
        "icon": "map"
      },
      {
        "title": "Fire Ecology",
        "content": "Natural lightning-caused brush fires precisely keep the dense aggressive woodlands from gradually completely overtaking the open grasslands.",
        "icon": "flame"
      },
      {
        "title": "Towering Mounds",
        "content": "Massive termite mounds dot the landscape, some reaching up to 5 meters high. They serve as lookouts for cheetahs and eventually homes for mongooses once abandoned.",
        "icon": "mountain"
      }
    ],
    "animals": [
      {
        "id": "aardvark",
        "name": "Aardvark",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-aardvark.webp?v=10780072572956802133",
        "evolutionaryTrait": "A long, sticky tongue and powerful claws designed for breaking into hard termite mounds.",
        "funFact": "Their name actually means 'earth pig' in Afrikaans, despite not being related to pigs at all!",
        "ecosystemRole": "Nocturnal insectivore and burrow creator.",
        "diet": "Ants and termites.",
        "size": "Size of a small pig.",
        "sound": "Grunts and snorts."
      },
      {
        "id": "african-buffalo",
        "name": "African Buffalo",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-african-buffalo.webp?v=9317975983301134260",
        "evolutionaryTrait": "A massive, solid bone shield across their forehead called a 'boss' to defend against predator attacks.",
        "funFact": "They are known for their incredible memory and have been observed seeking revenge on lions!",
        "ecosystemRole": "Large grazer shaping the grasslands.",
        "diet": "Tall grasses and herbs.",
        "size": "Size of a large cow.",
        "sound": "Deep, resonant grunts and bellows."
      },
      {
        "id": "african-vulture",
        "name": "African Vulture",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-african-vulture.webp?v=5319219396338212129",
        "evolutionaryTrait": "Highly acidic stomach acid that allows them to safely eat rotting meat infected with dangerous diseases.",
        "funFact": "They have bald heads to prevent messy bacteria from collecting in their feathers while they eat!",
        "ecosystemRole": "Crucial scavenger and disease preventer.",
        "diet": "Carrion and bone fragments.",
        "size": "Wingspan of up to eight feet.",
        "sound": "Hisses and harsh chatters."
      },
      {
        "id": "baboon",
        "name": "Baboon",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-baboon.webp?v=14429538521144471612",
        "evolutionaryTrait": "Long, dog-like snouts filled with incredibly sharp canine teeth used to defend their complex social troops.",
        "funFact": "They are highly social primates that spend a lot of their time grooming each other to build friendships!",
        "ecosystemRole": "Adaptable terrestrial omnivore.",
        "diet": "Fruits, insects, and small mammals.",
        "size": "Size of a large dog.",
        "sound": "Loud, barking grunts and screams."
      },
      {
        "id": "bateleur-eagle",
        "name": "Bateleur Eagle",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-bateleur-eagle.webp?v=11194682445269948759",
        "evolutionaryTrait": "An exceptionally short tail and long wings that make them incredibly agile flyers like acrobats.",
        "funFact": "Their name is actually French for 'tightrope walker', perfectly describing their wobbling flight style!",
        "ecosystemRole": "Aerial predator and scavenger.",
        "diet": "Birds, small mammals, and carrion.",
        "size": "Wingspan of nearly six feet.",
        "sound": "A loud, barking call."
      },
      {
        "id": "black-rhinoceros",
        "name": "Black Rhinoceros",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-black-rhinoceros.webp?v=11077245968280491562",
        "evolutionaryTrait": "A pointed, prehensile upper lip perfectly shaped for powerfully grasping and plucking thorny leaves from bushes.",
        "funFact": "They have surprisingly terrible eyesight but make up for it with an incredibly sharp sense of smell!",
        "ecosystemRole": "Large browsing herbivore.",
        "diet": "Leaves, shoots, and thorny bushes.",
        "size": "Weight of a small car.",
        "sound": "Snorts, puffs, and growls."
      },
      {
        "id": "dung-beetle",
        "name": "Dung Beetle",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-dung-beetle.webp?v=8713405531440499335",
        "evolutionaryTrait": "Incredibly strong back legs explicitly designed to rapidly shape and roll balls of heavy animal dung.",
        "funFact": "Some species amazingly use the faint glow of the Milky Way galaxy to navigate in straight lines at night!",
        "ecosystemRole": "Crucial decomposer and soil nutrient cycler.",
        "diet": "Nutrient-rich animal dung.",
        "size": "Size of a large coin.",
        "sound": "A quiet buzzing in flight."
      },
      {
        "id": "dwarf-mongoose",
        "name": "Dwarf Mongoose",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-dwarf-mongoose.webp?v=17504317719479357360",
        "evolutionaryTrait": "Highly coordinated pack hunting instincts that allow them to safely tackle scorpions and venomous snakes.",
        "funFact": "They frequently form close hunting partnerships with hornbill birds to watch out for shared predators!",
        "ecosystemRole": "Small pack-hunting predator.",
        "diet": "Insects, spiders, and small reptiles.",
        "size": "Size of a small squirrel.",
        "sound": "High-pitched chirps and squeaks."
      },
      {
        "id": "elephant",
        "name": "Elephant",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-elephant.webp?v=5544386720262155436",
        "evolutionaryTrait": "A massive, powerful trunk consisting of thousands of muscles used for breathing, drinking, and grasping objects.",
        "funFact": "They can cleverly communicate with each other using deep rumbling sounds that travel miles through the ground!",
        "ecosystemRole": "Mega-herbivore shaping the entire landscape.",
        "diet": "Grasses, leaves, bark, and fruit.",
        "size": "Weight of three large cars.",
        "sound": "Loud trumpets and deep rumbles."
      },
      {
        "id": "giraffe",
        "name": "Giraffe",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-giraffe.webp?v=17820232577624642423",
        "evolutionaryTrait": "A uniquely massive heart capable of powerfully pumping blood all the way up their incredibly long necks.",
        "funFact": "Despite having a neck that stretches several feet long, they have exactly the same number of neck bones as human beings!",
        "ecosystemRole": "High-canopy continuous browser.",
        "diet": "Acacia leaves and twigs.",
        "size": "Standing nearly twenty feet tall.",
        "sound": "Mostly silent, occasional quiet hums at night."
      },
      {
        "id": "green-banded-swallowtail-butterfly",
        "name": "Green-banded Swallowtail Butterfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-green-banded-swallowtail-butterfly.webp?v=4933819694097206166",
        "evolutionaryTrait": "Striking neon-green wing bands that dramatically flash in the sunlight to confuse chasing predators.",
        "funFact": "They constantly gather in massive groups around muddy puddles to drink essential minerals and salts!",
        "ecosystemRole": "Pollinator and prey species.",
        "diet": "Flower nectar.",
        "size": "Wingspan of a large hand.",
        "sound": "Silent."
      },
      {
        "id": "grey-crowned-crane",
        "name": "Grey Crowned Crane",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-grey-crowned-crane.webp?v=3744806234851355157",
        "evolutionaryTrait": "A stiff golden crown of feathers and a bright red neck pouch used for elaborate mating displays.",
        "funFact": "They perform an incredibly beautiful dancing ritual involving energetic jumps, bows, and loud honking!",
        "ecosystemRole": "Wetland and grassland omnivore.",
        "diet": "Insects, seeds, and frogs.",
        "size": "Standing three feet tall.",
        "sound": "A loud, honking call."
      },
      {
        "id": "hippopotamus",
        "name": "Hippopotamus",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-hippopotamus.webp?v=16954681332268179270",
        "evolutionaryTrait": "Ears, eyes, and nostrils placed high on the top of their skull to safely monitor their surroundings while mostly submerged.",
        "funFact": "They secrete a thick red substance from their skin that acts as a natural glowing sunscreen and antibiotic!",
        "ecosystemRole": "Large semi-aquatic herbivore.",
        "diet": "Short grasses grazed at night.",
        "size": "Weight of a small car.",
        "sound": "Loud, echoing honks and grunts."
      },
      {
        "id": "kori-bustard",
        "name": "Kori Bustard",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-kori-bustard.webp?v=16973177918535194551",
        "evolutionaryTrait": "Exceptionally strong legs adapted for almost constantly walking across the savanna instead of flying.",
        "funFact": "It is officially the heaviest flying bird in Africa, though it strongly prefers to stay firmly on the ground!",
        "ecosystemRole": "Large terrestrial omnivore.",
        "diet": "Insects, lizards, and seeds.",
        "size": "Standing nearly four feet tall.",
        "sound": "A deep, booming bark."
      },
      {
        "id": "lilac-breasted-roller",
        "name": "Lilac-breasted Roller",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-lilac-breasted-roller.webp?v=15770857492493421277",
        "evolutionaryTrait": "Incredibly vibrant, multi-colored plumage used to quickly attract mates during their high-speed acrobatic flights.",
        "funFact": "They boldly swoop down directly into raging bushfires just to snatch up fleeing grasshoppers!",
        "ecosystemRole": "Aerial insect predator.",
        "diet": "Grasshoppers, beetles, and small lizards.",
        "size": "Size of a pigeon.",
        "sound": "A harsh, raspy squawk."
      },
      {
        "id": "lion",
        "name": "Lion",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-lion.webp?v=2742649163872976341",
        "evolutionaryTrait": "A thick, dark mane around their neck that protects them perfectly from bites during intense territorial fights.",
        "funFact": "A dominant male lion's roar is so incredibly loud it can be heard from up to five miles away!",
        "ecosystemRole": "Apex terrestrial pack predator.",
        "diet": "Wildebeest, buffalo, and zebra.",
        "size": "Weight of a large couch.",
        "sound": "A deep, vibrating roar."
      },
      {
        "id": "lioness",
        "name": "Lioness",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-lioness.webp?v=9715941146331427473",
        "evolutionaryTrait": "A highly cooperative pack-hunting strategy, utilizing complex coordinated flanking maneuvers to trap agile prey.",
        "funFact": "They are the primary hunters of the pride and work seamlessly together like a perfectly orchestrated military team!",
        "ecosystemRole": "Primary apex pack hunter.",
        "diet": "Zebra, antelope, and wildebeest.",
        "size": "Size of a large tiger.",
        "sound": "Low grunts and roars."
      },
      {
        "id": "little-bee-eater",
        "name": "Little Bee-eater",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-little-bee-eater.webp?v=11326489260707783339",
        "evolutionaryTrait": "A specialized technique of vigorously rubbing venomous bees against branches to safely safely remove the stinger before eating.",
        "funFact": "They dig long tunnels right into sandy riverbanks to create secure nesting chambers for their babies!",
        "ecosystemRole": "Specialized aerial insectivore.",
        "diet": "Bees, wasps, and hornets.",
        "size": "Size of a sparrow.",
        "sound": "Soft, high-pitched trills."
      },
      {
        "id": "marabou-stork",
        "name": "Marabou Stork",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-marabou-stork.webp?v=4108278575952137943",
        "evolutionaryTrait": "A massive, extremely sharp beak and bald head explicitly adapted for plunging deep into rotting animal carcasses.",
        "funFact": "They have hollow toe bones and frequently poop entirely on their own legs to cool off in the blazing sun!",
        "ecosystemRole": "Large avian scavenger.",
        "diet": "Carrion, fish, and insects.",
        "size": "Standing five feet tall.",
        "sound": "Bill clacking and grunting."
      },
      {
        "id": "mongoose",
        "name": "Mongoose",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-mongoose.webp?v=7057880480224855962",
        "evolutionaryTrait": "An incredible resistance to deadly snake venom combined flawlessly with lightning-fast dodging reflexes.",
        "funFact": "They frequently stand up tall on their hind legs just like prairie dogs to excitedly look around the tall grass!",
        "ecosystemRole": "Active terrestrial small predator.",
        "diet": "Insects, small reptiles, and rodents.",
        "size": "Size of a large squirrel.",
        "sound": "High-pitched chatters and growls."
      },
      {
        "id": "monitor-lizard",
        "name": "Monitor Lizard",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-monitor-lizard.webp?v=2261477036325467098",
        "evolutionaryTrait": "A deeply forked tongue continuously flicking the air to taste invisible scent particles from hidden prey.",
        "funFact": "They are highly intelligent reptiles and can even count up to six when evaluating a pile of unseen snail shells!",
        "ecosystemRole": "Large opportunistic reptilian predator.",
        "diet": "Eggs, carrion, insects, and small mammals.",
        "size": "Length of a large dog.",
        "sound": "Loud, warning hisses."
      },
      {
        "id": "secretary-bird",
        "name": "Secretary Bird",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-secretary-bird.webp?v=16217205149747589035",
        "evolutionaryTrait": "Extremely long, heavily scaled legs used to rapidly and powerfully stomp venomous snakes to death.",
        "funFact": "Their name perfectly comes from the cool black feathers sticking out of their head, looking exactly like quill pens behind an ear!",
        "ecosystemRole": "Terrestrial snake and insect hunter.",
        "diet": "Snakes, rodents, and large insects.",
        "size": "Standing four feet tall.",
        "sound": "Deep, croaking calls."
      },
      {
        "id": "serval",
        "name": "Serval",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-serval.webp?v=785368173579226854",
        "evolutionaryTrait": "Incredibly large ears acting like satellite dishes to hear the faint squeaks of hidden rodents beneath the grass.",
        "funFact": "They can powerfully leap over nine feet straight up into the air to effortlessly catch fleeing birds mid-flight!",
        "ecosystemRole": "Specialized small mammal predator.",
        "diet": "Rodents, birds, and frogs.",
        "size": "Size of a medium dog.",
        "sound": "High-pitched chirps and hisses."
      },
      {
        "id": "southern-ground-hornbill",
        "name": "Southern Ground Hornbill",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-southern-ground-hornbill.webp?v=15382404961883438595",
        "evolutionaryTrait": "Thick, dark eyelashes perfectly evolved to protect their sensitive eyes from bright sun and blowing dust.",
        "funFact": "Their booming morning call is so incredibly deep and loud that people often mistake it for a distant lion roaring!",
        "ecosystemRole": "Large formidable ground predator.",
        "diet": "Snakes, frogs, and insects.",
        "size": "Size of an angry turkey.",
        "sound": "A deep, booming, drum-like call."
      },
      {
        "id": "spotted-hyena",
        "name": "Spotted Hyena",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-spotted-hyena.webp?v=12815199197311814464",
        "evolutionaryTrait": "An incredibly powerful biting force fully capable of easily cracking open large elephant leg bones to eat the marrow.",
        "funFact": "Although they are famous for scavenging, they actually hunt down and kill more than ninety percent of their own food!",
        "ecosystemRole": "Apex pack scavenger and predator.",
        "diet": "Carrion, antelope, and wildebeest.",
        "size": "Size of a large grey wolf.",
        "sound": "A distinct, giggling laugh and eerie whoops."
      },
      {
        "id": "topi",
        "name": "Topi",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-topi.webp?v=14879824387955993076",
        "evolutionaryTrait": "Incredibly long, muscular legs specifically adapted to maintain high-speed running over very long distances.",
        "funFact": "Dominant males confidently stand on giant termite mounds for hours just to show off to females and spot predators!",
        "ecosystemRole": "Large migrating grazing herbivore.",
        "diet": "Dry savanna grasses.",
        "size": "Size of a small horse.",
        "sound": "Soft grunts and snorts."
      },
      {
        "id": "tortoise",
        "name": "Tortoise",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-tortoise.webp?v=7119594507056240207",
        "evolutionaryTrait": "A massively thick, impenetrable bone box acting as a shield against lion teeth and raging bushfires.",
        "funFact": "They store huge amounts of water in a special sac, allowing them to happily survive for months without a single rain drop!",
        "ecosystemRole": "Slow-moving terrestrial herbivore.",
        "diet": "Weeds, grasses, and fallen fruit.",
        "size": "Size of a small boulder.",
        "sound": "Hissing when agitated."
      },
      {
        "id": "warthog",
        "name": "Warthog",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-warthog.webp?v=18048221053515980556",
        "evolutionaryTrait": "Curved, razor-sharp tusks used fiercely to expertly dig out solid roots and fight off attacking leopards.",
        "funFact": "When they quickly run away in panic, they adorably stick their thin tails straight up in the air like little antennas!",
        "ecosystemRole": "Foraging omnivore and soil tiller.",
        "diet": "Roots, bulbs, grass, and insects.",
        "size": "Size of a large dog.",
        "sound": "Snorts, squeals, and grunts."
      },
      {
        "id": "weaver-bird",
        "name": "Weaver Bird",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-weaver-bird.webp?v=5333087723407388065",
        "evolutionaryTrait": "An incredibly intricate weaving ability specifically used to build hanging nest fortresses to protect their eggs cleverly from snakes.",
        "funFact": "If a female doesn't eagerly like the complex nest a male built, she will relentlessly tear it completely apart!",
        "ecosystemRole": "Seed-eating flock bird and nest architect.",
        "diet": "Seeds and small insects.",
        "size": "Size of a sparrow.",
        "sound": "A busy, buzzing chatter."
      },
      {
        "id": "zebra",
        "name": "Zebra",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-zebra.webp?v=15183664025178174542",
        "evolutionaryTrait": "Dazzling black and white stripes perfectly evolved to heavily disorient biting flies and completely confuse attacking lions.",
        "funFact": "Just like a unique human fingerprint, absolutely no two zebras have exactly the identical same stripe pattern!",
        "ecosystemRole": "Major grazing herbivore.",
        "diet": "Tall, coarse grasses.",
        "size": "Size of a sturdy pony.",
        "sound": "A strange, dog-like bark and whinny."
      },
      {
        "id": "african-flower-beetle",
        "name": "African Flower Beetle",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-african-flower-beetle.webp?v=12110228641724775179",
        "evolutionaryTrait": "Brightly colored tough exoskeleton that protects it from predators while blending with flowers.",
        "funFact": "They love to feed on pollen and nectar, playing a small but interesting role in pollination!",
        "ecosystemRole": "Acts as a pollinator for various savanna flowers and a food source for birds.",
        "diet": "Nectar, pollen, and sweet fruit.",
        "size": "About 0.5 to 1 inch long.",
        "sound": "A low buzz when flying."
      },
      {
        "id": "african-giant-millipede",
        "name": "African Giant Millipede",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-african-giant-millipede.webp?v=13044320370318446234",
        "evolutionaryTrait": "Many legs and a hard exoskeleton, able to curl into a tight ball for protection.",
        "funFact": "When threatened, they can secrete an irritating fluid from their body segments!",
        "ecosystemRole": "Important detritivore, breaking down dead plant matter into fertile soil.",
        "diet": "Decaying wood, leaves, and other plant matter.",
        "size": "Can grow up to 11-15 inches long.",
        "sound": "Mostly silent."
      },
      {
        "id": "african-monarch-butterfly",
        "name": "African Monarch Butterfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-african-monarch-butterfly.webp?v=15906710605624507430",
        "evolutionaryTrait": "Bright orange and black warning colors (aposematism) signaling toxicity.",
        "funFact": "Caterpillars accumulate toxins from milkweed, making the adult butterfly taste terrible to predators!",
        "ecosystemRole": "Pollinator for many flowering plants in the savanna ecosystem.",
        "diet": "Nectar from various flowers.",
        "size": "Wingspan of around 3 inches.",
        "sound": "Silent."
      },
      {
        "id": "african-praying-mantis",
        "name": "African Praying Mantis",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-african-praying-mantis.webp?v=16077026655039761497",
        "evolutionaryTrait": "Elongated body and specialized front legs for grasping and holding struggling prey.",
        "funFact": "They can turn their heads 180 degrees to scan the area for passing insects!",
        "ecosystemRole": "An ambush predator that helps control insect populations.",
        "diet": "Other insects, including flies, moths, and crickets.",
        "size": "Can grow up to 3-4 inches long.",
        "sound": "Silent."
      },
      {
        "id": "rainbow-grasshopper",
        "name": "Rainbow Grasshopper",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-rainbow-grasshopper.webp?v=14750536660723935607",
        "evolutionaryTrait": "Incredible jumping abilities and striking colors that can warn predators or confuse them during flight.",
        "funFact": "Also known as painted grasshoppers, their bright colors often signal toxicity from the plants they eat!",
        "ecosystemRole": "Primary consumer transferring plant energy to higher trophic levels like birds and mammals.",
        "diet": "Various grasses and low-lying vegetation.",
        "size": "About 1 to 2 inches long.",
        "sound": "A buzzing clicking sound (stridulation)."
      },
      {
        "id": "red-and-yellow-barbet",
        "name": "Red-and-yellow Barbet",
        "image": "//cleverfoxplay.com/cdn/shop/files/serengeti-red-and-yellow-barbet.webp?v=6357482383288986642",
        "evolutionaryTrait": "A strong, thick bill used for pecking into termite mounds to create nesting holes.",
        "funFact": "They are known for their intricate duets, where pairs sing complex songs together to defend their territory!",
        "ecosystemRole": "Avian omnivore and secondary hollow creator that provides homes for other small animals.",
        "diet": "Insects, seeds, and fruit.",
        "size": "Around 8-9 inches long.",
        "sound": "A loud, synchronized duet ringing across the savanna."
      }
    ]
  },
  {
    "id": "taiga",
    "name": "Taiga",
    "location": "Ussuri Taiga, Russian Far East",
    "description": "A unique, highly diverse crossroad where freezing Siberian boreal forests seamlessly blend with lush East Asian broadleaf forests.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/russian-taiga-hero-img.webp?v=13456175314144646067",
    "color": "bg-sky-700",
    "facts": [
      {
        "title": "The Land of the Amur",
        "content": "The Ussuri Taiga in the Russian Far East is a unique mix of northern boreal species and southern subtropical species.",
        "icon": "treePine"
      },
      {
        "title": "Tigers and Bears",
        "content": "It is one of the only places on Earth where Amur Tigers actually overlap and actively compete with brown and black bears.",
        "icon": "pawPrint"
      },
      {
        "title": "Freezing Forest",
        "content": "Despite long, brutally cold and deeply snowy winters, the enormous summer monsoons support a lush, dense forest canopy.",
        "icon": "snowflake"
      },
      {
        "title": "A Meeting of Worlds",
        "content": "The Sikhote-Alin range sits at a unique ecological crossroads where southern subtropical species mix with northern taiga species, creating an incredibly unusual biodiversity hotspot.",
        "icon": "map"
      }
    ],
    "animals": [
      {
        "id": "amur-leopard",
        "name": "Amur Leopard",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-amur-leopard.webp?v=17964234970466876238",
        "evolutionaryTrait": "A thick, pale coat with large rosettes that provides warmth and excellent camouflage in snowy forests.",
        "funFact": "They are one of the rarest big cats in the world, with only about 100 individuals left in the wild.",
        "ecosystemRole": "Apex predator managing herbivore populations.",
        "diet": "Roe deer, sika deer, wild boar, and hares.",
        "size": "Up to 5 feet long, excluding the tail.",
        "sound": "Harsh, raspy coughs and growls."
      },
      {
        "id": "amur-tiger-cub",
        "name": "Amur Tiger",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-amur-tiger-cub.webp?v=7699514206994772906",
        "evolutionaryTrait": "A layer of fat on their flanks and belly, along with a thick winter coat, allows them to survive extreme freezing temperatures.",
        "funFact": "They are the largest of all wild cats, with males capable of weighing over 600 pounds.",
        "ecosystemRole": "Apex predator crucial for controlling large ungulates.",
        "diet": "Wild boar, red deer, sika deer, and sometimes bears.",
        "size": "Up to 10 feet long.",
        "sound": "Deep, resonating roars and chuffs."
      },
      {
        "id": "asian-badger",
        "name": "Asian Badger",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-asian-badger.webp?v=9085610423492398578",
        "evolutionaryTrait": "Long, robust, curved claws on their front feet are perfectly designed for rapid and efficient soil excavation.",
        "funFact": "They are highly social animals that live in elaborate, multi-chambered underground burrow systems called 'setts'.",
        "ecosystemRole": "Omnivorous foragers and significant soil aerators.",
        "diet": "Earthworms, insects, roots, and small mammals.",
        "size": "24 to 35 inches long.",
        "sound": "Grunts, snorts, and aggressive growls."
      },
      {
        "id": "asiatic-black-bear",
        "name": "Asiatic Black Bear",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-asiatic-black-bear.webp?v=12884179190411284437",
        "evolutionaryTrait": "A distinct white V-shaped patch on their chest is thought to make them look larger when standing on their hind legs to intimidate rivals.",
        "funFact": "They are incredibly arboreal and often build comfortable platform 'nests' high up in the trees to rest in.",
        "ecosystemRole": "Major omnivore shaping plant communities via seed dispersal.",
        "diet": "Nuts, berries, insects, honey, and occasionally meat.",
        "size": "4 to 6.5 feet long.",
        "sound": "Loud, guttural barks and deep grunts."
      },
      {
        "id": "black-woodpecker",
        "name": "Black Woodpecker",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-black-woodpecker.webp?v=2867497498481472929",
        "evolutionaryTrait": "A massive, chisel-like bill capable of excavating incredibly deep foraging pits in decaying trees to reach ants.",
        "funFact": "Their large, abandoned nesting cavities are vitally important, as they provide homes for many other birds and mammals.",
        "ecosystemRole": "Keystone species providing cavities for secondary nesters.",
        "diet": "Carpenter ants, wood-boring beetle larvae, and bark insects.",
        "size": "About 18 inches long.",
        "sound": "A loud, ringing 'klee-klee-klee' call."
      },
      {
        "id": "blakistons-fish-owl",
        "name": "Blakiston’s Fish Owl",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-blakiston-s-fish-owl.webp?v=14363831292656385092",
        "evolutionaryTrait": "Unlike most owls, their feathers lack sound-muffling fringes, as silent flight isn't necessary for hunting fish in rushing rivers.",
        "funFact": "They are completely bare-legged, lacking the leg feathers of other owls to prevent freezing when wading into icy waters.",
        "ecosystemRole": "Apex avian predator of the river-forest interface.",
        "diet": "Salmon, trout, frogs, and occasionally small mammals.",
        "size": "Up to 28 inches tall.",
        "sound": "A deep, resonant 'hoo-hoo'."
      },
      {
        "id": "capercaillie",
        "name": "Capercaillie",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-capercaillie.webp?v=17116718760972114273",
        "evolutionaryTrait": "Specialized digestive system with an enlarged caecum to process vast amounts of tough, fibrous conifer needles.",
        "funFact": "During the mating season, males gather at 'leks' and perform bizarre, clicking and popping courtship displays.",
        "ecosystemRole": "Large herbivorous bird of the deep forest.",
        "diet": "Pine needles, berries, shoots, and insects (for chicks).",
        "size": "Males can be up to 34 inches long.",
        "sound": "Strange clicks, pops, and a sound like a cork popping from a bottle."
      },
      {
        "id": "eurasian-jay",
        "name": "Eurasian Jay",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-eurasian-jay.webp?v=7831902990234366708",
        "evolutionaryTrait": "An exceptional spatial memory allows them to bury thousands of acorns in autumn and retrieve them months later under the snow.",
        "funFact": "They are incredible mimics and can accurately replicate the calls of predators like hawks to scare away smaller birds.",
        "ecosystemRole": "Crucial seed disperser, particularly for oak trees.",
        "diet": "Acorns, berries, insects, and small vertebrates.",
        "size": "13 to 14 inches long.",
        "sound": "A harsh, rasping 'skaak'."
      },
      {
        "id": "far-eastern-forest-cat",
        "name": "Far Eastern Forest Cat",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-far-eastern-forest-cat.webp?v=1308283425364745058",
        "evolutionaryTrait": "A thick, heavily spotted winter coat offers camouflage in dense underbrush while stalking agile prey.",
        "funFact": "They are excellent climbers and will frequently ambush prey by dropping down on them from low tree branches.",
        "ecosystemRole": "Nimble mesopredator controlling small mammal numbers.",
        "diet": "Mice, voles, small birds, and insects.",
        "size": "About 20 to 25 inches long.",
        "sound": "Spits, hisses, and meows similar to domestic cats."
      },
      {
        "id": "fischers-clawed-salamander",
        "name": "Fischer’s Clawed Salamander",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-fischer-s-clawed-salamander.webp?v=15218769892222529564",
        "evolutionaryTrait": "Black, hardened tips on their toes act like tiny claws to help them grip slippery rocks in fast-flowing mountain streams.",
        "funFact": "Like many stream salamanders, they lack lungs entirely and must breathe purely through their moist skin.",
        "ecosystemRole": "Amphibious predator of aquatic insects.",
        "diet": "Aquatic insects, larvae, and small crustaceans.",
        "size": "6 to 8 inches long.",
        "sound": "Silent."
      },
      {
        "id": "hazel-grouse",
        "name": "Hazel Grouse",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-hazel-grouse.webp?v=541028548035445563",
        "evolutionaryTrait": "Mottled brown, grey, and barring pattern provides flawless camouflage among the leaf litter of the forest floor.",
        "funFact": "They are famously secretive and prefer to run away through dense cover rather than fly when disturbed.",
        "ecosystemRole": "Herbivorous gamebird of the forest interior.",
        "diet": "Buds, catkins, berries, and insects.",
        "size": "14 to 15 inches long.",
        "sound": "A very high-pitched, thin whistle."
      },
      {
        "id": "mandarin-duck",
        "name": "Mandarin Duck",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-mandarin-duck.webp?v=6274691811368071293",
        "evolutionaryTrait": "The striking, sail-like feathers on the male's back are used as highly visible courtship signals during the breeding season.",
        "funFact": "They are closely associated with forests and actually nest in hollow cavities high up in trees near the water.",
        "ecosystemRole": "Waterfowl linking the riverine and forest ecosystems.",
        "diet": "Seeds, acorns, aquatic plants, and insects.",
        "size": "16 to 19 inches long.",
        "sound": "A sharp, whistling 'hwick' or a low cluck."
      },
      {
        "id": "manchurian-red-deer",
        "name": "Manchurian Red Deer",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-manchurian-red-deer.webp?v=18208458396427293952",
        "evolutionaryTrait": "Broad, heavy antlers adapted for fighting rivals to establish dominance in dense woodland clearings.",
        "funFact": "Also known as the wapiti, their loud, echoing bugling calls during the rut can be heard from miles away.",
        "ecosystemRole": "Major large herbivore shaping plant structure.",
        "diet": "Grasses, leaves, bark, and twigs.",
        "size": "Up to 5 feet tall at the shoulder.",
        "sound": "Loud, high-pitched bugling."
      },
      {
        "id": "marsh-tit",
        "name": "Marsh Tit",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-marsh-tit.webp?v=12926497169900070518",
        "evolutionaryTrait": "A small, sturdy bill adapted to easily pry open tough seeds and patiently extract insects from tree bark.",
        "funFact": "Despite their name, they are rarely found in marshes; they much prefer broadleaf woodlands and mature forests.",
        "ecosystemRole": "Active and acrobatic insectivore.",
        "diet": "Insects, spiders, and seeds.",
        "size": "About 4.5 inches long.",
        "sound": "A sharp, explosive 'pitchou' call."
      },
      {
        "id": "moose",
        "name": "Moose",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-moose.webp?v=13371695291004757551",
        "evolutionaryTrait": "Incredibly long legs allow them to easily wade through deep snow in winter and deep water and marshland in summer.",
        "funFact": "They are exceptional swimmers and can completely submerge themselves to graze on aquatic plants on the lake bottom.",
        "ecosystemRole": "Massive herbivore strongly impacting aquatic and forest vegetation.",
        "diet": "Aquatic vegetation, willow, birch, and twigs.",
        "size": "Up to 7 feet tall at the shoulder.",
        "sound": "Deep, resonant bellows and grunts."
      },
      {
        "id": "musk-deer",
        "name": "Musk Deer",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-musk-deer.webp?v=16792657356123831006",
        "evolutionaryTrait": "Instead of antlers, males have remarkably long canine teeth that protrude downward like fangs for combat.",
        "funFact": "Males produce a strongly scented waxy substance called 'musk', which has unfortunately made them targets for poachers.",
        "ecosystemRole": "Small, secretive herbivore of the rugged forest.",
        "diet": "Lichens, mosses, leaves, and shoots.",
        "size": "About 20 to 24 inches tall at the shoulder.",
        "sound": "Usually silent, but may give a sharp hiss when alarmed."
      },
      {
        "id": "northern-goshawk",
        "name": "Northern Goshawk",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-northern-goshawk.webp?v=15250356925989978874",
        "evolutionaryTrait": "Short, broad wings and a long tail provide incredible agility, allowing them to rapidly twist and weave through dense timber in pursuit of prey.",
        "funFact": "They are fiercely territorial and completely unafraid; they will dive-bomb and attack humans who come too near their nests.",
        "ecosystemRole": "Vicious and incredibly skilled avian apex predator of the forest.",
        "diet": "Gamebirds, crows, hares, and squirrels.",
        "size": "18 to 24 inches long.",
        "sound": "A loud, chattering 'kak-kak-kak'."
      },
      {
        "id": "otter",
        "name": "Otter",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-otter.webp?v=5206943681943719609",
        "evolutionaryTrait": "Muscular, torpedo-shaped body and heavily webbed feet make them masterly, incredibly agile swimmers.",
        "funFact": "They have the densest fur of any animal, with up to a million hairs per square inch to keep them completely dry.",
        "ecosystemRole": "Highly active aquatic predator.",
        "diet": "Fish, crustaceans, frogs, and insects.",
        "size": "3 to 4.5 feet long.",
        "sound": "Chirps, chuckles, and high-pitched whistles."
      },
      {
        "id": "pacific-swift",
        "name": "Pacific Swift",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-pacific-swift.webp?v=1291677923204127322",
        "evolutionaryTrait": "Long, scythe-like wings built for spending almost its entire life flying seamlessly through the air without landing.",
        "funFact": "Their legs are so short and weak that if they end up completely flat on the ground, they have trouble taking off.",
        "ecosystemRole": "Crucial high-altitude aerial insectivore.",
        "diet": "Flying insects entirely.",
        "size": "About 7 to 8 inches long.",
        "sound": "A loud, shrill screaming call."
      },
      {
        "id": "pika",
        "name": "Pika",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-pika.webp?v=9890556864506810999",
        "evolutionaryTrait": "Rounded ears and lack of a visible tail help reduce heat loss, allowing survival in extremely cold, high-altitude rocky environments.",
        "funFact": "They do not hibernate; instead, they spend all summer collecting huge 'haypiles' of dried plants to eat throughout the bitter winter.",
        "ecosystemRole": "Key herbivorous prey species.",
        "diet": "Grasses, sedges, and alpine flowers.",
        "size": "6 to 8 inches long.",
        "sound": "A sharp, high-pitched 'eep' or bark."
      },
      {
        "id": "raccoon-dog",
        "name": "Raccoon Dog",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-raccoon-dog.webp?v=5968247493311442665",
        "evolutionaryTrait": "It uniquely retains the ability to climb trees, unlike most canids, which is useful for foraging in thick forests.",
        "funFact": "Also known as the 'tanuki', they are the only wild dogs that hibernate completely through the harsh winter months.",
        "ecosystemRole": "Highly adaptable opportunistic omnivore.",
        "diet": "Insects, rodents, amphibians, berries, and carrion.",
        "size": "18 to 28 inches long.",
        "sound": "Growls, whines, and soft mewing sounds."
      },
      {
        "id": "red-fox",
        "name": "Red Fox",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-red-fox.webp?v=6775807872277233391",
        "evolutionaryTrait": "A thick, bushy tail acts as a vital counterbalance when making sharp, sudden turns while chasing agile prey.",
        "funFact": "They have incredibly sensitive hearing and are known for their iconic 'mousing leap', diving head-first into snow to catch hidden mice.",
        "ecosystemRole": "Flexible, opportunistic mesopredator.",
        "diet": "Rodents, rabbits, birds, insects, and berries.",
        "size": "2.5 to 3.5 feet long.",
        "sound": "Sharp barks, yips, and a raspy, eerie scream."
      },
      {
        "id": "sable",
        "name": "Sable",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-sable.webp?v=6609742559011644121",
        "evolutionaryTrait": "Their soft, exquisitely dense winter fur provides phenomenal insulation against freezing conditions in the deep taiga.",
        "funFact": "They are exceptionally curious drawn animals, but their beautiful, valuable coats historically made them highly prized targets.",
        "ecosystemRole": "Nimble, aggressive, weasel-like predator.",
        "diet": "Mice, chipmunks, birds, nuts, and berries.",
        "size": "13 to 20 inches long.",
        "sound": "Hisses, chuckles, and aggressive growls."
      },
      {
        "id": "salmon",
        "name": "Salmon",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-salmon.webp?v=16763237693599013741",
        "evolutionaryTrait": "Possesses incredible osmotic ability to migrate efficiently between salt-water oceans and freshwater natal rivers.",
        "funFact": "They use a combination of the Earth's magnetic field and their astonishing sense of smell to miraculously return to the exact stream where they hatched.",
        "ecosystemRole": "Enormously critical food source transporting marine nutrients deep into the forest.",
        "diet": "Aquatic insects (when young), small fish, and krill (in the ocean).",
        "size": "Varies generally from 20 to 40 inches depending on the species.",
        "sound": "Silent."
      },
      {
        "id": "scaly-sided-merganser",
        "name": "Scaly-sided Merganser",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-scaly-sided-merganser.webp?v=11201269999297965361",
        "evolutionaryTrait": "A slender, serrated beak with backward-pointing 'teeth' perfectly adapted for tightly gripping slippery fish underwater.",
        "funFact": "An endangered waterfowl that requires both clear, fast-flowing mountain rivers for fishing and incredibly old trees with large cavities for nesting.",
        "ecosystemRole": "Highly specialized diving predator.",
        "diet": "Small fish and aquatic insects.",
        "size": "Around 22 to 24 inches long.",
        "sound": "Low, hoarse croaks."
      },
      {
        "id": "siberian-chipmunk",
        "name": "Siberian Chipmunk",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-siberian-chipmunk.webp?v=18068745195498317423",
        "evolutionaryTrait": "Distinctive dark stripes stretching along the back effectively break up their outline against the dappled shadows of the forest floor.",
        "funFact": "They use expansive cheek pouches that stretch enormously to carry seeds quickly to their underground burrows.",
        "ecosystemRole": "Abundant small herbivore and seed disperser.",
        "diet": "Seeds, nuts, berries, and fungi.",
        "size": "5 to 6 inches long (excluding tail).",
        "sound": "High, sharp chipping notes and trills."
      },
      {
        "id": "siberian-flying-squirrel",
        "name": "Siberian Flying Squirrel",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-siberian-flying-squirrel.webp?v=5436970816113732448",
        "evolutionaryTrait": "A furry membrane (patagium) stretches between front and back legs to glide remarkably far between ancient trees in old-growth forests.",
        "funFact": "Their exceedingly large, dark eyes allow them to navigate and forage effectively purely in the pitch black of night.",
        "ecosystemRole": "Nocturnal arboreal herbivore.",
        "diet": "Catkins, leaves, buds, seeds, and berries.",
        "size": "5 to 8 inches long.",
        "sound": "Soft, whispering chirps."
      },
      {
        "id": "siberian-roe-deer",
        "name": "Siberian Roe Deer",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-siberian-roe-deer.webp?v=13943502559796507454",
        "evolutionaryTrait": "Incredibly long back legs provide tremendous leaping power, allowing them to bound gracefully over tall grass and brush.",
        "funFact": "When genuinely alarmed, the white hair patch on their rump furiously flares open like a warning flag to alert others.",
        "ecosystemRole": "Important small herbivore.",
        "diet": "Leaves, herbs, buds, and twigs.",
        "size": "2.5 to 3 feet tall at the shoulder.",
        "sound": "A dog-like, harsh bark when alarmed."
      },
      {
        "id": "siberian-weasel",
        "name": "Siberian Weasel",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-siberian-weasel.webp?v=14190028077176580065",
        "evolutionaryTrait": "A distinctly long, tubular body optimally designed for aggressively pursuing desperate rodents right down into their winding burrows.",
        "funFact": "In parts of Asia, its fine winter fur has historically been highly prized and used specifically for making high-quality paintbrush bristles.",
        "ecosystemRole": "Fierce, relentless small predator.",
        "diet": "Voles, mice, pikas, and occasionally birds.",
        "size": "11 to 15 inches long.",
        "sound": "Sharp hisses and chattering."
      },
      {
        "id": "ural-owl",
        "name": "Ural Owl",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-ural-owl.webp?v=6544097539296712986",
        "evolutionaryTrait": "Exceptionally acute hearing allows them to detect and plunge entirely through thick layers of snow to catch hidden mice.",
        "funFact": "They are famously extremely aggressive and utterly fearless when defending their nests, readily attacking anything that approaches.",
        "ecosystemRole": "Nocturnal avian predator.",
        "diet": "Voles, mice, hares, and medium birds.",
        "size": "20 to 24 inches tall.",
        "sound": "A deep, hollow 'hoo-hoo-hoo'."
      },
      {
        "id": "ussuri-brown-bear",
        "name": "Ussuri Brown Bear",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-ussuri-brown-bear.webp?v=2113027570690701803",
        "evolutionaryTrait": "Massive shoulder hump heavily packed with pure muscle for devastating power when digging up dense roots and breaking apart heavy logs.",
        "funFact": "Often called the 'black grizzly', they regularly hunt alongside Amur tigers, occasionally battling them over valuable kills.",
        "ecosystemRole": "Massive, powerful, wide-ranging omnivore.",
        "diet": "Nuts, roots, berries, fish, and mammals.",
        "size": "Males can weigh over 800 pounds.",
        "sound": "Deep, thundering roars and grunts."
      },
      {
        "id": "wild-boar",
        "name": "Wild Boar",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-wild-boar.webp?v=558473951479111680",
        "evolutionaryTrait": "An incredibly tough, cartilaginous snout explicitly adapted for relentlessly churning up the earth to uncover buried roots and insects.",
        "funFact": "They enjoy intensely rolling in deep mud entirely to heavily coat themselves, effectively cooling down and physically removing terrible parasites.",
        "ecosystemRole": "A powerful ecosystem engineer that forcefully tills the soil.",
        "diet": "Acorns, roots, tubers, earthworms, and carrion.",
        "size": "Up to 3.5 feet tall at the shoulder.",
        "sound": "Loud, aggressive grunts, squeals, and snorts."
      },
      {
        "id": "wolverine",
        "name": "Wolverine",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-wolverine.webp?v=3738083888638290472",
        "evolutionaryTrait": "Remarkably large, heavily furred paws act like biological snowshoes for bounding swiftly across incredibly deep snow without sinking.",
        "funFact": "They possess incredible jaw strength completely capable of crushing frozen bones, allowing them to scavenge what other predators entirely leave behind.",
        "ecosystemRole": "Relentless, incredibly powerful scavenger and predator.",
        "diet": "Carrion, small mammals, and occasionally large ungulates.",
        "size": "25 to 35 inches long.",
        "sound": "Deep, guttural growls and hisses."
      },
      {
        "id": "lily-of-the-valley",
        "name": "Lily of the Valley",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-lily-of-the-valley.webp?v=5136740012098796962",
        "evolutionaryTrait": "Produces highly toxic compounds to defend its delicate bell-shaped flowers and bright red berries from herbivores.",
        "funFact": "Despite being poisonous to ingest, it has a famously sweet scent that is highly prized in perfumes!",
        "ecosystemRole": "Provides ground cover in shaded forest areas and its berries are eaten by certain adapted birds.",
        "diet": "Sunlight and forest soil nutrients (Photosynthesis).",
        "size": "Grows up to 6 to 12 inches tall.",
        "sound": "Silent."
      },
      {
        "id": "pinecone",
        "name": "Pinecone (Conifer)",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-pinecone.webp?v=8396785002428918521",
        "evolutionaryTrait": "Woody scales protect developing seeds from harsh weather and tightly close up when wet to prevent rotting.",
        "funFact": "They naturally act as weather indicators: the scales open in dry conditions and close up when it's damp or raining!",
        "ecosystemRole": "A crucial food source for red squirrels, crossbills, and other seed-eating taiga animals.",
        "diet": "Sunlight and water (Photosynthesis).",
        "size": "Can be 2 to 6 inches long.",
        "sound": "Silent."
      },
      {
        "id": "red-berry-shrub",
        "name": "Red Berry Shrub",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-red-berry-shrub.webp?v=15213373430019028716",
        "evolutionaryTrait": "Brightly colored berries to attract birds and mammals which will eat the fruit and disperse the seeds across the taiga.",
        "funFact": "Such shrubs often rely on the freezing winter temperatures to stratify their seeds so they can germinate in spring!",
        "ecosystemRole": "Key understory food source to help bears and birds fatten up before winter.",
        "diet": "Sunlight and soil nutrients (Photosynthesis).",
        "size": "Can form low-lying thickets.",
        "sound": "Silent."
      },
      {
        "id": "rhododendron-of-fauriei",
        "name": "Faurie’s Rhododendron",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-rhododendron-of-fauriei.webp?v=3245582339563609491",
        "evolutionaryTrait": "Leathery evergreen leaves that can curl up like cigars during freezing weather to reduce moisture loss and survive the harsh taiga winter.",
        "funFact": "It is an incredibly rare relict species from the Tertiary period, surviving the Ice Ages in isolated mountain refuges!",
        "ecosystemRole": "Provides rare nectar in the early season and dense cover for small animals.",
        "diet": "Sunlight and acidic soil nutrients (Photosynthesis).",
        "size": "Shrub grows up to 10 feet tall.",
        "sound": "Silent."
      },
      {
        "id": "russian-bearberry",
        "name": "Russian Bearberry",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-russian-bearberry.webp?v=4505272956752241563",
        "evolutionaryTrait": "A low, trailing growth habit that keeps it insulated under the snowpack during the freezing winters.",
        "funFact": "As its name suggests, the bright red berries are heavily foraged by brown bears preparing for hibernation!",
        "ecosystemRole": "Prevents soil erosion and provides an essential late-season food source for wildlife.",
        "diet": "Sunlight and rocky soil nutrients (Photosynthesis).",
        "size": "Low groundcover, spreading over several feet.",
        "sound": "Silent."
      },
      {
        "id": "schlippenbachs-rhododendron",
        "name": "Royal Azalea (Schlippenbach’s)",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-schlippenbach-s-rhododendron-royal-azalea.webp?v=5725771397179053993",
        "evolutionaryTrait": "Massive, delicate pink flowers that bloom slightly before the leaves fully emerge to maximize pollinator visibility in the dense forest.",
        "funFact": "It is considered one of the most beautiful flowering shrubs in the world and turns a stunning yellow-orange in the autumn!",
        "ecosystemRole": "An early-season nectar source for insects emerging from hibernation.",
        "diet": "Sunlight and well-drained acidic soils (Photosynthesis).",
        "size": "Can grow to be a large shrub up to 15 feet tall.",
        "sound": "Silent."
      },
      {
        "id": "siberian-fir-cone",
        "name": "Siberian Fir",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-siberian-fir-cone.webp?v=7558668764233823529",
        "evolutionaryTrait": "The cones grow completely upright on the branches, unlike pinecones which hang down, allowing the wind to easily catch their winged seeds.",
        "funFact": "The tree produces essential oils so fragrant they are heavily used in aromatherapy for their fresh pine scent!",
        "ecosystemRole": "A dominant canopy tree that shapes the ecosystem, providing shelter for sables and flying squirrels.",
        "diet": "Sunlight and taiga soils (Photosynthesis).",
        "size": "Tree can reach up to 100 feet tall.",
        "sound": "Silent."
      },
      {
        "id": "wild-rosemary-daurian-rhododendron",
        "name": "Wild Rosemary / Daurian Rhododendron",
        "image": "//cleverfoxplay.com/cdn/shop/files/russian-wild-rosemary-daurian-rhododendron.webp?v=707630737891570737",
        "evolutionaryTrait": "Leaves contain aromatic essential oils that act as anti-freeze and deter herbivores from eating them.",
        "funFact": "When the sun hits a dense patch on a warm day, the evaporating oils make the whole forest smell strongly of sweet resin!",
        "ecosystemRole": "Forms dense understory thickets that support insect pollinators and provide safe nesting grounds.",
        "diet": "Sunlight and damp, acidic soils (Photosynthesis).",
        "size": "Grows up to 3 to 6 feet tall.",
        "sound": "Silent."
      }
    ]
  },
  {
    "id": "temperate-rainforest",
    "name": "Temperate Rainforest",
    "location": "Hoh Rainforest, Washington, USA",
    "description": "Mist-covered, ancient old-growth forests heavily draped in incredibly thick, bright green moss. A profoundly cool, perpetually wet paradise.",
    "heroImage": "//cleverfoxplay.com/cdn/shop/files/olympic-hoh-rainforest-hero-img.webp?v=14195759845137788233",
    "color": "bg-green-500",
    "facts": [
      {
        "title": "A Cathedral of Trees",
        "content": "The Hoh Rainforest contains some of the largest and oldest coniferous trees on Earth, like towering Sitka Spruces and ancient Douglas Firs.",
        "icon": "treePine"
      },
      {
        "title": "The Moisture Engine",
        "content": "Massive amounts of moisture blow in from the Pacific Ocean, dropping up to 14 feet of rain every year, supporting endless carpets of bright green moss.",
        "icon": "cloudRain"
      },
      {
        "title": "Nursing Logs",
        "content": "When massive trees fall, they slowly rot over centuries into 'nurse logs' – acting as nutrient-rich, mossy nurseries strictly providing life for the hundreds of new seedlings growing directly upon them.",
        "icon": "leaf"
      },
      {
        "title": "A Mossy Blanket",
        "content": "Mosses and epiphytes cover almost every surface, absorbing rain like a giant sponge and holding moisture throughout the dry summer months.",
        "icon": "droplet"
      }
    ],
    "animals": [
      {
        "id": "american-marten",
        "name": "American Marten",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-american-marten.webp?v=5907570678564899256",
        "evolutionaryTrait": "Semi-retractable claws allow them to agilely climb up and down massive ancient conifers in pursuit of prey.",
        "funFact": "They are incredibly acrobatic and can leap dynamically from tree to tree much like a squirrel.",
        "ecosystemRole": "Nimble arboreal mesopredator.",
        "diet": "Voles, squirrels, birds, and berries.",
        "size": "1.5 to 2 feet long.",
        "sound": "Chuckles, huffs, and sharp screams when alarmed."
      },
      {
        "id": "american-robin",
        "name": "American Robin",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-american-robin.webp?v=14918813277663202937",
        "evolutionaryTrait": "A specialized beak explicitly adapted to expertly pluck worms directly out of the damp, mossy forest floor.",
        "funFact": "Their cheerful song is famously considered one of the very first undeniable signs of spring in North America.",
        "ecosystemRole": "Abundant ground-foraging insectivore and seed disperser.",
        "diet": "Earthworms, insects, and berries.",
        "size": "About 9 to 11 inches long.",
        "sound": "A clear, melodic 'cheerily, cheer up, cheer up, cheerily, cheer up'."
      },
      {
        "id": "banana-slug",
        "name": "Banana Slug",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-banana-slug.webp?v=8518984928245623457",
        "evolutionaryTrait": "Produces incredibly thick slime that profoundly deters predators and explicitly helps maintain vital moisture in the damp forest.",
        "funFact": "They are amongst the largest terrestrial slugs on Earth, remarkably capable of growing up to 10 inches long.",
        "ecosystemRole": "Crucial decomposer that radically recycles forest nutrients.",
        "diet": "Detritus, mushrooms, dead leaves, and animal droppings.",
        "size": "6 to 10 inches long.",
        "sound": "Silent."
      },
      {
        "id": "barred-owl",
        "name": "Barred Owl",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-barred-owl.webp?v=8589503936184254192",
        "evolutionaryTrait": "Softly fringed flight feathers enable flawlessly silent flight to ambush prey entirely undetected in the dark canopy.",
        "funFact": "They are fiercely aggressive and have actually progressively displaced the native spotted owls across much of the Pacific Northwest.",
        "ecosystemRole": "Nocturnal apex predator of the dense forest.",
        "diet": "Small mammals, amphibians, and other birds.",
        "size": "17 to 20 inches tall.",
        "sound": "A loud, echoing 'Who cooks for you? Who cooks for you all?'"
      },
      {
        "id": "beaver",
        "name": "Beaver",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-beaver.webp?v=16565085967753246057",
        "evolutionaryTrait": "Self-sharpening, iron-rich orange teeth never stop growing, perfectly designed for relentlessly felling massive trees.",
        "funFact": "They have a specialized secondary set of inner lips that remarkably close behind their teeth so they can definitively chew underwater without drowning.",
        "ecosystemRole": "Unmatched ecosystem engineer creating vital wetland habitats.",
        "diet": "Tree bark, cambium, roots, and aquatic plants.",
        "size": "3 to 4 feet long, including the tail.",
        "sound": "Loud tail slaps on the water and soft whines."
      },
      {
        "id": "black-bear",
        "name": "Black Bear",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-black-bear.webp?v=7509696001216875254",
        "evolutionaryTrait": "Short, sharp, heavily curved claws make them exceptional climbers, enabling them to easily escape danger by scaling massive Douglas firs.",
        "funFact": "Despite being called 'black' bears, in the West they are very frequently brown, cinnamon, or even blonde in color.",
        "ecosystemRole": "Large opportunistic omnivore and major seed disperser.",
        "diet": "Berries, nuts, insects, salmon, and occasionally fawns.",
        "size": "250 to 400 pounds.",
        "sound": "Woofs, grunts, and loud jaw-popping when threatened."
      },
      {
        "id": "black-tailed-deer",
        "name": "Black-tailed Deer",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-black-tailed-deer.webp?v=13619721714966001494",
        "evolutionaryTrait": "Remarkably large ears act like sensitive satellite dishes to accurately detect the faint sounds of predators approaching through incredibly dense underbrush.",
        "funFact": "They are a distinct subspecies of the mule deer explicitly adapted to the dark, incredibly lush coastal rainforests of the Pacific Northwest.",
        "ecosystemRole": "Primary large herbivore shaping the understory vegetation.",
        "diet": "Leaves, twigs, lichens, and fresh green shoots.",
        "size": "About 3 feet tall at the shoulder.",
        "sound": "High-pitched bleats and alarm snorts."
      },
      {
        "id": "bobcat",
        "name": "Bobcat",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-bobcat.webp?v=11713499989623341039",
        "evolutionaryTrait": "A dramatically short 'bobbed' tail prevents it from getting violently snagged or grabbed in extremely thick, tangled brush.",
        "funFact": "They are incredibly solitary and fiercely territorial, vigorously marking their home ranges with distinct scent and prominent claw marks on trees.",
        "ecosystemRole": "Stealthy ambush mesopredator.",
        "diet": "Rabbits, rodents, birds, and occasionally small deer.",
        "size": "About twice the size of a domestic cat.",
        "sound": "Hisses, growls, and loud, eerie yowls during mating season."
      },
      {
        "id": "canada-gray-jay",
        "name": "Canada Jay",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-canada-gray-jay.webp?v=972837734551339596",
        "evolutionaryTrait": "Uses extremely sticky saliva to masterfully glue food caches high in the trees, effectively storing food for harsh, snowy winters.",
        "funFact": "They are notoriously incredibly bold and frequently referred to as 'camp robbers' for enthusiastically stealing food right out of people's hands.",
        "ecosystemRole": "Opportunistic omnivore and important seed dispenser.",
        "diet": "Insects, berries, seeds, and unguarded camp food.",
        "size": "About 10 to 12 inches long.",
        "sound": "Soft whistles, clucks, and complex chatters."
      },
      {
        "id": "douglas-squirrel",
        "name": "Douglas Squirrel",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-douglas-squirrel.webp?v=16731143508007716362",
        "evolutionaryTrait": "Extremely powerful, specialized jaws easily allow them to rapidly strip incredibly tough conifer cones to extract the nutritious seeds inside.",
        "funFact": "They are fiercely, incredibly territorial and will aggressively scold bears, cougars, or humans that blatantly invade their space.",
        "ecosystemRole": "Essential seed disperser and prey species.",
        "diet": "Conifer seeds, mushrooms, and berries.",
        "size": "About 12 to 14 inches long (including tail).",
        "sound": "Loud, rapid, aggressive chattering and trills."
      },
      {
        "id": "garter-snake",
        "name": "Garter Snake",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-garter-snake.webp?v=3812434046369504622",
        "evolutionaryTrait": "Remarkably possesses a minor immunity to the utterly deadly neurotoxin produced by their massive prey, the rough-skinned newt.",
        "funFact": "When forcibly handled, they will defensively release a remarkably foul-smelling musk to definitively deter predators.",
        "ecosystemRole": "Small terrestrial predator of amphibians.",
        "diet": "Slugs, earthworms, frogs, toads, and newts.",
        "size": "2 to 3 feet long.",
        "sound": "Silent."
      },
      {
        "id": "great-horned-owl",
        "name": "Great Horned Owl",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-great-horned-owl.webp?v=876427403495596071",
        "evolutionaryTrait": "Incredibly massive, phenomenally powerful talons require an astonishing 28 pounds of force to accurately open, instantly crushing their prey.",
        "funFact": "They frequently and aggressively take over the large nests of other raptors instead of bothering to build their own.",
        "ecosystemRole": "Incredibly fierce avian apex predator.",
        "diet": "Rabbits, rodents, skunks, and even other owls.",
        "size": "18 to 25 inches tall.",
        "sound": "A deep, stuttering series of hoots: 'hoo-h'HOO-hoo-hoo'."
      },
      {
        "id": "mink",
        "name": "Mink",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-mink.webp?v=8684291577461661894",
        "evolutionaryTrait": "Distinctively partially webbed toes and water-resistant fur make them surprisingly exceptional swimmers and vicious aquatic hunters.",
        "funFact": "They are remarkably vicious for their size and fearlessly willing to take down prey significantly larger than themselves.",
        "ecosystemRole": "Fierce semi-aquatic predator.",
        "diet": "Fish, frogs, crayfish, and small mammals.",
        "size": "18 to 24 inches long.",
        "sound": "High-pitched squeals and aggressive hisses."
      },
      {
        "id": "northern-flying-squirrel",
        "name": "Northern Flying Squirrel",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-northern-flying-squirrel.webp?v=6744876757780360357",
        "evolutionaryTrait": "A heavily furred, specialized skin flap gracefully stretches from wrist to ankle, enabling them to brilliantly glide between massive canopy trees.",
        "funFact": "They do not actually fly; instead, they flawlessly glide, using their distinctly flat tail as a remarkably effective rudder.",
        "ecosystemRole": "Nocturnal arboreal prey base for owls.",
        "diet": "Fungi, lichens, nuts, and tree sap.",
        "size": "10 to 12 inches long.",
        "sound": "Soft, high-pitched chirps and chatters."
      },
      {
        "id": "northern-spotted-owl",
        "name": "Northern Spotted Owl",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-northern-spotted-owl.webp?v=16977501503733870917",
        "evolutionaryTrait": "Mottled brown and white feathers flawlessly match the dappled light filtering through the dense, towering canopy of ancient old-growth forests.",
        "funFact": "They absolutely require massive, incredibly old trees with natural hollow cavities in order to successfully raise their chicks.",
        "ecosystemRole": "Crucial indicator species defining the health of old-growth forests.",
        "diet": "Flying squirrels, woodrats, and mice.",
        "size": "16 to 19 inches tall.",
        "sound": "A high, hollow 'whoop... whoop-whoop... whoop'."
      },
      {
        "id": "olympic-marmot",
        "name": "Olympic Marmot",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-olympic-marmot.webp?v=5476390677382651176",
        "evolutionaryTrait": "Exceptionally thick fur and heavy fat reserves enable them to powerfully survive over 8 months of deep hibernation under massive snowpack.",
        "funFact": "They are completely endemic to the Olympic Peninsula; they simply do not exist anywhere else in the entire world.",
        "ecosystemRole": "Alpine herbivore and significant prey source.",
        "diet": "Grasses, sedges, lupines, and wildflowers.",
        "size": "About the size of a large house cat, up to 15 pounds.",
        "sound": "Very loud, sharp, piercing alarm whistles."
      },
      {
        "id": "olympic-torrent-salamander",
        "name": "Olympic Torrent Salamander",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-olympic-torrent-salamander.webp?v=5699568600144685876",
        "evolutionaryTrait": "Tremendously reduced lungs profoundly force them to rely on extremely cold, incredibly well-oxygenated rushing streams to breathe through their porous skin.",
        "funFact": "They are exceptionally uniquely adapted to absolute frigid water and will completely overheat incredibly quickly if the water heavily warms up.",
        "ecosystemRole": "Specialized aquatic insect predator.",
        "diet": "Aquatic insects and tiny invertebrates.",
        "size": "About 3.5 to 4 inches long.",
        "sound": "Silent."
      },
      {
        "id": "pacific-giant-salamander",
        "name": "Pacific Giant Salamander",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-pacific-giant-salamander.webp?v=893879132992824850",
        "evolutionaryTrait": "A phenomenally massive, heavily muscular body structure explicitly enables them to aggressively hunt surprisingly large prey like mice and snakes.",
        "funFact": "It is one of the only salamanders in the entire world completely capable of actively vocalizing, producing a distinctly loud, barking cry.",
        "ecosystemRole": "Massive aquatic and terrestrial amphibious predator.",
        "diet": "Insects, frogs, smaller salamanders, and mice.",
        "size": "Up to remarkably 12 inches long.",
        "sound": "A harsh, surprising bark when threatened."
      },
      {
        "id": "pacific-jumping-mouse",
        "name": "Pacific Jumping Mouse",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-pacific-jumping-mouse.webp?v=6857477948074399591",
        "evolutionaryTrait": "Exceptionally long, incredibly powerful hind legs paired with an outrageously long tail allow them to bound astonishing distances.",
        "funFact": "When genuinely frightened, they can rapidly leap an incredible 6 feet in a single magnificent bound to successfully escape.",
        "ecosystemRole": "Key nocturnal prey for small predators.",
        "diet": "Seeds, fungus, and small insects.",
        "size": "About 9 to 10 inches long (mostly tail).",
        "sound": "Soft, high-pitched squeaks."
      },
      {
        "id": "pacific-tree-frog",
        "name": "Pacific Tree Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-pacific-tree-frog.webp?v=16970823102805608237",
        "evolutionaryTrait": "Specialized, highly sticky toe pads fundamentally allow them to profoundly cling to completely smooth, wet leaves high vertically up in the canopy.",
        "funFact": "Despite their surprisingly tiny size, their incredibly loud 'ribbit' is the iconic sound fundamentally used for frogs in almost all Hollywood movies.",
        "ecosystemRole": "Crucial mid-level amphibious predator.",
        "diet": "Spiders, beetles, flies, and ants.",
        "size": "Only 1 to 2 inches long.",
        "sound": "A very loud, harsh 'kreck-ek' or 'ribbit'."
      },
      {
        "id": "raccoon",
        "name": "Raccoon",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-raccoon.webp?v=4572245313452736769",
        "evolutionaryTrait": "Extremely dexterous, highly sensitive front paws flawlessly lack webbing, fundamentally allowing them to easily manipulate objects precisely like tiny hands.",
        "funFact": "They have a uniquely bizarre habit of distinctly 'washing' their food in water simply to dramatically increase the tactile sensitivity of their paws.",
        "ecosystemRole": "Highly adaptable, profoundly opportunistic omnivore.",
        "diet": "Fruit, insects, small rodents, and human garbage.",
        "size": "2 to 3 feet long.",
        "sound": "Chitters, purrs, growls, and loud screeches."
      },
      {
        "id": "red-breasted-sapsucker",
        "name": "Red-breasted Sapsucker",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-red-breasted-sapsucker.webp?v=12428513020732243732",
        "evolutionaryTrait": "A distinct brush-like tongue flawlessly designed specifically to masterfully collect the sweet, sticky sap it causes to aggressively flow from tree wells.",
        "funFact": "The incredibly neat, organized rows of tiny holes they relentlessly drill fundamentally provide vital food for dozens of other forest species.",
        "ecosystemRole": "Vital keystone species heavily providing sweet sap to the forest.",
        "diet": "Tree sap, ants, and beetles.",
        "size": "About 8.5 inches long.",
        "sound": "A squeaky, nasal 'mew' or 'waa'."
      },
      {
        "id": "red-crossbill",
        "name": "Red Crossbill",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-red-crossbill.webp?v=14389354797248044702",
        "evolutionaryTrait": "An outrageously bizarre, heavily crossed beak perfectly engineered simply to masterfully pry apart the incredibly tough scales of massive pine cones.",
        "funFact": "Their beak shapes fundamentally vary so drastically based precisely on the specific local pine cones they eat that they essentially have different local dialects.",
        "ecosystemRole": "Highly specialized conifer seed predator.",
        "diet": "Exclusively seeds extracted from conifer cones.",
        "size": "About 6 inches long.",
        "sound": "A sharp, clicking 'jip-jip-jip' in flight."
      },
      {
        "id": "red-legged-frog",
        "name": "Red-legged Frog",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-red-legged-frog.webp?v=11273778051150020692",
        "evolutionaryTrait": "Vibrant, intensely red undersides on their legs are forcefully flashed simply to violently startle predators when they suddenly jump.",
        "funFact": "They critically require large, incredibly shaded, intensely cool ponds intimately surrounded by thick vegetation to effectively breed.",
        "ecosystemRole": "Important amphibious predator and prey species.",
        "diet": "Insects, worms, and small invertebrates.",
        "size": "3 to 5 inches long.",
        "sound": "A very low, stuttering, guttural croak."
      },
      {
        "id": "river-otter",
        "name": "River Otter",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-river-otter.webp?v=16055371371194946602",
        "evolutionaryTrait": "A remarkably long, heavily muscular tail profoundly acts purely as a highly effective rudder for extremely agile maneuverability deeply underwater.",
        "funFact": "They constantly thoroughly groom their incredibly dense fur exclusively to trap a critical layer of air fundamentally needed for heavy insulation.",
        "ecosystemRole": "Dominant aquatic predator.",
        "diet": "Fish, crayfish, amphibians, and occasionally ducks.",
        "size": "3 to 4.5 feet long.",
        "sound": "Chirps, chuckles, and sharp alarm snorts."
      },
      {
        "id": "roosevelt-elk",
        "name": "Roosevelt Elk",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-roosevelt-elk.webp?v=15494333438862789959",
        "evolutionaryTrait": "Phenomenally massive body size and incredibly heavy, powerful antlers successfully combat the dense, incredibly rugged terrain of the vast coastal rainforests.",
        "funFact": "They are definitively the absolute largest of all of the North American elk subspecies, with males genuinely weighing up to 1,100 pounds.",
        "ecosystemRole": "Massive dominant herbivore drastically shaping the forest floor.",
        "diet": "Ferns, lichens, grasses, and woody shrubs.",
        "size": "Up to 5.5 feet tall exactly at the shoulder.",
        "sound": "Extremely loud, high-pitched, echoing bugling calls."
      },
      {
        "id": "rough-skinned-newt",
        "name": "Rough-skinned Newt",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-rough-skinned-newt.webp?v=5204273490628720193",
        "evolutionaryTrait": "Actively secretes tetrodotoxin, an incredibly potent, deadly neurotoxin strictly to successfully avoid being eaten by predators.",
        "funFact": "When violently threatened, they arch their backs significantly to prominently display their bright, glaring orange bellies as a massive warning.",
        "ecosystemRole": "Heavily toxic terrestrial and profoundly aquatic amphibian.",
        "diet": "Insects, earthworms, and small slugs.",
        "size": "5 to 8 inches long.",
        "sound": "Silent."
      },
      {
        "id": "townsends-chipmunk",
        "name": "Townsend’s Chipmunk",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-townsend-s-chipmunk.webp?v=3725713343366659378",
        "evolutionaryTrait": "A distinctly deeper, significantly darker brown coat than other chipmunks flawlessly provides amazing camouflage absolutely within the heavily shadowed old-growth forest.",
        "funFact": "They uniquely play incredibly vital roles specifically in extensively spreading essential fungal spores strictly needed for very healthy tree roots.",
        "ecosystemRole": "Extremely active diurnal seed and fungal disperser.",
        "diet": "Seeds, nuts, berries, and extensively subterranean fungi.",
        "size": "About 9 to 11 inches long.",
        "sound": "Rapid, highly pitched, very sharp chipping sounds."
      },
      {
        "id": "pacific-tree-vole",
        "name": "Townsend’s Vole",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-pacific-tree-vole.webp?v=10530782234759906480",
        "evolutionaryTrait": "Remarkably large size specifically for a vole distinctly allows it to easily dominate massive, deeply thick grassy clearings right near the forest edge.",
        "funFact": "They meticulously construct absolutely extensive, heavily complex trail networks precisely through the profoundly thick grass, explicitly hiding perfectly from predators above.",
        "ecosystemRole": "Crucial primary prey species simply for almost every predator.",
        "diet": "Grasses, sedges, and roots.",
        "size": "About 6 to 9 inches long.",
        "sound": "Extremely soft, high-pitched squeaks."
      },
      {
        "id": "varied-thrush",
        "name": "Varied Thrush",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-varied-thrush.webp?v=13498126605639824617",
        "evolutionaryTrait": "A distinctly striking, brightly orange breast heavily contrasted purely with a dark blue-grey back seamlessly blends surprisingly well fundamentally in dappled rainforest light.",
        "funFact": "Their incredibly eerie, distinctly long whistle song fundamentally heavily characterizes exactly the incredibly dark, deeply wet coastal forests strictly during winter.",
        "ecosystemRole": "Abundant forest floor forager and crucial seed disperser.",
        "diet": "Insects strictly in summer, entirely berries precisely in winter.",
        "size": "About 9 to 10 inches long.",
        "sound": "A highly eerie, distinctly prolonged, single-pitch whistle."
      },
      {
        "id": "winter-wren",
        "name": "Winter Wren",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-winter-wren.webp?v=4842874254523795129",
        "evolutionaryTrait": "Outrageously incredibly tiny size perfectly allows them to enthusiastically squeeze intensely deep deeply into massively tangled root wads merely to vigorously hunt completely hidden insects.",
        "funFact": "Despite being absolutely one of the genuinely smallest birds intimately in the forest, they possess an explicitly incredibly loud, massively complex, highly bubbly song.",
        "ecosystemRole": "Extremely hyperactive understory insectivore.",
        "diet": "Spiders, bark beetles, and profoundly tiny insects.",
        "size": "Only 3.5 to 4.5 inches long.",
        "sound": "An exceptionally long, incredibly rapid, heavily bubbling trill."
      },
      {
        "id": "woodpecker",
        "name": "Woodpecker",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-woodpecker.webp?v=122928786851938607",
        "evolutionaryTrait": "Incredibly thick, extremely sturdy skulls fundamentally act precisely as heavy shock absorbers, actively preventing devastating brain damage explicitly from profoundly rapid, massive drumming.",
        "funFact": "They effectively uniquely possess incredibly long, heavily barbed tongues exactly to expertly extract completely hidden insects right out of their deeply drilled wooden cavities.",
        "ecosystemRole": "Vital primary cavity completely creating ecosystem engineer.",
        "diet": "Wood-boring beetles, completely hidden ants, and sap.",
        "size": "Varies significantly thoroughly by specifically exact species.",
        "sound": "Loud, highly rhythmic specifically drumming immediately against hollow trees."
      },
      {
        "id": "blue-darner-dragonfly",
        "name": "Blue Darner Dragonfly",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-blue-darner-dragonfly.webp?v=15419923263384349532",
        "evolutionaryTrait": "Incredibly agile flight capabilities allows them to hunt mosquitoes seamlessly in mid-air.",
        "funFact": "They can fly backwards and hover completely still like tiny helicopters!",
        "ecosystemRole": "Crucial predator of small flying insects, keeping mosquito populations in check.",
        "diet": "Mosquitoes, flies, and other small insects.",
        "size": "Wingspan up to 3 inches.",
        "sound": "A soft buzzing of wings."
      },
      {
        "id": "cedar",
        "name": "Western Red Cedar",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-cedar.webp?v=7903327179472930550",
        "evolutionaryTrait": "Produces natural fungicides (thujaplicins) that prevent the tree from rotting in the incredibly damp rainforest environment.",
        "funFact": "It's known as the 'Tree of Life' to indigenous peoples, who used it for everything from canoes to clothing!",
        "ecosystemRole": "A massive, long-lived canopy species whose decaying logs provide nutrients and structure for the entire forest.",
        "diet": "Sunlight and abundant water (Photosynthesis).",
        "size": "Can grow over 200 feet tall.",
        "sound": "Silent."
      },
      {
        "id": "fairy-slipper-orchid-calypso",
        "name": "Fairy Slipper Orchid",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-fairy-slipper-orchid-calypso.webp?v=17636564565111163198",
        "evolutionaryTrait": "A tricky plant that produces a beautiful, sweet-smelling flower but absolutely no nectar to reward its pollinators.",
        "funFact": "Bumblebees visit the flower expecting a sweet meal, give up after finding nothing, but still transport its pollen to another flower!",
        "ecosystemRole": "Early spring bloomer that takes advantage of the brief window of sunlight before the forest canopy fully leafs out.",
        "diet": "Sunlight and a symbiotic relationship with soil fungi (Photosynthesis).",
        "size": "Only up to 8 inches tall.",
        "sound": "Silent."
      },
      {
        "id": "fly-agaric",
        "name": "Fly Agaric (Amanita)",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-fly-agaric.webp?v=6720418048381638468",
        "evolutionaryTrait": "Bright red cap with white spots to warn animals that it is highly toxic and hallucinogenic.",
        "funFact": "It's the classic 'toadstool' mushroom seen in fairy tales and video games like Super Mario!",
        "ecosystemRole": "Forms a crucial mutually beneficial (mycorrhizal) relationship with the roots of conifers, helping them absorb nutrients.",
        "diet": "Absorbs nutrients from decaying organic matter and through its tree root partners.",
        "size": "Caps can reach 8 inches across.",
        "sound": "Silent."
      },
      {
        "id": "golden-chanterelle",
        "name": "Golden Chanterelle",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-golden-chanterelle.webp?v=15658180796009035917",
        "evolutionaryTrait": "Grows 'false gills'—thick ridges instead of delicate blades—which help it shed the constant rainforest drip.",
        "funFact": "They smell faintly of apricots and are one of the most highly prized culinary mushrooms in the world!",
        "ecosystemRole": "Forms symbiotic relationships with tree roots, trading minerals for the tree's sugars.",
        "diet": "Absorbs nutrients via its symbiotic relationship with living trees.",
        "size": "Typically 2 to 5 inches wide.",
        "sound": "Silent."
      },
      {
        "id": "red-huckleberry",
        "name": "Red Huckleberry",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-red-huckleberry.webp?v=7014861641170922826",
        "evolutionaryTrait": "Thrives on the decaying wood of 'nurse logs', drawing essential nutrients from the rotting stumps where soil is too competitive.",
        "funFact": "Their branches are distinctively angled and are bright green, allowing them to photosynthesize even without leaves!",
        "ecosystemRole": "Crucial late-summer food source for black bears, birds, and small mammals.",
        "diet": "Sunlight and the rich nutrients of decaying nurse logs (Photosynthesis).",
        "size": "Shrub grows 3 to 13 feet tall.",
        "sound": "Silent."
      },
      {
        "id": "salmonberry",
        "name": "Salmonberry",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-salmonberry.webp?v=12458412551383116852",
        "evolutionaryTrait": "One of the earliest blooming shrubs in the rainforest; its bright pink flowers are timed to the arrival of migrating hummingbirds.",
        "funFact": "The berries look exactly like large, yellow-orange raspberries and are said to resemble bright salmon roe (eggs)!",
        "ecosystemRole": "Creates dense thickets along streams that provide cover for nesting birds and early nectar for Rufous hummingbirds.",
        "diet": "Sunlight and damp soil (Photosynthesis).",
        "size": "Grows up to 10 feet tall.",
        "sound": "Silent."
      },
      {
        "id": "sitka-spruce",
        "name": "Sitka Spruce",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-sitka-spruce.webp?v=8901018311666767212",
        "evolutionaryTrait": "Develops an incredibly wide, shallow root system to stay upright in the soggy, unstable soil and strong coastal winds.",
        "funFact": "It is the largest species of spruce in the world, and its wood has incredible acoustic properties used to make guitars and pianos!",
        "ecosystemRole": "The dominant climax species of the coastal temperate rainforest, defining the entire structure of the ecosystem.",
        "diet": "Sunlight and coastal moisture (Photosynthesis).",
        "size": "Can exceed 300 feet in height.",
        "sound": "Silent."
      },
      {
        "id": "skunk-cabbage",
        "name": "Skunk Cabbage",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-skunk-cabbage.webp?v=3946988081119639811",
        "evolutionaryTrait": "Can dramatically generate its own heat (thermogenesis) to melt snow and release its foul odor to attract early-season pollinating flies.",
        "funFact": "It gets its name from its very strong, musky smell—which humans hate, but scavenging flies absolutely love!",
        "ecosystemRole": "One of the first plants to bloom in early spring, providing food for black bears waking from hibernation.",
        "diet": "Sunlight and mucky wetland soil (Photosynthesis).",
        "size": "Leaves can grow over 3 feet long.",
        "sound": "Silent."
      },
      {
        "id": "sword-fern",
        "name": "Western Sword Fern",
        "image": "//cleverfoxplay.com/cdn/shop/files/olympic-sword-fern.webp?v=9964857498470205488",
        "evolutionaryTrait": "Tough, evergreen fronds with serrated edges that remain green year-round, capturing whatever scarce light pierces the dark winter canopy.",
        "funFact": "The spores on the underside of their leaves look like neat rows of tiny brown dots!",
        "ecosystemRole": "Dominates the forest floor, providing essential shelter for amphibians, insects, and small rodents.",
        "diet": "Sunlight and damp forest soil (Photosynthesis).",
        "size": "Fronds can reach 4 to 6 feet long.",
        "sound": "Silent."
      }
    ]
  }
];

window.CFP_A4_EDITION_META = {
  "counts": {
    "distinctEntryIds": 577,
    "scenes": 16,
    "selectableMemberships": 589
  },
  "editionId": "cfp-animal-habitats-a4",
  "editionLabel": "A4 Production Edition",
  "membershipSha256": "7c0eecdf18a272b86c9790f180e0f9fa520329ab75b6c2c113ca8a4baa31fbc3",
  "orderedSceneIds": [
    "alpine",
    "arctic",
    "outback",
    "cloud-forest",
    "coral-reef",
    "deep-sea",
    "fynbos",
    "galapagos",
    "kelp-forest",
    "madagascar",
    "mangrove",
    "namib",
    "pantanal",
    "savanna",
    "taiga",
    "temperate-rainforest"
  ],
  "schemaVersion": "1.0.0"
};
